import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);  

const messages = {

	'en': { 
		//=============================messages================================================
		noTradingCreateNewOne : 'No Trading Account Yet, Create a New Account',
		faMszOtp1 : 'or use can also use 2fa OTP but you should enable first by click on the link given below',
		RESEND_EMAIL : 'Resend Email',
		TECH_ERROR : "We are facing some issues , Kindly try after some time",
		VALIDATION_ERROR : 'validation error',
		INVALID_TRADING_ACC : 'invalid trading account error',
		INVALID_WITHDRAWAL_TRANSACTION : 'invalid withdrawal transaction',
		INVALID_OTP : 'invalid OTP',
		FILE_UPLOAD : 'Only jpg, jpeg, png, pdf files are allowed!',
		OTP_EXPIRED : 'OTP expired',
		OTP_IP_MISMATCH : 'OTP is not match',
		LOW_BALANCE_THEN_AMOUNT : 'The amount that you have entered is higher than the Free Margin available.',				
		TICKET_EXIST : 'ticket already exists',
		EMAIL_EXIST : 'email is already exists',
		MOBILE_EXIST : 'mobile number is already exists',
		LOW_BONUS_THEN_AMOUNT : 'amount that you have filled is low then your bonus',
		INVALID_ACCOUNT_TRANSACTION : 'invalid account transaction',
		INVALID_TICKET_TRANSACTION : 'invalid ticket transaction',
		DEPOSIT_LIMIT : 'deposit limit',
		AMOUNT_GREATER_THEN_ALLOWED : 'The amount that you have entered is higher then the allowed.',
		fund_msz : 'deposit successfully',
		suceessMsz1 : '2FA Enabled successfully',
		suceessMsz2 :'2FA Disabled successfully',
		suceessMsz3 : 'A link for change password has been sent on your registered email id',
		suceessMsz4 :'password changed successfully',
		suceessMsz5 :'OTP resend successfully',
		suceessMsz6 :'OTP is sent on your register email and mobile number',
		suceessMsz7 :'Now you are eligible to open live account',
		suceessMsz8 :'please upload your document within 15 days',
		suceessMsz9 :"add name successfully",
		suceessMsz10 :'link has been sent your registered email id', 
		suceessMsz11 :'plan unsubscribe successfully',
		suceessMsz12 :'service restart successfully',
		suceessMsz13 : 'service reboot successfully',
		suceessMsz14 : 'service shutdown successfully',
		suceessMsz15 : 'service password changed successfully',
		suceessMsz16 : 'A link has been sent to your registered email address',
		suceessMsz17 : 'deposit successfully',
		suceessMsz18 : 'OTP resend successfully',
		suceessMsz19 : 'add bank successfully',
		suceessMsz20 : 'ticket has been created successfully and please wait for 2-3 working days',
		suceessMsz21 : 'At this moment we are allowing 1,00,000,00 only. In case you want to deposit more than this kindly contact support',
		suceessMsz22 : 'you are not allowed to enter amount greater then or equal to deposit limit - , because you are not verified yet and ur document is still under verification so you cannot deposit more then2000 EUR',
		suceessMsz23 : 'Invalid Amount',
		suceessMsz24 : 'Your account is not verified',	
		suceessMsz25 : 'account id should be different from another account id you selected	',	
		suceessMsz26 : 'atleast select 2 options',
		suceessMsz27 : 'new password is not same as confirm new password',
		suceessMsz28 : 'Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',
		suceessMsz29 : '',
		errorMsz1 : "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!",
		termsAgreeRqd: "Please agree terms in order to proceed",
		googleOtp : "Please enter the one time passcode shown in the <strong>Google Authenticator</strong> app.",
		enterAmount : 'Enter Amount',
		allowDeposit1lac : 'we are not allowing deposit more then 1,00,000 for demo account',
		SearchSomething : "Search Here",
		
		//====================users====================================
		//============login page
		lg_riskWarningMsg :'CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading in CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		lg_welcomeMsgHeadone :'Competitive Trading Conditions',
		lg_welcomeMsg1 :'Benefit from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.',
		lg_welcomeMsgHeadtwo :'Our Platforms',
		lg_welcomeMsg2 :"Access the world's most popular markets on our fast and reliable platforms - MT4, MT5 & ActTrader",
		lg_welcomeMsgHeadthree :'Trading Tools',
		lg_welcomeMsg3 :"Access a wide range of trading tools such as Autochartist, Trader’s Tool Box, API trading and more",
		lg_signin :'Log in to Fxview',
		lg_emailaddress :'Email Address',
		lg_EmailfieldValid :'Please enter a valid email address',
		lg_EmailfieldReq :'The Email field is required',
		lg_password : 'Password',
		lg_logIn :'Sign In',
		lg_forgotPassword :'Forgot Password',
		lg_donthaveaccount :'Don’t have an account?',
		lg_signuphere :'Sign up here',
		lg_charlgateMsGlobal : 'Charlgate SVG LLC is registered in St. Vincent and Grenadines, with registration number 1112 LLC 2021.',
		lg_charlgateMsEurope :'Charlgate Ltd is authorised and regulated by CySEC, with licence number 367/18 & company registration number 372060.',
		lg_varify2step :'Two-step Verification',
		lg_EnterAuthCode :'Enter Authentication Code',
		lg_submit :'Submit',
		lg_backLogin :'Back to log in page',
		lg_footerMsz2 :'Your capital is at risk. You may lose all the capital invested.',
		lg_riskDisclaimer :'Risk Disclaimer',

		//============forgot password
		fp_forgotPasswordText :'Please enter your registered email address with fxview so we can help you create a new password.',
		fp_resetPassword :'Reset Password',
		fp_RESEND_EMAIL :'Resend Email',
		fp_backLogin :'Back to log in page',
		fp_charlgateMsg :'Charlgate Ltd owns fxview.com.  Charlgate Ltd is a company authorised and regulated by the Cyprus Securities and Exchange Commission – CySEC (CySEC Licence number 367/18 & company registration number : 372060 ) and a Member of the Investor Compensation Fund (ICF).',

		//=============register
		reg_welcomemsg1 : 'Spreads from 0.0 pip',
		reg_welcomemsg2 : '$1 per $100K Commission',
		reg_welcomemsg3 :'A Variety of Trading Tools',
		reg_welcomemsg4 :'Ultra Fast Execution',
		reg_welcomemsg5 :'100% Deposit Bonus',
		reg_openacc :'Open An Account',
		reg_takeminute:'It will take less than a minute',
		reg_selectacctype : 'select account type',
		reg_selectcountry :'select residence country',
		reg_Enteremail : 'Enter Email Address',
		reg_Enterpwd :'Enter Password',
		reg_passwordFieldReq :'The New Password field is required',
		reg_passCharVal :'Your New Password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*)',
		reg_conPassword :'Confirm Password',
		reg_ConfpasswordReq :'The Confirm Password field is required.',
		reg_newConfFieldSame :'The entered passwords do not match. Please try again',
		reg_captchaErr :'Invalid Captcha',
		reg_register:'Register',
		reg_signagree:'By signing up you agree to our',
		reg_privacyPolicy :' Privacy Policy',
		reg_haveAccount:'Have an account?',
		reg_login :'Log in',
		reg_registerMsz2 :'One-Time Pin has been sent to your email. Please enter it below.',
		reg_enterOtp :'Enter OTP',
		reg_submit :'Submit',
		reg_resendotp :'Resend OTP',

		//==========reset password from hash
		rp_passwordHashMsz2 :'Password has been changed successfully. Click',
		rp_here :'Here',
		rp_toLogin :'to log in',
		rp_otherWayHelp:'Other ways to get help',
		rp_chatWithUs :'Chat with us',
		rp_or :'or',
		rp_callUs :'Call us',

		//=============profile 
		prof_verified :'Verified',
		prof_undrreview : 'Your application is under review!',
		prof_checkstatus : 'Please check the status of your ticket',
		prof_clickhere :'Click Here',
		prof_completeRegister :'Complete Registration',
		prof_basicDetail :'Basic Info',
		prof_addressDetail :'Address Info',
		prof_paymentDetail :'Payment Details',
		prof_documents :'Documents',
		prof_fname :'First Name',
		prof_lname :'Last Name',
		prof_DOB :'Date of birth',
		prof_phone :'Phone',
		prof_Member :'Member',
		prof_companyname :'Company Name',
		prof_incorporationdate :'Incorporation date',
		prof_currency :'Currency',
		prof_emailaddress :'Email Address',
		prof_PEP:'Politically Exposed Person (PEP)',
		prof_addressLine1 :'Residential Address line 1',
		prof_addressLine2 :'Residential Address line 2',
		prof_postCode :'Post Code',
		prof_city :'City or Town',
		prof_resCountry :'Country of Residence',
		prof_bankName :'Bank Name:',
		prof_AccNumber :'Account Number:',
		prof_Pending :'Pending',
		prof_Disable :'Disable',
		prof_viewDetail :'view detail',
		prof_paymentMethod :'Deposit Method',
		prof_AccountName :'Account Name',
		prof_SwiftCode : 'Swift/BIC/Sort Code',
		prof_IBAN :'IBAN',
		prof_bankAdd :'Bank Address:',
		prof_onlinePayId :'Online Payment ID:',
		prof_Change :'Change',
		prof_CreditCard :'Credit Card Number:',
		prof_ExpiryDate :'Expiry Date:',
		prof_noBankDetail :'No Bank Details',
		prof_AddBank :'Add Bank',
		prof_AddCard :'Add Credit card',
		prof_noDocuments :'No Documents',
		prof_disablecard :'kindly disable my credit card payment method, information as given below :',
		prof_creditcardno :'credit card number : **** **** ****',
		prof_bankpaymentmethod :'kindly disable my bank transfer payment method, information as given below :',
		prof_diablepaymentmethod :'Disable Payment Method',
		prof_addpeymentmethod :'Add Payment Method',

		//=================2fa 
		twoFA_faText :'Two-Factor Authentication',
		twoFA_alreadyEnabled :'Enabled',
		twoFA_setUp2FA :'Set up 2FA',
		twoFA_clickToDisable :'Click To Disable',
		twoFA_clickToEnable :'Click To Enable',
		twoFA_enable2FaText :'Enable Two-Factor Authentication',
		twoFA_accounntSafe3Steps :'Make Your Account safer in 3 easy steps:',
		twoFA_downloaduthApp :'Download an Authenticator App',
		twoFA_downloaduthAppText :'Download and install Authy or Google Authenticator to your phone or tablet.',
		twoFA_scanQrCode :'Scan The QR Code',
		twoFA_scanQrCodeText :"Open the authentication app and scan the image to the left, using your phone's camera.",
		twoFA_loginYourCode :'Log in with your Code',
		twoFA_enter6DigitCode :'Enter the 6-digit verification code generated.',
		twoFA_activate :'Activate',
		twoFA_enterOtpDisableQrCode :'Please Enter OTP to Disable QR Code',
		twoFA_disableCodeText :'Disable With your Code',
		//===========change password
		cp_changePassword :'Change Password',
		cp_oldpwd :'Old Password',
		cp_newPassword :'New Password',
		cp_conPassword :'Confirm password',
		cp_passCharval :'Your password must contain at least 6 characters, maximum 15 characters and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',

		//========welcome
		welcm_fewStepAway :'You are just few steps away',
		welcm_activateFxviewAccountNow :'Activate Your Fxview Account Now!',
		welcm_setupFxViewAcc :'Setup your fxview account',
		welcm_modify :'Modify',
		welcm_addFund :'Add Funds',
		welcm_startTrading :'Start Trading',
		welcm_welcomeFxView :'Welcome to Fxview!',
		welcm_welFxviewCon :'You are almost ready to begin trading. Please complete your trading account application and upload the necessary identification documents.',
		welcm_completeReg :'Complete Registration',
		welcm_tryDemoAcc :'Try a Demo Account',
		welcm_tryDemoAccCon :'Try our trading platforms - MT4, MT5 and ActTrader - and develop your CFD trading skills. Practice trading with virtual funds',
		welcm_createDemoAccount :'Demo Account',
		welcm_downloadPlatform :'Download Platform',
		welcm_MT4 :'Meta Trader 4',
		welcm_winIosAndroid :'Windows/IOS/Android',
		welcm_MT5 :'Meta Trader 5',
		welcm_actTrader :'ActTrader<sup>TM</sup>',
		welcm_rangeTradTools :'Range of Trading Tools',
		welcm_wlcmMsz1 :'Identify automatically generated trade ideas based on chart patterns, breakouts, trend reversals, Fibonacci patterns and technical indicators.',
		welcm_wlcmMsz2 :'Explore a wide range of actionable trade ideas recognised on the basis of multiple chart patterns and technical indicators across various assets class.',
		welcm_wlcmMsz3 :'Stay a step ahead with real time financial news and updates on geo-political events to make informed trading decisions.',
		welcm_wlcmMsz4 :'Stay up to date with real time Economic calendar that encompasses key global economic events and indicators on the horizon.',
		welcm_wlcmMsz5 :'Get an unmatched trading experience via suitable VPS hosting program that allows you to trade uninterruptedly with reduced latency.',
		welcm_SeeMore :'See More',

		//========user notification
		notif_Notification :'Notification',
		notif_noNewNotification :'No New Notifications',

		//=========request-verify
		verf_reqProcessing :'request processing...',
		verf_reqVerify :'Request Verification',
		verf_dear :'Dear',
		verf_requestVerifyWith :'Your withdrawal request has been processed successfully',
		verf_backWithList :'Back To Withdrawals List',
		verf_reqFailed :'Request Failed',
		verf_msg :'Your withdrawal request has been failed',
		//============refer a friend 
		refer_Refera :'Refer a ',
		refer_friend :'Friend',
		refer_opportunity:'Our refer a friend program gives you an opportunity to earn $20 for every friend  you refer. What’s more, your friend will also be rewarded $20 when they sign up with your invitation email.',
		refer_Refernow :'Refer Now',
		refer_howorks :'How it Works',
		refer_everyclient :'For every client you refer, we will reward you with $20. Share your favourite things about fxview with your friends and enjoy additional trading margin, on us.',
		refer_stepmsg1 :'Register or log in to your fxview account',
		refer_stepmsg2 :'Invite your friend using the form in the client area',
		refer_stepmsg3 :'Your friend will receive an email invite and will follow the steps to register',
		refer_stepmsg4 :'Both you and your friend will receive $20 once your friend funds their account with $200 or more',
		refer_referEmail :'Referred Email',
		refer_addmore :'Add more',
		refer_nowrefer :'refer now',
		refer_successRefer :'You have Successfully Referred',
		refer_refrMore :'Refer More',
		refer_godashboard :'Go to Dashboard',
		refer_partnerprog :'Our other partnership program',
		refer_Affilialte :'Affiliate Program',
		refer_uniquelink :'Get your unique referral link',
		refer_trackearn :'Track your earnings from referrals',
		refer_monitorStatus :'Monitor the status of your referrals',
		refer_withdrawearn :'Withdraw your earnings as you wish',
		refer_register :'Register',
		refer_knowmore :'Know More',
		refer_brokerprogram :'Introducing Broker Program',
		refer_uniqueIB :'Unique IB portal',
		refer_IBmanager :'Dedicated IB manager',
		refer_controlearn :'Take control of your earnings',
		refer_regislink :'unique IB registration link',
		refer_clientlist:'Client List',
		refer_email :'Email',
		refer_accountStatus :'Account Stage',
		refer_volumereq :'Volume requirement',
		refer_tradedvol :'Traded Volume',
		refer_qualified :'Qualified',
		refer_action :'Action',
		refer_successDelete :'You have Successfully Deleted',
		refer_fromReflist :'from your Referrel list',
		refer_wantTodelete :'Do you want to delete',
		refer_confrm :'Confirm',
		refer_enterEmailrefer :'Please Enter Email to refer',
		refer_error :'error',

		//===========dashboard
		dash_overview :'Overview',
		dash_traderRoom :"Trader's Room",
		dash_personalInfo :'Personal Information',
		dash_declaration :'Declaration',
		dash_uploadDocumen :'Upload Personal Documents',
		dash_completeReg :'Complete Registration',
		dash_checkticketstatus :'Please check the status of your ticket.',
		dash_clickhere :'Click Here',
		dash_TradingAcc :'Trading Accounts',
		dash_live :'Live',
		dash_demo :'Demo',
		dash_Platform :'Platform',
		dash_tradAccId :'Account ID',
		dash_Leverage :'Leverage',
		dash_currency :'Currency',
		dash_marketSummary :'Market Summary',
		dash_marketInsight :'Market Insights',
		dash_news :'News',
		dash_EconomicCal :'Economic Calendar',
		dash_thereIsNoRecord :'No records found',
		dash_Time :'Time',
		dash_Country :'Country',
		dash_event :'Event',
		dash_frequency :'Frequency: Monthly',
		dash_autochartist :'AutoChartist',
		dash_nodata :'No Data',
		dash_time :'Time',
		dash_impact :'Impact',
		dash_actual :'Actual',
		dash_forecast :'Forecast',
		dash_previous :'Previous',

		//========download platform
		dp_download :'Download',
		dp_actTrader :'ActTrader<sup>TM</sup>',
		dp_forWindows :'For Windows',
		dp_forIos :'For iOS',
		dp_forAndroid :'For Android',
		dp_ActWebTrader :'Act Web Trader',
		dp_MT4WebTrader :'MT4 Web Trader',
		dp_forMAC :'For MAC',
		dp_MT5WebTrader :'MT5 Web Trader',

		//======================account==========================
		//=========account

		acc_Aclist :'Account List',
		acc_changeLeverage :'Change Leverage',
		acc_changeplatPass :'Change Platform Password',
		acc_InternalTrans :'Internal Transfer',

		//=============================bank================================
		//===========bank

		bnk_bankDetails :'Bank Details',
		bnk_MicrCode :'Micr Code:',
		bnk_IBANNumber :'IBAN Account Number',
		bnk_ifscSwiftBic :'ifsc/Swift/Bic (Short code of uk)',
		bnk_Save :'Save',

		//============================bonus===============================
		//=========deposit-bonus

		db_requestBon :'Request Bonus',
		db_removeBon  :'Remove Bonus',
		db_bonusList  :'Bonus List',

		//===========bonus-verify 
		bver_bonusVerMsz1 :'Your bonus request has been processed successfully.',
		bver_backBonusList :'Back To Bonus List',
		bver_reqFailed :'Request Failed',

		//============bonus-list
		bl_bonusList :'Bonus List',
		bl_created :'Date',
		bl_amount :'Amount',
		bl_bonusType :'Bonus Type',
		bl_status :'Status',
		bl_comments :'Comments',
		bl_complete : 'Complete',
		 
		//============remove bonus
		rb_removeBonus :'Remove Bonus',
		rb_removebonusMsz1 :'Sorry you are not eligible to remove bonus.',
		rb_availbonus :'Available Bonus:',
		rb_bonusremove :'Enter bonus amount to remove',
		rb_submit :'Submit',
		rb_googleAuth1 :'Please enter the 6 digit One-Time Pin shown in the',
		rb_googleAuth2 :'Google Authenticator',
		rb_googleAuth3 :'app',
		rb_validate :'Validate',
		rb_googleAuth4 :'Having Trouble with your Two-Factor Authentication Code?',
		rb_googleAuth5 :'Click Here to verify with Email',
		rb_googleAuth6 :"We've sent a link to your email",
		rb_bonusGoogleAuth :'Kindly click on the link in order to proceed with your withdrawal',
		rb_googleAuth7 :"Haven't received an email in your inbox or spam folder? Resend",
		rb_googleAuth8 :'Two-factor authentication is not enabled on your account.',
		rb_googleAuth9 :"Two-factor authentication adds an extra layer of security, ensuring that it's really you who is trying to make changes in your fxview account.",
		rb_googleAuth10 :'Click Here to enable Google authentication',
		rb_congo :'Congratulations',
		rb_removeBonusCongoMsz : 'Bonus has been removed successfully forTrading Id',
		rb_goToDash :'Go to dashboard',
		rb_noTradingAccFound :'No Live Trading Account Found!',
		rb_plzWaitWhileProc :'Please wait while we are processing your data...',
		rb_bonusGooglerequest :'Kindly click on the link in order to proceed with your bonus request',
		rb_bonusGoogleremove :'Kindly click on the link in order to proceed',

		//==============request bonus

		req_bonus :'Bonus',
		req_bonusMsz1 :'Sorry you are not eligible. Fund your account to avail bonus.',
		req_allowMaxBonus :'Maximum bonus allowed',
		req_amount :'Amount',
		req_agreeTerms :'I agree to the terms and conditions',
		req_fieldReq:'Field is required',
		req_maxlev :'Maximum Leverage allowed to avail 100% deposit bonus is 300X.',
		req_tochangeleverage :'to change your leverage',
		req_bonusMsz2 :'Bonus has successfully been added for Trading ID:',
		req_availBonus :'Use Bonus',
		req_allowBonus :'Allowed Bonus',
		req_goBackMangeAcc :'Go to Manage Account',
		req_noTradingAccFound :'No Live Trading Account Found!',
		req_minBonus :'minimum deposit bonus is 200 dollar and we are getting option to deposit is',
		req_maxAmount :'Max amount you can request for bonus is',
		rb_ReadPolicy :'Read Our Bonus Policy',

		//==================================deposit======================================
		//============deposit
		dep_acc_fund_depFundAcc :'Deposit Funds to Account',
		dep_acc_fund_tradAccId :'Trading Account ID',
		dep_acc_fund_depFund :'Deposit Funds',
		dep_acc_fund_selDepMet :'Select Deposit Method',
		dep_acc_fund_depFieldReq :'DepositMethod field is required',
		dep_selectbankaccount :'Please Select Bank Account :',
		dep_acc_fund_lessDet :'Less Detail',
		dep_acc_fund_viewDet :'View Detail',
		dep_holderName :'Holder Name:',
		dep_sortCode :'Sort Code',
		dep_reference :'Reference',
		dep_fortradaccount :'For trading account',
		dep_selectAcc :'Please Select Account',
		dep_acc_fund_DontbankAcc :"you don't have any bank account , please",
		dep_acc_fund_clkHere :'Click Here',
		dep_Createbank :'to create new bank',
		dep_acc_fund_MinDepAmt : 'Minimum Deposit Amount',
		dep_acc_fund_SpeDepAm :'Specify the deposit amount',
		dep_mindepositallow :'Minimum deposit allowed',
		dep_acc_fund_bakStp :'Previous step',
		dep_acc_fund_procToPay :'Proceed To Payment',
		dep_ticketHasbeenCreated :'Your ticket has been created',
		dep_proMsz19 :'Go to Tickets',
		dep_acc_fund_PlsEnsCort :'Please ensure that details are correct',
		dep_acc_fund_accountId :'Account ID',
		dep_acc_fund_feeUsd :'Fee (USD)',
		dep_acc_fund_depAmt :'Deposit Amount',
		dep_acc_fund_depMeth :'Deposit Method',
		dep_acc_fund_noTrdAccFnd :'No Live Trading Account Found!',
		dep_acc_fund_plzWaitWhileProc :'Please wait while we are processing your data...',
		dep_maxlimit :'you have raised max limit of transaction per month',
		dep_maxdeposit :'you can deposit maximum amount = ',
		dep_pleaseDeposit :'Please deposit',
		dep_AccNumber :'amount as per given bank detail  : <br> Account Number : ',
		dep_holdername :'<br> Holder Name :',
		dep_bankname :'<br> Bank Name :',
		dep_brsortCode :'<br> Sort Code :',
		dep_brbankAdress :'<br> Bank Address :',
		dep_depositDone :'deposit done successfully',
		dep_depositFail :'deposit failed',

		//=========deposit list

		dl_depositList :'Deposit List',
		dl_transId :'Transaction Id',
		dl_status :'Status',
		dl_Method :'Method',
		dl_type :'Type',
		dl_created :'Date',
		dl_action :'Action',

		//==============deposit transaction
		dt_depTransHist :'Deposit Transaction history',
		dt_payMeth :'Payment Method',
		dt_clickToResolve :'click to resolve',

		//=============deposit wallet
		dw_acc_fund_selDepMet :'Select Deposit Method',
		dw_acc_fund_depFieldReq :'DepositMethod field is required',
		dw_selectaccount:'Please Select Bank Account :',
		dw_acc_fund_lessDet :'Less Detail',
		dw_acc_fund_viewDet :'View Detail',
		dw_holderName :'Holder Name:',
		dw_bankName :'Bank Name:',
		dw_bankAdd :'Bank Address:',
		dw_sortCode :'Sort Code',
		dw_reference :'Reference',
		dw_fortradingAcc :'For trading account',
		dw_acc_fund_DontbankAcc :"you don't have any bank account , please",
		dw_Createbank :'to create new bank',
		dw_acc_fund_MinDepAmt :'Minimum Deposit Amount',
		dw_acc_fund_SpeDepAm :'Specify the deposit amount',
		dw_acc_fund_PlsEnsCort :'Please ensure that details are correct',
		dw_acc_fund_accountId :'Account ID',
		dw_acc_fund_feeUsd :'Fee (USD)',
		dw_acc_fund_depAmt :'Deposit Amount',
		dw_acc_fund_depMeth :'Deposit Method',
		dw_proMsz19:'Go to Tickets',
		dw_acc_fund_plzWaitWhileProc :'Please wait while we are processing your data...',
		dw_bankCode :'<br> Bank Code : ',

		//========================manage accounts=================================
		//===========account-verify 
		acc_reqProcessing :'request processing...',
		acc_accountVerMsz1 :'request has been processed successfully',
		acc_backAccountList :'Back to Account List',
		acc_reqFailed :'Request Failed',

		//===========account-list

		acclist_myAccounts :'My Accounts',
		acclist_liveAccount :'Live Accounts',
		acclist_demoAccount :'Demo Accounts',

		//=========change-leverage
		lev_changeLeverage :'Change Leverage',
		lev_exsistLev :'Existing Leverage',
		lev_newLev :'New Leverage',
		lev_backManageAccount :'Back To Manage Account',
		lev_levMsz1 :'Please click on the link to change your leverage.',
		lev_levMsz2 :'Your trading account leverage has been changed successfully',
		lev_tradingId :'Trading Ideas',
		lev_oldLev :'Old Leverage',
		lev_goBackMangeAccv :'Go to Manage Account',
		lev_noDemoLiveTradingAccFound :'No Trading Account Found!',
		lev_waitforVerf :'Please wait for the Verification.',

		//==========change leverage password
		levPwd_passMsz1 : 'Please click on the link to change your password',
		lePwd_passMsz2 :'Your trading account password has been changed successfully',
		lePwd_oldPassword :'Old Password',

		//========demo account list
		Dlist_demoLive :'Demo/Live',
		Dlist_accountType :'Account Type',
		Dlist_leverage :'Leverage',

		//=======detach account
		detch_detachaccount :'Detach account:',
		detch_fourfive :'454579',
		detch_pamMaster :'Pamm master:',
		detch_todd :'Todd Anderson',
		detch_balance :'Balance',
		detch_equity :'Equity',
		detch_freeMargin :'Free Margin',
		detch_MarginUSed :'Margin Used',
		detch_pnl :'PnL',
		detch_two :'$2000',
		detch_eight :'$800',
		detch_twelve :'$1200',
		detch_three :'$300',
		detch_twofive :'$-250',
		detch_takenote :'Please take note of below points',
		detch_openPosition :'All open positions will be closed before detaching the account.',
		detch_finalPnl :'The final PnL might vary according to market conditions.',
		detch_afterOpen :'After open positions are closed, Management, Subscription Cost, Performance fee will be calculated and deducted from the account, if any.',
		detch_terms :'I accept the above terms and conditions',
		detch_confirm :'Confirm',

		//=======internal transfer
		It_oneRecord :'You  only have  one record. Please create at least one more trading account or wallet before attempting an internal transfer',
		It_liveAcc :'Live Account',
		It_wallet :'Wallet',
		It_internalTransfer :'Internal Transfer',
		It_confToTransfer :'Please Confirm to Continue',
		It_back :'Back',
		It_freeMargin :'Free Margin',
		It_interTransSorryMsz :"Sorry you don't have balance to transfer amount to another trading account.",
		It_transToAcc :'transfer to account id',
		It_fieldReq :'Field is required',
		It_currentBalance :'Current Balance',
		It_pleseEnterAmount :'please enter amount',
		It_submit :'Submit',
		It_confToTransfer :'Please Confirm to Continue',
		It_intTransMsz2 :'Please click on the link to confirm your internal transfer',
		It_intTransMsz3 :'The transfer has been completed successfully',
		It_fromTradId :'From Trading ID',
		It_towallet :'To Wallet',
		It_toTradId :'To Trading ID',
		It_transferAmount :'Transferred Amount',
		It_backinternalTrans :'Back to internal transfer',
		It_interTransDeducted :'will be deducted from your',
		It_depostotradAcc :'will be deposited to your',

		//==========internal transfer wallet
		Itwallet_backwallet :'Back to wallet',
		Itwallet_cancel :'Cancel',
		Itwallet_fromwal: 'from wallet',
		Itwallet_towal :'To Wallet',
		Itwallet_backtowallet :'Back to wallet',

		//===========subscribe account

		sub_SubliveAcc :'Subscribe Live Account',
		sub_subscribe :'Subscribe',
		sub_backtradingTool :'Back to Trading tool box',
		sub_enterotp :'Enter Otp',
		sub_validate :'Validate',
		sub_resendOtp :'Resend Otp',
		sub_congo :'Congratulations',
		sub_tradingId :'Trading ID',
		sub_addtradertool :'Please Add Add Trader Tool Box per following details <br> account_id : ',

		//==========================research=================================================
		//==========research and education 
		re_marketinsight :'Market Insights',
		re_news :'News',

		//======pages
		//============basic education
		edu_learnTrade :'Learn to Trade',
		edu_offerEdu :'We offer you educational resources to learn all about trading. Our learning materials cater to all knowledge levels, and enable you to enhance your understanding of the global markets, online trading and our trading tools. Our comprehensive list of trading topics ranges from basic to advanced, and will help you elevate your trading to a higher level.',
		edu_Enhance :'Enhance your understanding of the global markets and take your trading to the next level by tapping into our educational resources. Fxview education offers an extensive list of topics that cater to all levels of traders - from beginners to advanced - and covers both how the markets work, as well as how to use our trading tools to your advantage.',
		edu_tradeconfidence :'You will learn to trade with confidence by focusing on both the technical and fundamental aspects of trading/investment with our help and support throughout',
		edu_basic :'Basic',
		edu_advance :'Advanced',
		edu_general :'General',
		edu_forex :'Forex',
		edu_commodities :'Commodities',
		edu_indices :'Indices',
		edu_stocks :'Stocks',
		edu_thereIsNoRecord :'No records found',

		//=============market-insight 
		marin_source :'Source: hoopsAI',
		marin_loadmore:'Load More',
		marin_loadwait :'Loading please Wait...',

		//============market news
		news_marketnews :'Market News',
		news_fearurednews :'Featured News',
		news_market : 'Market',
		news_nodata :'No Data',
		news_latestnews :'Latest News',

		//=============video tutorial 

		video_video :'Video',
		video_tut :'Tutorials',
		video_intrestedforex :'Interested in forex trading? You are in the right place. Fxview offers a series of video tutorials to help you develop your skills and learn to trade like the pros. Our step-by-step guides include instructions on registration, account verification, basic forex terminology, trading platform functionality, and much more.',
		video_allvideo :'All Videos',
		video_fxviewtut :'Fxview Tutorials',
		video_platTut :'Platform Tutorials',
		video_forexBasic :'Forex Basics',
		video_whatisforex :'What is the forex',
		

		//========webinare fxview
		web_webinars :'Webinars',
		web_enhancetrad :'Enhance your trading by signing up to our free webinars and learning from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills. Experts reveal key trading strategies and  concepts, which can benefit both beginners and experienced traders.',
		web_registeran :'Register for an',
		web_upcomingweb :'upcoming webinar',
		web_register :'Register',
		web_timeleft :'Time Left',
		web_days :'DAYS',
		web_hours :'HOURS',
		web_mins :'MINUTES',
		web_secs :'SECS',
		web_webnar :'Webinar',
		web_library :'library',
		web_higherpower :'Trendlines-Webinar',
		web_aprtwenty :'(9th August 2021)',
		web_findright :'Support and Resistance-Webinar',
		web_aprsixteen :'(11th August 2021)',
		web_weekahead :'Basic Indicators-Webinar',
		web_aprtwelve :'(13th August 2021)',
		web_introTrend :'Introduction To Trend Indicators - Webinar',
		web_apreighteen :'Mar 18th',
		web_topicdiscuss :'TOPIC OF DISCUSSION',
		web_correlation :'FXVIEW-Using Correlation To Improve Your Trading',
		web_datemay :'May 11, 2021 12:00 - 12:40 pm GMT',
		web_showlocal :'Show my local time',
		web_joinfxview :'Join Fxview expert as he gives you insights regarding using of correlation so as to improve your trading skills.',
		web_secureplace :'Secure your place with industry expert and learn what it takes to be a professional Forex trader',
		web_topicsCovered:'TOPICS TO BE COVERED DURING WEBINAR',
		web_strongweak :'- Strong vs weak correlation',
		web_corrmultiple:'- Correlation across multiple timeframes',
		web_posneg :'- Understanding positive and negative correlation',

		//======================register steps=======================================
		//=========steps
		steps_heading1 :'Personal Information',
		steps_heading2 :'Declaration',
		steps_heading3 :'Upload Personal Documents',

		//==========step1
		step1_personalinfo :'Personal Information',
		step1_fname :'First Name',
		step1_lname :'Last Name',
		step1_dob :'DOB',
		step1_dobrequired :'The DOB is required',
		step1_below18 :'Your Age is below 18',
		step1_minimumdate :'The DOB should be greater than 1920',
		step1_addinfo :'Address Information',
		step1_city :'City',
		step1_postalcode :'Postal Code',
		step1_countryRes :'Country of Residence',
		step1_otherinfo :'Other Information',
		step1_phno :'Phone Number',
		step1_phnoRequired :'The Phone number is required',
		step1_correctno :'Please Enter the correct Phone number',
		step1_prefcurrency :'Select Preferred Wallet Currency',
		step1_pep :'Are you a Politically Exposed Person (PEP)?',
		step1_usPerson :'Are you a US person?',
		step1_Next :'Next',
		step1_firstmember :'First Member Information',
		step1_member1dob :'Member 1 Date Of Birth is required',
		step1_member1age :'Member 1 Age is bellow 18',
		step1_secondmember :'Second Member Information',
		step1_menber2dobreq :'Member 2 Date Of Birth is required',
		step1_member2age :'Member 2 Age is bellow 18',
		step1_adressinfo :'Address Information',
		step1_companyinfo :'Company Information',
		step1_companyname :'Company Name',
		step1_incopDate :'Incorporation Date ',
		step1_incodateReq :'The Incorporation Date is required',
		step1_futuredate :'future Date not allow',
		step1_authorperson :'Authorised Person Information',
		step1_companyAdrsinfo :'Company Address Information',
		step1_regAddone :'Registered Company Address Line 1',
		step1_regAddtwo :'Registered Company Address Line 2',
		step1_country :'Country',
		step1_minimumph :'The phone number includes atleast 8 characters',
		step1_maxphone :'The phone number may not be greater than 15 characters',
		step1_stepMsz2 :"A PEP is a natural person who has been entrusted with the following prominent public functions in any country, as well as his/ her immediate family members and persons known to be close associates of such a person: <ul> <li>Heads of State, heads of government, ministers and deputy or assistant ministers,</li>  <li> Members of parliaments or of similar legislative bodies,</li>  <li>Members of governing bodies of political parties,</li>  <li>Members of supreme courts, of constitutional courts or of other high-level judicial bodies whose decisions are not subject to further appeal, except in exceptional circumstances,</li>  <li>Members of courts of auditors or of the boards of central banks,</li> <li>Ambassadors, chargés d'affaires and high-ranking officers in the armed forces,</li>  <li>Members of administrative, management or supervisory bodies of governmental businesses or stated owned enterprises,</li> <li>Directors, deputy directors and members of the board of directors or persons holding an equivalent position in an international organization,</li> <li>Mayors</li> </ul>",
		step1_stepMsz3 :'The definition of a U.S. person (“United States person”) includes: <ul>  <li> A U.S. citizen or resident (including dual citizenship),</li> <li> A U.S. alien (resident for tax purposes)</li>  <li> A person born in the U.S? </li>   <li> A person with a current U.S. mailing or residence address (including a U.S. post office box or U.S. in care of address) </li>    <li> A person with a current U.S. telephone number </li> <li> A person with standing instructions to transfer funds to an account maintained in the United Sates?</li>  <li> A person with current and effective power of attorney or signatory authority granted to a person with U.S. address?</li> </ul>',

		//============step4
		step4_readaccept :'I have read, understood and accept the',
		step4_ClientAgreement :'Client Agreement',
		step4_privacyplicy :'Privacy Policy',
		step4_and :'and',
		step4_riskDisclosr :'Risk Disclosure documents',
		step4_termsAgreeRqd :'Please agree to these terms',
		step4_policytwo :'I agree for my personal data to be processed and stored as per the Privacy Policy and for Fxview to contact me regarding important information for my account',
		step4_AfterCalling :'Note: After clicking on',
		step4_saveContinue :'Save & Continue',
		step4_allInfoCorrect :"you won't be able to change any previous step information. Make sure all information is correct!",

		//==========step5
		step5_browsersupport :"May the browser didn't support or there is some errors.So please upload file",
		step5_cameradenied :'Camera permission denied',
		step5_scanqrcode :'Scan QR code instead',
		step5_scanqrmobile :'Scan this QR code using your mobile camera or QR code app',
		step5_keepageopen :'Please keep this page open while you are using your mobile',
		step5_continueBrowser :'Continue with Browser',
		step5_docSubsuccess :'Your documents have been submitted successfully. Please be patient while we review your documents and it may take upto 24 hours or more during peak time.',
		step5_reviewstatus :'click here to review status of your ticket',
		step5_identifyDoc :'IDENTITY DOCUMENTS',
		step5_proofresidence :'PROOF OF RESIDENCE DOCUMENTS',
		step5_uploadphototext :'Upload a photo of your identity document. Please ensure that the details on the ID matches with the information you entered in the personal information form.',
		step5_uploadproof :'Upload a proof of your residence address (in your name & not more than 6 months old). Please note that we do not accept screenshots.',
		step5_takephoto :"Take a photo of your Driver's Licence and upload it here",
		step5_takegovernid :'Take a photo of your Government issued ID and upload it here',
		step5_goodQuality :'Good quality:',
		step5_brightclear :'Bright and clear',
		step5_note :'Note:',
		step5_allcorner :'All corners of the document to be visible and document must be valid (not expired)',
		step5_allcorner1 :' Must show your full name, residence address, issuing institution and issue date. All corners of the document to be clearly visible.',
		step5_uploadfrontside :'Please upload the front side of your document',
		step5_maximumfilesize :'Maximum files size of can be uploaded up to ',
		step5_uploadbackside:'Upload the back of your document',
		step5_upload :'Upload',
		step5_idenfNumber :'Please mention you identification Number located in your identity docuemtn.',
		step5_uploadpassport :'Take a photo of your Passport and upload it here',
		step5_photolicense :"Take a photo of your Driver's Licence and upload it here",
		step5_photogovernmentID :'Take a photo of your Government issued ID and upload it here',
		step5_proofsixold :'Take a photo of your proof or residence (not older than 6 months):',
		step5_bankstatement :'Bank Statement, Utility Bill (water, electricity, home internet or landline), Tax Document, Rental Agreement (if issued in the last 6 months)',
		step5_uploadyourDoc :'Upload your document',
		step5_idnorequired :'ID Number is Required.',
		step5_filesizemax :'files size can be maximum',
		step5_filesallowed :'Only jpg, jpeg, png, pdf files are allowed! ',
		step5_uploadbothside :'Please upload both side of your document',
		step5_verifydoc :'Please upload your document to verify your information',
		step5_continuemobile :'Continue with mobile',
		step5_recentphoto :'Please upload your recent photo',
		step5_photoverif :'PHOTO VERIFICATION',
		step5_legitimacy:'All users are required to upload a Verification photo. This is just part of the numerous techniques and systems we employ to ensure the legitimacy of our users.',
		step5_back :'back',
		step5_start:'Start',
		step5_webcamdont :"I don't have Web Cam",
		step5_captureimage :'Capture Image',
		step5_cancel:'Cancel',
		step5_filemax:'files size can be maximum of',
		step5_choosefileupload :'Choose File To upload',
		step5_allowmaxsize :'Maximum file size we allow is of',
		step5_useWebcam :'Use Web Cam',



		//======================social trade=====================
		//========social trade
		soclTrade_zullutrade :'Zulu Trade',
		soclTrade_mql :'MQL5',

		//==========zullutrade 
		zulu_trade : 'ZuluTrade',
		zulu_zulitradeinfo :'Zulu trade is a social trading platform where you can follow traders across the globe and copy trades whilst learning from the strategies they use. Based on the Complete information available for their trading styles and performance, you can easily make the traders of your choice and once you follow them, their trades will automatically be copied in your account.',
		zulu_createAccount :'Create Zulu Account',
		zulu_setupzulutrade :'How to setup ZuluTrade account',
		zulu_registeropen :'Register and open a Fxview ZuluTrade account.',
		zulu_findaccount :'Fund the account with a minimum of $100 to receive login credentials from the ZuluTrade.',
		zulu_logintozulu :'Login to the zulu trade website and start following any trader(s) of your choice.',

		//=========mam-pamm
		mampam_heading :'MAM/PAMM',
		mampam_programenable :'The fxview MAM/PAMM program enables experienced traders to manage multiple sub accounts under a single master account, in a professional manner.',
		mampam_knowmore :'Know More',
		mampam_becameinvestor :'How to become an investor:',
		mampam_clicktobecame :'Click on "Become an Investor"',
		mampam_uniquepamid :'Enter your manager’s unique PAMM ID to view his profile.',
		mampam_createinverstor :'Create your investor account and connect with the PAMM account',
		mampam_monitoracc :'Monitor your account through PAMM investor’s dashboard',
		mampam_connectmanager:'Connect to a Manager',
		mampam_becomemanager :'How to become an Manager:',
		mampam_clickbecomemanager :'Click on “become a manager”',
		mampam_meetconditions :'Meet the required conditions to receive your unique PAMM Id',
		mampam_manageaccount :'Manage your account through exclusive PAMM portal',
		mampam_becomeManager :'Become a Manager',

		//===========mql5
		mql_heading :'MQL5',
		mql_text :'MQL5 is one of the largest copy-trading communities in the world, connecting novice traders with experienced ones. Users can choose from thousands of free and fee-liable verified signals to improve their trading performance',
		mql_createliveAcc :'Create Live Account',
		mql_stepsRegister :'Steps to register MQL5',
		mql_stepone :'Register a MQL5 account on its websites',
		mql_stepTwo :'Open Metatrader platform and go to Tools >> Options and click on the Community tab. Login into the MQL5 account and click OK.',
		mql_stepThree :'Go to signals tab in the terminal window and select the signal that you want to follow.',


		//=======================unauthorized=============================================
		//=============unauthorized
		unaut_under :'Under',
		unaut_Verification :'Verification',
		unaut_pendingVerificationMsz1 :'Your application is under review by our compliance department. It may take 3-4 working days for your documents to be verified. You will receive an email once your documents are verified',


		//=============================trading accounts=======================
		//===============create zullu account
		createzullu_Your :'Your',
		createzullu_successcreate :'zulu account has been successfully created. Your credentials are:',
		createzullu_accountBaseCurrency: 'Account Base Currency',
		createzullu_tradenow:'Trade Now',
		createzullu_forWeb :'For Web',
		createzullu_open :'Open',
		createzullu_tradingAcc :'Trading Account',
		createzullu_classic :'Classic',
		createzullu_USD :'USD',
		createzullu_EUR :'EUR',
		createzullu_GBP :'GBP',
		createzullu_AUD :'AUD',
		createzullu_leverageField :'Leverage is a required field',
		createzullu_accountPassword :'Trading Account Password',
		createzullu_passwordcontain :'Your password must contain minimum 6 characters and maximum 15 characters and includes atleast 1 special character (!@#$%^*/)',
		createzullu_createAccount :'Create Account',
		//=================create account
		demoacc_demomsg :'demo account has been successfully created. Your credentials are:',
		demoacc_MT4 :'Meta Trader 4',
		demoacc_MT5 :'Meta Trader 5',
		demoacc_passwordMust :'Your password must contain minimum 6 characters and maximum 24 characters and includes atleast 1 special character (!@#$%^*/) ',
		//==================create live account

		liveacc_accounthas :'live account has been ',
		liveacc_successfully :'successfully',
		liveacc_credentialsare :'created. Your credentials are:',

		
		// ============= /withdrawal =========================
		// withdrawal_wallet.vue
		wit_Wallet_from_wallet : "from wallet",
		wit_Wallet_Back : "Back to wallet",
		wit_Wallet_No : "No wallet",
		wit_withdrawal :'Withdrawals',
		wit_freeMargin :'Free Margin',
		wit_withdrawalMsz1 :"Sorry, you're not eligible for a withdrawal yet. Depositing and trading can help you become eligible!",
		wit_PrincipalWithAmount :'Principal Withdrawal Amount',
		wit_AccNumber :'Account Number:',
		wit_skrillId :'Skrill ID:',
		wit_netId :'Neteller ID:',
		wit_creditCardNumber :'credit card number',
		wit_expiryDate :'expiry date',
		wit_allowOption :'Please select from the above allowed options',
		wit_WithdrawalMethodReq :'Withdrawal Method is required',
		wit_EnterWithdrawal :'Enter withdrawal',
		wit_requestWithdrawal :'You can request the withdrawal from newly approved payment options after 24 hours of approval',
		wit_withdrawalMsz2 :'We have received your withdrawal request, and will update you accordingly',
		wit_withCont1 :'Fxview does not charge withdrawal fees. However, ease note that payment processors/financial intermediaries may charge a transaction fee.',
		wit_withCont2 :'Due to third party transaction restrictions, funds can only be returned to a bank account in the same name as your Fxview trading account. Furthermore, funds will only be returned to the same bank account from which they were received.',
		wit_withCont3 :'The total amount you can withdraw into your card cannot exceed the total amount deposited with the card. Amounts exceeding this level can be withdrawn into your bank account, Neteller or Skrill',

		//==========withdrawal.vue
		withdraw_backWithdraw :'Back to Withdrawal',

		//==============withdrawal list
		withdrawList :'Withdrawal List',
		withdrawList_all :'All',
		withdrawList_pending :'Pending',
		withdrawList_processed :'Processed',
		withdrawList_rejected :'Rejected',
		withdrawList_created :'Date',
		withdrawList_accountId :'Account ID',
		withdrawList_amount :'Amount',
		withdrawList_currency :'Currency',
		withdrawList_withdrawalType :'Withdrawal Type',
		withdrawList_method :'Method',
		withdrawList_withdrawalStatus :'Status',
		withdrawList_detail :'Detail',
		withdrawList_viewTicket :'View Ticket',

		// ============================= /wallet =========================
		// wallet.vue
		Wallet_Wallet : "Wallet",
		Wallet_Loyalty_Points : "Loyalty Points",
		// wallet_detail.vue
		Wal_detail_Add_New : "Add New Wallet Currency",
		Wal_detail_Wallet_ID : "Wallet ID",
		Wal_detail_Deposit : "Deposit",
		Wal_detail_Withdraw : "Withdraw",
		Wal_detail_Transfer : "Transfer",
		Wal_detail_curr_required : "The currency field is required",
		Wal_detail_Submit : "Submit",
		Wal_detail_Trans_History : "Transaction History",
		Wal_detail_Date : "Date",
		Wal_detail_Time : "Time",
		Wal_detail_Type : "Type",
		Wal_detail_From : "From",
		Wal_detail_To : "To",
		Wal_detail_Amount : "Amount",
		Wal_detail_Status : "Status",
		Wal_detail_availAmount :'Available Amount:',
		

		// account-funding.vue
		acc_fund_Deposit : "Deposit",
		acc_fund_Withdrawal : "Withdrawal",
		// change_wallet_currency.vue
		chang_wal_curr_Internal_Transf : "Wallet Internal Transfer",
		chang_wal_curr_Transf_Wall_amount : "Transfer Wallet amount",
		chang_wal_curr_Back : "Back to Wallet",

		// loyalty-points.vue
		loyalP_Reward_Points : "Loyalty Reward Points",
		loyalP_Know_More : "Know More",
		loyalP_Trans_Wallet : "Transfer to Wallet",
		// =======================/wallet/loyality===========================
		// loyality_point_transfer.vue
		loyalP_Transfer : "Transfer",
		loyalP_transf_TotalP : "Total loyalty points",
		loyalP_transf_Amou_Avail : "Amount Available",
		loyalP_transf_Enter_p_transfe : "Enter point to transfer",
		loyalP_transf_Cancel : "Cancel",
		loyalP_transf_Transfer : "Transfer",
		loyalP_transf_Back : "Back to Wallet",
		loyalP_transToAcc :'transfer to account id',
		loyalP_fieldReq :'Field is required',
		loyalP_intTransMsz2 :'Please click on the link to confirm your internal transfer',
		loyalP_intTransMsz3 :'The transfer has been completed successfully',
		loyalP_fromTradId :'From Trading ID',
		loyalP_toTradId :'To Trading ID',
		loyalP_transferAmount :'Transferred Amount',
		// loyality_card_detail.vue
		loyal_card_det_You_are_a : "You are a",
		loyal_card_det_member : "member",
		loyal_card_det_Points : "Points",
		loyal_card_det_Last_Credit_On : "Last Credit On",
		loyal_card_det_Points : "Points",
		loyal_card_det_Earn : "Earn",
		loyal_card_det_more_points_to_jump_to : "more points to jump to",
		loyal_card_det_gain_add_benefi : "to gain additional benefits",
		// loyality_txn_list.vue
		loyal_List_Trans_History : "Transaction History",
		loyal_List_Date : "Date",
		loyal_List_Activity : "Activity",
		loyal_List_Volume : "Volume",
		loyal_List_Points : "Points",
		loyal_List_Cr_Db : "Cr/Db",
		// loyalty-verify.vue
		loyal_ver_back : "Back to Wallet",
		// redeam-point.vue
		redeamP_your_points : "Redeem your loyalty points",
		redeamP_Points : "Points",
		redeamP_Redeem : "Redeem",
		redeamP_Red_Points : "Redeem Points",
		redeamP_Points : "Points",
		redeamP_Now : "Redeam Now",
		redeamP_walletpoints :'Please Redeem Wallet Points as per following details <br> points : ',
		redeamP_pointdesc :'<br> point_desc :',




		// ==========================tool-pages====================
		//========tools.vue
		tool_overview :'Overview',
		tool_autochartistScan :'AutoChartist Scanner',
		tool_autochartistWeb :'AutoChartist Web',
		tool_Vpsheading :'VPS',
		tool_ecoCalendar :'Economic Calendar',
		tool_tradingToolbox :"Trader's Tool Box",
		tool_Calculator :'Calculators',
		tool_tradingHOur :'Trading Hours',
		tool_Signal :'Signals',
		// autochartist_scanner.vue
		autoScan_knoMore : "Know more",
		autoScan_DownLive : "Download for Live Account",
		autoScan_HowInstall : "How to install AutoChartist",
		autoScan_usrGuide : "user guide",
		autoScan_goTool : "In the platform, go to tools > options > expert advisors to allow DLL imports and click on OK.",
		// vps.vue
		toolVps_sureImp : "Are you sure to implement this operation?",
		toolVps_confirm : "confirm",
		toolVps_cancel : "cancel",
		toolVps_Shut_Down : "Shut-Down",
		toolVps_Restart : "Restart",
		toolVps_Reboot : "Reboot",
		toolVps_Change_Pass : "Change-Password",
		toolVps_VieDet : "View Detail",
		toolVps_UpdAcc : "Update Account",
		toolVps_Unsubscribe : "Unsubscribe",
		toolVps_vpsList : "Virtual  Private <span>Server</span>(VPS) List",
		toolVps_createVps : "Create VPS",
		toolVps_SubList : "Subscription List",
		toolVps_accWalt : "Account/Wallet",
		toolVps_Priodicity : "Priodicity",
		toolVps_Price : "Price",
		toolVps_strtDate : "Start Date",
		toolVps_endDate : "End Date",
		toolVps_Action : "Action",
		toolVps_vps : "Virtual  Private <span>Server</span>(VPS)",
		toolVps_vpsTilte : "Enjoy an unparalleled trading experience with us, where the stability of your trades is assured. There is no need to worry about latency or deal with multiple software on your system any more. Use our FREE VPS to get lightning fast responses to your trades and enjoy impressive speeds on our platforms.",
		toolVps_redLate : "Reduced Latency",
		toolVps_freeOn5000 : "Free with a deposit of $5,000 or more",
		toolVps_remoteAcccess : "Remote Access",
		toolVpsstab_Env : "Stable Environment",
		toolVps_back_vpsList : "Back to VPS List",
		toolVps_tc : "Terms and Conditions Apply",
		toolVps_Plan :'Plan',
		toolVps_Status :'Status',
		toolVps_type :'Type',
		toolVps_nextpayment :'Next Payment',
		toolVps_passWordMustContain12 :'Your password must contain at least 12 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',


		// sub_change_account_verify.vue
		toolVps_verifySubscribe : "Your update trading account request has been processed successfully",
		toolVps_back_subList : "Back to Subscription List",
		toolVps_reqProcessing :'request processing...',
		toolVps_reqVerify :'Request Verification',
		toolVps_reqFailed :'Request Failed',

		// sub_change_account.vue
		VpsSub_1_Record : "You only have one record. Please create at least one more trading account or wallet before attempting an change subscription account.",
		VpsSub_liveAcc : "Live Account",
		VpsSub_Wallet : "Wallet",
		VpsSub_ChangeTradAcc : "Change Subscription Trading Account",
		VpsSub_back_subLis : "Back to Subscription List",
		VpsSub_Submit : "Submit",
		VpsSub_received_request : "We have received your chnage trading account request, and will update you accordingly",
		VpsSub_withdrawalAuthMessage :'Kindly verify the withdrawal request by clicking on the link that we sent to your registered email ID',
		VpsSub_noTradingAccFound :'No Live Trading Account Found!',
		

		// unsubscribe_plan.vue
		VpsUnSub_1_record : "You  only have  one record. Please create at least one more trading account or wallet before attempting an change subscription account.",
		VpsUnSub_liveAcc : "Live Account",
		VpsUnSub_Wallet : "Wallet",
		VpsUnSub_sureUnsub : "Are you sure to unsubscribe",
		VpsUnSub_plan_ : "plan?",
		VpsUnSub_confirm : "confirm",
		VpsUnSub_Cancel : "Cancel",
		VpsUnSub_received_request : "We have received your chnage trading account request, and will update you accordingly",
		VpsUnSub_back_subList : "Back to Subscription List",
		// unsubscribe_verify.vue
		VpsUnSubVer_successfully : "Your unsubscribe plan request has been processed successfully",
		VpsUnSubVer_back_subList : "Back to Subscription List",
		// market_trading_hours.vue
		marktTrdHour_title : "Market Trading Hours",
		marktTrdHour_txt : "Our server time is GMT+3 during US Daylight Savings Time (DST) and GMT+2 during US Non Daylight Savings Time (Non-DST).",
		marktTrdHour_table_below : "The table below lists the opening and closing hours of various instruments and asset classes as per our server time.",
		marktTrdHour_Forex : "Forex",
		marktTrdHour_Indices : "Indices",
		marktTrdHour_Commodities : "Commodities",
		marktTrdHour_Open : "Open",
		marktTrdHour_Close : "Close",
		marktTrdHour_Break : "Break",
		// traders_marketplace.vue
		trdMarktPlac_title : "Trader's <span>Market Place</span>",
		trdMarktPlac_txt : "Browse our marketplace to access strategies created by some of the world's best traders, or design your own and we'll help you get it built.  Our marketplace is a one stop shop to take your trading to the next level.",
		trdMarktPlac_Automate : "Automate your <span>trading</span> to get the most out of the markets",
		trdMarktPlac_Customise : "Customise your trading",
		trdMarktPlac_Customise_Txt : "Define your requirements and bring your system to life by connecting with a developer who will build it for you",
		trdMarktPlac_Risk_manag : "Risk management",
		trdMarktPlac_Risk_manag_txt : "Review the performance of signal providers based on their experience, best & worst trades, risk profile and more",
		trdMarktPlac_Browse_library : "Browse our library",
		trdMarktPlac_Browse_libraryTxt : "Browse our extensive library of EAs and indicators for MT4, MT5 and ActTrader, and find the right fit for your needs",
		trdMarktPlac_Categories : "Categories",
		trdMarktPlac_All : "All",
		trdMarktPlac_Expert : "Expert",
		trdMarktPlac_Advisors : "Advisors",
		trdMarktPlac_Indicators : "Indicators",
		trdMarktPlac_ActTrader : "ActTrader",
		trdMarktPlac_Popular : "Popular",
		trdMarktPlac_New : "New",
		trdMarktPlac_Free : "Free",
		trdMarktPlac_Paid : "Paid",
		trdMarktPlac_Long_Str : "Long Term Strategies",
		trdMarktPlac_2frame : "Two Frames",
		trdMarktPlac_StratCon2 : "Strategy consists of two different charts history:",
		trdMarktPlac_Details : "Details",
		trdMarktPlac_Add_List : "Add To List",
		trdMarktPlac_Hammer_Ass : "Hammer Assistant",
		trdMarktPlac_Strat_trad_assis : "This Strategy (trading assistant) will warn you when a hammer is forming and",
		trdMarktPlac_Pos_Mgmt : "Positions Management",
		trdMarktPlac_Lot_Cal : "Lot Calculator",
		trdMarktPlac_Lot_Cal_txt : "Lot Calculator - is a Forex tool that lets you calculate the size of the ...",
		trdMarktPlac_Short_Strat : "Short Term Strategies",
		trdMarktPlac_Reg_Stra : "Regression Strategy",
		trdMarktPlac_Reg_StraTxt : "Strategy opens a buy position when low value of current candle is = top belt ..",
		trdMarktPlac_NoData : "No Data",
		// economic_calendar.vue
		ecoCalendar : "Economic Calendar",
		ecoCal_Title_Txt : "Track important economic events and releases that impact Forex, Commodities and Indices.",
		ecoCal_Up_next : "Up next",
		ecoCal_Country : "Country",
		ecoCal_Select_All : "Select All",
		ecoCal_Clear : "Clear",
		ecoCal_My_Filter : "My Filter",
		ecoCal_Default : "Default",
		ecoCal_Impact : "Impact",
		ecoCal_All : "All",
		ecoCal_Medium : "Medium",
		ecoCal_High : "High",
		ecoCal_Save_filter : "Save setting in my filter",
		ecoCal_Apply_Filter : "Apply Filter",
		ecoCal_Apply_Filter : "Apply Filter",
		ecoCal_Time : "Time",
		ecoCal_TimeZ_Settings : "Time Zone Settings",
		ecoCal_TimeZ : "Time Zone",
		ecoCal_Select_TimeZ : "Select Time Zone",
		ecoCal_TimeF : "Time Format",
		ecoCal_Set_timeZ_Auto : "Set my time zone automatically",
		ecoCal_Save_Sett : "Save Setting",
		ecoCal_Cancel : "Cancel",
		ecoCal_Impact : "Impact",
		ecoCal_noRecord : "No Record",
		ecoCal_Country :'Country',
		ecoCal_Event :'Event',
		ecoCal_Actual :'Actual',
		ecoCal_Forecast :'Forecast',
		ecoCal_Previous :'Previous',


		// trading_tool.vue
		tools_Trad_Tools : "Trading Tools",
		tools_Trad_Tools_Txt : "Make informed and timely investment decisions using our powerful trading tools that help you identify potential opportunities and build a stronger trading strategy",
		tools_Auto_Scanner : "AutoChartist Scanner",
		tools_Auto_Scanner_txt : "Never miss a trading opportunity again..",
		tools_VPS : "VPS",
		tools_VPS_txt : "Enjoy free basic VPS or choose from subscription..",
		tools_Eco_Calendar : "Economic Calendar",
		tools_Eco_Calendar_txt : "Stay up to date on important economic events..",
		tools_Trad_Toolbox : "Trader's Toolbox",
		tools_Trad_Toolbox_txt : "A premium range of trading and analysis tools..",
		tools_Calculators : "Calculators",
		tools_Calculators_txt : "Calculate pip value, margin, swaps & more..",
		tools_TradeMarket : "Trader's Marketplace",
		tools_TradeMarket_txt : "Find your ideal EA or indicator, or have..",
		tools_Trad_Hours : "Trading Hours",
		tools_Trad_Hours_txt : "Quickly see when the markets are open..",
		tools_Auto_Idea : "AutoChartist Idea",
		tools_Auto_Idea_txt : "Never miss a trading opportunity again..",
		tools_readmore:'Read More',

		//==================shared=====================================
		//=============change-entity 

		chEn_entity :'Entity',
		chEn_global :'Fxview Global',
		chEn_europe :'Fxview Europe',
		chEn_redirectmsg1 :'Based on your selection, you will be redirected to the website of Charlgate SVG LLC, which is registered in Saint Vincent and the Grenadines. Charlgate SVG LLC falls outside the European regulatory framework, and is not in scope of the Markets in Financial Instruments Directive II (MiFID II), among others. In addition, there is no provision for an investor compensation scheme.',
		chEn_redirectmsg2 :'Before you proceed, please confirm that your decision was made independently and at your own exclusive initiative, and that no solicitation or recommendation has been made by Charlgate SVG LLC or any other entity within the group.',
		chEn_continue :'Continue',
		chEn_takeback :'Take me back',

		//===========advanced chart

		adchart_create :'Create',
		adchart_save :'Save',
		adchart_chart:'Chart',
		adchart_Studies :'Studies',
		adchart_failedchart :'Failed to load chart',
		adchart_kindlyrefresh :'Kindly refresh',

		//=========chart
		chart_loadchartfail:'Failed to load chart Kindly refresh!',

		//=========filter component
		filter_Selecttimezone :'Select Timezone',
		filter_Low :'Low',
		filter_medium :'Medium',
		filter_high :'High',
		filter_submit :'Submit',


		//================header
		head_Wallet :'Wallet',
		head_loyality :'Loyality Points',
		head_createLiveAcc :'Create Live Account',
		head_createDemoAcc :'Create Demo Account',
		head_Notification :'Notification',
		head_seeAll :'See All',
		head_noNewNotification :'No New Notifications',
		head_verified :'Verified',
		head_notVerified :'Not Verified',
		head_profile :'Profile',
		head_changePassword :'Change Password',
		successMsz4: "Password Changed Successfully",
		head_security :'Security',
		head_referFriend :'Refer a friend',
		head_logout :'Log out',

		//=========leftnavbar

		leftnav_dashboard :'Dashboard',
		leftnav_wallet :'Wallet',
		leftnav_accfunding :'Account Funding',
		leftnav_manageAcc :'Manage Account',
		leftnav_Depositbonus :'Deposit Bonus',
		leftnav_socialTrade :'Social Trading',
		leftnav_tools :'Tools',
		leftnav_education :'Education &',
		leftnav_resources :'Resources',
		leftnav_downloadplatform :'Download Platform',
		leftnav_support:'Support',

		//==============loader 
		load_norecordfound :'No records found',

		//==============no trading account
		tradAcc_application :'Please complete your account application and create a',
		tradAcc_trading :'trading',
		tradAcc_live :'live',
		tradAcc_accountAccess :'account to access this function.',
		tradAcc_resumeApplication :'Resume Application',
		tradAcc_checkappStatus :'Your application is under review, Please check the status your ticket.',
		tradAcc_ticket:'Ticket',
		tradAcc_createliveAcc :'Please create a live account to access this function',
		tradAcc_liveDemoAcc :'Please create a live or demo account to access this function',
		tradAcc_demoAcc :'Demo Account',
		tradAcc_createWallet :'Please create a wallet  to access this function',
		tradAcc_wallet :'Wallet',

		//===========pagination
		pagin_totalRecords :'Total Records',


		//==========shared/tradingAccounts===================
		//===========account list table

		acclist_fund :'Fund',
		acclist_addFund :'Add Funds',
		acclist_addFundTo :'Add Funds to',
		acclist_tradingId :'Trading ID',
		acclist_addingFundTo :'Adding Funds to',
		acclist_tradingAcc :'',
		acclist_fund_msz :'deposit successfully',
		acclist_changeLeverage :'Change Leverage',
		acclist_changePassword :'Change Password',
		acclist_internalTransfer :'Internal Transfer',
		acclist_tradeNow :'Trade Now',
		acclist_detachAcc :'Detach account',

		//=============account-id 
		accId_TransFromAccId :'Transfer from account id',
		accId_selectAccountId :'select account id',
		accId_fieldReq :'Field is required',

		//============close trading listing

		closetrad_login :'Login',
		closetrad_order :'Order',
		closetrad_symbol :'Symbol',
		closetrad_volume :'Volume',
		closetrad_openPrice :'Open Price',
		closetrad_openTime :'Open Time',
		closetrad_commision :'Commission',
		closetrad_type :'Type',
		closetrad_SL :'SL',
		closetrad_TP :'TP',
		closetrad_closePrice :'Close Price',
		closetrad_closeTime :'Close Time',
		closetrad_Swap :'Swap',
		closetrad_PNL :'PNL',
		closetrad_comment :'Comment',
		closetrad_price :'Price',
		//================open close trade list 
		OCtradelist_balance :'Balance',
		OCtradelist_margin :'Margin',
		OCtradelist_equity :'Equity',
		OCtradelist_pnl :'PNL',
		OCtradelist_tradeNow :'Trade Now',
		OCtradelist_opentrade :'Open Trade',
		OCtradelist_closetrade :'Close Trade',
		//===============open order listing
		openOrder_orderId :'Order ID',
		openOrder_accountId :'Account ID',
		openOrder_quantity :'Quantity',
		openOrder_triggered :'Triggered',
		openOrder_side :'Side',
		openOrder_tradeId :'Trade ID',
		openOrder_profit :'Profit',
		openOrder_agentComm :'Agent Commission',
		openOrder_cmd :'Cmd',
		openOrder_sl :'SL',
		openOrder_tp :'TP',
		openOrder_swaps :'Swaps',

		// trading_calculators.vue
		trade_cal_title : "Trading Calculators",
		trade_cal_title_Txt : "Our online calculators provide you with an easy way to analyse the trades that you plan to make. We help you calculate values based on market conditions and provide you with instant results.",
		trade_cal_Commission : "Commission",
		trade_cal_Multi_Target : "Multi-Target",
		trade_cal_Pivot_Points : "Pivot Points",
		trade_cal_Profit_Loss : "Profit & Loss",
		trade_cal_Fibonacci : "Fibonacci",
		trade_cal_Pip_Value : "Pip Value",
		trade_cal_Swap : "Swap",
		trade_cal_Position_Size : "Position Size",
		trade_cal_Currency_Convertor : "Currency Convertor",

		// ====================/shared/calculators============================
		// Commission.vue
		cal_comm_title : "Commission",
		cal_comm_title_txt : "Calculate the commissions you would pay for a trade with our commission calculator. Fxview charges a commission of $1/100,000 each way (or $2/100,000 round-trip). Our commission calculator will assist you in calculating how much this works out to, for any given trade. Simply enter the asset class, symbol, account base currency and the trade size, and press 'Calculate Now.'",
		cal_comm_forex : "forex",
		cal_comm_commodities : "commodities",
		cal_comm_indices : "indices",
		cal_comm_Asset_Class : "Asset Class",
		cal_comm_Field_req : "field is required",
		cal_comm_USD : "USD",
		cal_comm_GBP : "GBP",
		cal_comm_AUD : "AUD",
		cal_comm_EUR : "EUR",
		cal_comm_accBaseCurr : "Account Base Currency",
		cal_comm_Symbol : "Symbol",
		cal_comm_trade_size_lot : "Trade Size (in lots)",
		cal_comm_now : "Calculate Now",
		cal_comm_Comm_roundT : "Commission (round trip)",
		// Margin.vue
		cal_marg_title : "Margin",
		cal_marg_title_txt : "The Margin Calculator helps you determine the margin required to open a position. Simply select the asset class, symbol, account currency and the trade size to ascertain the margin required based depending on the maximum leverage offered for different types of instruments.",
		cal_marg_Field_req : "field is required",
		cal_marg_accBaseCurr : "Account Base Currency",
		cal_marg_Symbol : "Symbol",
		cal_marg_trade_size_lot : "Trade Size (in lots)",
		cal_marg_now : "Calculate Now",
		cal_marg_req : "Margin Require",
		cal_marg_max_lev : "Max. Leverage",
		cal_marg_forex :'forex',
		cal_marg_commodities :'Commodities',
		cal_marg_indices :'Indices',
		

		// milti_Target.vue
		cal_milti_Target : "Multi Target",
		cal_milti_Target_txt: "This calculator helps traders to plan what part of their positions should be closed at certain target levels to gain the best return to risk ratio possible.",
		cal_milti_Field_req : "field is required",
		cal_milti_accBaseCurr : "Account Base Currency",
		cal_milti_Symbol : "Symbol",
		cal_milti_Position_Type : "Position Type",
		cal_milti_Buy : "Buy",
		cal_milti_Sell : "Sell",
		cal_milti_Open_Price : "Open Price",
		cal_milti_Stop_loss_Price : "Stop loss Price",
		cal_milti_trade_size_lot : "Trade Size (in lots)",
		cal_milti_Target_Price : "Target Price",
		cal_milti_lots_Clos_Target : "lots Closed At Target",
		cal_milti_Net_Lot_size: "Net Lot size:",
		cal_milti_Now : "Calculate Now",
		cal_milti_Target_Profit : "Target Profit",
		cal_milti_Total_Profit : "Total Profit",
		cal_milti_Return_Risk : "Return To Risk",
		// pivot_points.vue
		cal_pivot_point_txt : "Fxview offers a pivot points calculator to help you identify the direction of prevailing trends and determine support and resistance levels.",
		cal_pivot_High : "High",
		cal_pivot_Low : "Low",
		cal_pivot_Open : "Open",
		cal_pivot_Close : "Close",
		cal_pivot_Calculate_Now : "Calculate Now",
		cal_pivot_Clear : "Clear",
		cal_pivot_CLASSIC : "CLASSIC",
		cal_pivot_WOODIE : "WOODIE'S",
		cal_pivot_CAMARILLA : "CAMARILLA",
		cal_pivot_DMARKS: "DMARKS'S",
		cal_pivot_Resistance : "Resistance",
		cal_pivot_Pivot_Points : "Pivot Points",
		cal_pivot_Support : "Support",
		cal_pivot_Field_req : "field is required",
		cal_pivot_PivotPoints :'Pivot Points',


		// profit_Loss.vue
		cal_profit_Loss : "Profit & Loss",
		cal_profitL_Txt : "Fxview’s profit and loss calculator is a basic tool that can assist you to calculate the profit or loss from a trade. Simply select the asset class, symbol, account base currency, the desired opening and closing prices, the position type and the trade size in lots, and press 'Calculate Now.'",
		cal_profitLField_req : "field is required",
		cal_profitL_accBaseCurr : "Account Base Currency",
		cal_profitL_Symbol : "Symbol",
		cal_profitL_Pos_Type : "Position Type",
		cal_profitL_Buy : "Buy",
		cal_profitL_Sell : "Sell",
		cal_profitL_Open_Price : "Open Price",
		cal_profitL_Close_Price : "Close Price",
		cal_profitL_trade_size_lot : "Trade Size (in lots)",
		cal_profitL_Now : "Calculate Now",
		// fibonacci.vue
		cal_Fibonacci : "Fibonacci",
		cal_fibo_txt : "With fxview’s fibonacci calculator, you can calculate fibonacci retracements based on the extreme points of a chart in an uptrend or a downtrend. Just put the high and the low values to get started.",
		cal_fibo_Uptrend : "Uptrend",
		cal_fibo_Downtrend : "Downtrend",
		cal_fibo_Field_req : "field is required",
		cal_fibo_High : "High",
		cal_fibo_Low : "Low",
		cal_fibo_Now : "Calculate Now",
		cal_fibo_Retracements : "Retracements",
		cal_fibo_Support : "Support",
		// Pip_Value.vue
		cal_Pip_Value : "Pip Value",
		cal_Pip_txt: "An effective tool for managing your risk strategy, our pip value calculator lets you calculate the value per pip of each position. With this tool you can monitor your risk for each trade with more precision.",
		cal_Pip_Field_req : "field is required",
		cal_Pip_accBaseCurr : "Account Base Currency",
		cal_Pip_Symbol : "Symbol",
		cal_Pip_trade_size_lot : "Trade Size (in lots)",
		cal_Pip_Now : "Calculate Now",
		// Swap.vue
		cal_swap : "Swap",
		cal_swap_txt : "Swaps can be thought of as the financing cost of keeping a position open. They can be either positive or negative, are paid/received when a position is kept open overnight. They are different for long and short positions, and vary across different instruments.",
		cal_swap_MT4_MT5 : "MT4/MT5",
		cal_swap_ACT : "ACT",
		cal_swap_Field_req : "field is required",
		cal_swap_accBaseCurr : "Account Base Currency",
		cal_swap_Symbol : "Symbol",
		cal_swap_Num_Days : "Number of Days",
		cal_swap_trade_size_lot : "Trade Size (in lots)",
		cal_swap_Swap_Long : ">Swap Long",
		cal_swap_Swap_Short : "Swap Short",
		// position_size.vue
		cal_Position_Size : "Position Size",
		cal_position_txt : "Fxview’s position size calculator helps you calculate how many lots of a position you can open, given a pre-determined amount you are willing to risk losing. Simply specify the asset class, account base currency, symbol, position type, open price & stop loss, account balance, and the risk percentage (i.e. the percentage of your account balance you are willing to risk losing), then press 'Calculate Now.'",
		cal_position_Field_req : "field is required",
		cal_position_accBaseCurr : "Account Base Currency",
		cal_position_Symbol : "Symbol",
		cal_position_Position_Type : "Position Type",
		cal_position_BUY : "BUY",
		cal_position_SELL : "SELL",
		cal_position_Open_Price : "Open Price",
		cal_position_Account_Balance : "Account Balance",
		cal_position_Stop_Loss : "Stop Loss",
		cal_position_Risk_Perc : "Risk Percentage",
		cal_position_trade_size_lot : "Trade Size in Lots",
		cal_position_trade_size_lot : "Trade Size in Lots",
		cal_position_Now : "Calculate Now",
		// currency_convertor.vue
		cal_curr_Convertor : "Currency Convertor",
		cal_curr_conv_txt : "Fxview’s currency converter allows users to check the value of one currency against others based on current exchange rates. With our currency converter, you can convert any two currencies with just a few clicks.",
		cal_curr_conv_From : "Currency From",
		cal_curr_conv_To : "Currency To",
		cal_curr_conv_Amount : "Amount",
		cal_curr_conv_Field_req : "field is required",
		cal_curr_conv_Now : "Calculate Now",
		cal_curr_conv_Converted : "Converted Currency",

		// left-menu .vue
		cal_leftmenu_commision :'Commission',
		cal_leftmenu_margin :'Margin',
		cal_leftmenu_multiTarget :'Multi-Target',
		cal_leftmenu_pivotpoints :'Pivot Points',
		cal_leftmenu_profitloss :'Profit & Loss',
		cal_leftmenu_fibonacci :'Fibonacci',
		cal_leftmenu_pipValue :'Pip Value',
		cal_leftmenu_Swap :'Swap',
		cal_leftmenu_positionSize :'Position Size',
		cal_leftmenu_currencyConv  :'Currency Convertor',


		//============================support folder================================================
		//============index
		suppIndex_requestServices :'Support Request',
		suppIndex_OpenRequests :'Open Request',
		suppIndex_ClosedRequests :'Close Request',

		//=============request-services
		suppReqService_support :'Support',
		suppReqService_howassist :'How can we assist you?',
		suppReqService_emailus :'Email Us',
		suppReqService_email :'support@fxview.com',
		suppReqService_liveChat :'Live Chat',
		suppReqService_avail24 :'Available 24/5',
		suppReqService_requestcallback :'Request Call Back',
		suppReqService_office :'Office: +4420 3150 2475',
		suppReqService_createTicket :'Create a Support Ticket',
		suppReqService_helpSupport :'How can we help?',
		suppReqService_back :'Back',
		profile :'Profile',
		Others :'Others',
		SubAffiliates :'Sub-Affiliates',
		PromotionalTools :'Promotional Tools',
		CommissionWithdrawals :'Commission Withdrawals',
		Commissionstructure :'Commission structure',
		Referrals :'Referrals',
		AddPaymentMethod :'Add Payment Method',

		//==============support
		support_ticketNumber :'Ticket Number',
		support_reason :'Reason',
		support_created :'Date',
		support_action :'Action',

		//===============view
		suppview_backToTicket :'Support Home',
		suppview_thankyou :'Thank you for verifying your identity, and welcome to Fxview! You can now open a Live trading account and start trading.',
		suppview_createliveAcc :'create live account',
		suppview_whilevalidate1:'While validating your proof of address document, we noticed that the address and ID number entered during registration does not match the document uploaded during verification.',
		suppview_whilevalidate2 :'While validating your proof of address document, we noticed that the address entered during registration does not match the document uploaded during verification.',
		suppview_whilevalidate3 :'While validating your proof of address document, we noticed that the ID number entered during registration does not match the document uploaded during verification.',
		suppview_originalAdress :'Original address',
		suppview_stepMsz18 :"I don't want to change anything",
		suppview_preQues :'Previous Question',
		suppview_nextQues :'Next Question',
		suppview_stepMsz21 :'Resolve conflict',
		suppview_idNumEnt :'ID number entered',
		suppview_percentComplete :'% Complete',
		suppview_nationalityEntered :'Nationality entered',
		suppview_fillone :'Please fill atleast one field',

		//========================services folder======================
		//==================otp verification

		otpVerif_otpVerification :'OTP Verification',
		otpVerif_otpVerificationText1 :'A OTP has been sent to your email.',
		otpVerif_resendOtpTicket :"Haven't received an email in your inbox or spam folder? Resend",
		otpVerif_back :'back',
		otpVerif_backToTicket :'Support Home',

		//====================profile-request
		profileReq_getHelpWith :'Get Help With',
		profileReq_Queries :'Related Queries',
		profileReq_relatedTopics :'Related Topics',
		profileReq_inversterPass :'In case if you face any issues setting investor password from your MT4/MT5 platform, Please proceed with creating the support request',
		profileReq_notSatisfied :"I'm not satisfied",
		profileReq_lodgeComplaint :'Submit a complaint',
		profileReq_helpUsWithYour :'Help us with your',
		profileReq_askOtherQuestions :'Ask us any other question',
		profileReq_AddBankDetails :'Add Bank Details',
		profileReq_AddSkrillDetails :'Add Skrill Id Details',
		profileReq_AddNetellerDetails :'Add Neteller Id Details',
		profileReq_AddCreditCardDetails :'Add Credit Card Details',
		profileReq_inn :'in',
		profileReq_emailHeading :'Please Enter your new email ID below',
		profileReq_exsistsEmailAddress :'Existing Email Address',
		profileReq_newEmail :'Enter Your New Email Address',
		profileReq_EmailfieldValid :'Please enter a valid email address',
		profileReq_EmailfieldReq :'Email field is required',
		profileReq_changeEmailAddress :'Change Email Address',
		profileReq_mobileHeading :'Please Enter Your New Mobile Number Below',
		profileReq_existingMobileNumber :'Existing Mobile Number',
		profileReq_InvalidNumber :'Invalid Number',
		profileReq_changeMobileNumber :'Change Mobile Number',
		profileReq_postCodeRequired :'The post code is required',
		profileReq_residenceCountryRequired :'The residence country is required',
		profileReq_uploadRecentAddressProof :'Upload recent address proof ',
		profileReq_docReq :'document is required',
		profileReq_changeAddress :'Change Address',
		profileReq_bankName :'Bank Name:',
		profileReq_AccountName :'Account Name',
		profileReq_bankNameRequired :'The bank name is required',
		profileReq_accountHolderRequired :'The account holder name is required',
		profileReq_AccNumber :'Account Number:',
		profileReq_accountNumberRequired :'The account number is required',
		profileReq_country :'Country',
		profileReq_countryFieldRequired :'The country field is required',
		profileReq_IBAN :'IBAN',
		profileReq_ibanRequired :'The iban is required',
		profileReq_MyBankNotIBAN :'My Bank Doesn’t issue IBAN',
		profileReq_SwiftCode :'Swift/BIC/Sort Code',
		profileReq_swiftCodeRequired :'The swift code is required',
		profileReq_bankAdd :'Bank Address:',
		profileReq_bankAddressRequired :'The bank address is required',
		profileReq_UpBankStatement :'Upload Bank Statement',
		profileReq_fileallow :'Only jpg, jpeg, png, pdf, PDF, JPG, JPEG, PNG, docx, doc, xls, xlsx files are allowed!',
		profileReq_addNewBank :'Add a New Bank Account',
		profileReq_last4Digit :'last 4 digits is required and contains only numeric character',
		profileReq_first4Digit :'first 4 digits is required and contains only numeric character',
		profileReq_frontBack :'We require the following for the card verification -',
		profileReq_frontPhotoCredit :'Color copy of the front side of the card, showing: full name, expiration date, Bank name/logo, first 4 and last 4 digits of the credit card number hiding the middle 8 digits.',
		profileReq_uploadSupportingDocument :'Upload a Supporting Document',
		profileReq_backPhotoCredit :'Color copy of the back side of the card hiding the CVV security code. The back copy should shown the sign of the holder',
		profileReq_submit :'Submit',
		profileReq_paymentRequiredNumeric :'The payment id field is required and may only contain numeric characters.',
		profileReq_note :'Please note that in case of USDC or USDT address, the only supported network on Fxview is ERC20, Please provide ERC20 network wallet address in order to process the withdrawal',
		profileReq_netSkrill1 :'please upload the screenshot of the',
		profileReq_netSkrill2 :'profile contacting the full name,',
		profileReq_netSkrill3 :'id and address. We are going to match the name and address',
		profileReq_userDetails :'User Details',
		profileReq_ComplaintDetails :'Complaint Details',
		profileReq_employeeWhoOffered :'Employee who offered the services to the Client:',
		profileReq_timeDisputed :'Date and Time of the disputed situation (in MetaTrader server time):',
		profileReq_TheDisputeTime :'The dispute time is required',
		profileReq_ticNoContested :'Ticket Number(s) of all contested positions and/or pending orders:',
		profileReq_DisputedAmount :'Disputed amount:',
		profileReq_reportComplaint :'Have you reported your complaint to any Supervisory Authority?',
		profileReq_stateNameAuth :'Please state the name of the Supervisory Authority',
		profileReq_TheAuthorityName :'The authority name is required',
		profileReq_DetailedDescript :'Detailed description of the Complaint:',
		profileReq_attachTogetherForm :"Please attach together with this form any supporting evidence to your claim that will facilitate fxview's investigation of your complaint. Supporting evidence may consist of any documentation (screenshots, chats, phone records etc) relevant to the complaint.",
		profileReq_Subject :'Subject',
		profileReq_yourMsz :'Your Message',
		profileReq_ticketHasbeenComplaint :'Your complaint has been Registered successfully',
		profileReq_ticketHasbeenCreated :'Your ticket has been created',
		profileReq_proMsz19 :'Go to Tickets',
		profileReq_entervalidcard :'please enter valid card number',
		profileReq_changeEmail :'Please Change my email as per following details <br> Old Email :',
		profileReq_NEWEmail :'<br> New Email :',
		profileReq_changeMobile :'Please Change my Mobile Number as per following details <br> Old Number : ',
		profileReq_newNumber :'<br> New Number :',
		profileReq_changebankinfo :'Please Change my Bank Information as per following details <br> Account Number :',
		profileReq_holdername :'<br> Holder Name :',
		profileReq_bankname :'<br> Bank Name : ',
		profileReq_bankcode :'<br> Bank Code :',
		profileReq_sortcode :'<br> Sort Code :',
		profileReq_bankAddress :'<br> Bank Address :',
		profileReq_changeadress :'Please Change my Address as per following details <br> Address1 : ',
		profileReq_adresstwo :'<br> Address2 :',
		profileReq_postcode :'<br> Post Code :',
		profileReq_residenceCountry :'<br> Residence Country :',
		profileReq_nation :'<br> Nationality : ',
		profileReq_City :'<br> City :',
		profileReq_pleaseAdd :'Please Add',
		profileReq_paymentmethod :'Payment Method per following details <br>',
		profileReq_number :'Number :',
		profileReq_expiryDate :'<br> Expiry Date :',
		profileReq_id :'Id :',
		profileReq_trading : 'Trading Account',
		profileReq_wallet : 'Wallet',
		profileReq_tradingHeading : 'Link your account',
		profileReq_tradingAccount : 'Please Link Trading Account ',
		profileReq_exsistsTradingAccount : 'Enter Trading Account',
		profileReq_walletNumber : 'Please Link Wallet Number',
		profileReq_exsistsWalletNumber : 'Enter Wallet Number',
		profileReq_tradingPlatformPlaceholder : 'Please select Trading Platform',
		profileReq_walletCurrencyPlaceholder : 'Please select Wallet Currency',
		profileReq_tradingPlatform : 'Trading Platform',
		profileReq_walletCurrency : 'Wallet Currency',
		profileReq_linkTradingAccount : 'LINK',
		ChangeClientPortalPassword: "<p><span>Please follow these steps to change your client area password:</span></p><ul><li><p><span>Click on the square with your initials on the top right corner of the client portal area</span></p></li><li><p ><span>Click on &lsquo;Change Password&rsquo; or directly click&nbsp;</span><a href='https://app.fxview.com/change-password' target='_blank'><span>HERE</span></a></p</li><li><p ><span>Enter your old password</span></p></li><li><p ><span>Enter the new password you would like to use</span></p></li><li><p ><span>Click on &lsquo;Change Password&rsquo;</span></p></li></ul><p><span>Your password is now changed</span></p>",
		ProfessionalAccountRequest:"<p><span>To know about the Professional Client categorisation policy, please click&nbsp;</span><a href='https://fxview.com/static/fxview/pdf/legal-document/Client-Categorisation-Procedure.pdf' target='_self'><span>HERE</span></a><span>. To apply for a professional client, please click&nbsp;</span><a href='https://app.fxview.com/pro' target='_self'><span>HERE</span></a></p>",
		AccountVerificationIndividual:"<p><span>we do need to do KYC and require the following documents for complete account verification:</span></p><p><span>* A proof of your residence which can be a utility bill or a bank statement in your own name and address dated within the last 6 months</span></p><p><span>* A proof of your identity, which can be your government issued photo id, passport, or a driving licence. You will need this document at hand during the In-Person-Verification (IPV) process.&nbsp;</span></p><p><span>*IPV is in person verification where a client needs to show and take an image of the front and back of his valid ID card and take his selfie. Once the pictures are taken, they will be automatically uploaded in your profile and are necessary for the account verification. IPV can be done in the secured client area&nbsp;</span><a href='https://app.fxview.com/'><span>HERE</span></a></p>",
		Enable2FA: "<p><span>Please follow these steps to enable 2FA on your client area:</span></p><ul ><li><p><span>To enable 2FA click&nbsp;</span><a href='https://app.fxview.com/two-fa' target='_self'><span>HERE</span></a></p></li><li><p><span>Click on enable and you will see a QR Code on your screen</span></p></li><li><p><span>Download the google authenticator app on your mobile and scan the code through the app</span></p></li><li><p><span>Once the code is scanned, you will see a numeric code on your google authenticator app</span></p></li><li><p><span>Enter that google authentication code where it says &ldquo;Google Authenticator Code&rdquo; and click on &ldquo;Enable&rdquo;</span></p></li></ul><p><span>2FA is now enabled</span></p>",
		Disable2FA: "<p><span>Please follow these steps to disable 2FA on your client area:</span></p><ul ><li><p><span>To disable 2FA click&nbsp;</span><a href='https://app.fxview.com/two-fa' target='_self'><span>HERE</span></a></p></li><li><p><span>Enter that google authentication code for fxview</span></p></li><li><p><span>Click on disable</span></p></li></ul><p><span>2FA is now disabled.</span></p>",
		ClientAreaPasswordReset : "<p><span>In order to reset the password of your client area, please click on &ldquo;Forgot Password&rdquo; at the time of login. Once you click on it, enter your registered email address and you will receive a link to reset the password. You&rsquo;ll then be asked to enter your new password twice, and click &lsquo;Reset Password&rsquo; to complete the process.</span></p>",
		AccountClosure : "<p><span>We are sorry to hear that you want to close your fxview account. If you are facing any kind of issue with your account, please feel free to contact us Via Live Chat , Email or Call so we can look into the issue and provide you the required assistance.&nbsp;</span></p><p><span>Should you still choose to close your account, please proceed with the support request.</span></p><p><span>Please note that in case you have any open positions in your account, all the positions will be closed at the prevailing market price and withdrawal of remaining funds will be processed to you</span></p><p><span>In case you wish to cancel your account closure request in the meantime, please feel free to contact us via Live Chat, phone or email, and we will be glad to assist.</span></p>",
		DeleteLiveAccount : "<p><span>You cannot delete a live trading account with transactions in it however, you can delete a live account without transactions. Please note that in case you delete the account once, you would not be able to retrieve or access it or its any related trading history in future. Please proceed to raise a ticket in order to delete the account</span></p>",
		DeleteDemoAccount : "<p><span>Please note that in case you delete the account once, you would not be able to retrieve or access it or its any related trading history in future. Please proceed to raise a ticket in order to delete the account</span></p>",
		MarginCallInquiry:"<p><span>Our margin call/stop out levels are 70%/50% which means if your account equity falls below 70%, you will receive a margin call notification on your trading platform and if your equity falls below 50% of the used margin, system will start closing out your positions automatically one by one and the position incurring maximum loss will be closed out first.&nbsp;</span></p><p><span>Getting a margin call depends on the margin utilized by the open positions in your account and it is client&rsquo;s responsibility to monitor the open positions at all times and ensure there are sufficient funds in the account to support open positions in the account.</span></p>",
		InvestorPasswordRequest : "<p><span>Please follow these steps in order to set an investor password for your trading account</span><span>.</span></p><ul ><li><p><span>Login to your MT4/MT5 account</span></p></li><li><p><span>Click on Tools &gt; Options &gt; Server &gt; Change</span></p></li><li><p><span>Enter your master password</span></p></li><li><p><span>Select - change investor (read only) password</span></p></li><li><p><span>Enter your new password and enter the same in confirm&nbsp;</span></p></li><li><p><span>Click on ok</span></p></li></ul>",
		UnabletoDownloadPlatform:"<p><span>Please follow these steps to download platform:</span></p><p><span>Click on the profile icon &gt; Download Platform</span></p>",
		Changeleverage: "<p><span>Increasing your leverage is subject to your client classification. Retail Clients can trade on a maximum of 30x leverage. Professional Clients can trade on leverage of up to 500x. You can read more about client classification&nbsp;</span><a href='https://fxview.com/static/fxview/pdf/legal-document/Client-Categorisation-Procedure.pdf' target='_self'><span>HERE</span></a><span>.&nbsp;</span></p><p><span>Please follow these steps to change the leverage:</span></p><ul ><li><p><span>Click on manage account</span></p></li><li><p><span>Click on change leverage</span></p></li><li><p><span>Select your trading account</span></p></li><li><p><span>Choose the leverage you want</span></p></li><li><p><span>Click on submit</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request&nbsp;</span></p></li></ul><p><span>Your leverage will then be updated.</span></p>",
		TradeOrderInquiry : "<p><span>If you want any trade to be investigated, please provide the following information:</span></p><ul ><li><p><span>Trading Account ID</span></p></li><li><p><span>Trade order ID</span></p></li><li><p><span>Time when you faced the issue</span></p></li><li><p><span>Exact issue you faced&nbsp;</span></p></li><li><p><span>Relevant screenshots</span></p></li></ul>",
		TradingAccountStatement: "<p><span>Yes, you can generate your own account statements. Please follow the below steps in order to generate your trading account statement.</span></p><p><span>For MT4:&nbsp;</span></p><ul ><li><p><span>Log in to your MT4 platform</span></p></li><li><p><span>Click on the &quot;Account History&quot; tab at the bottom of the terminal</span></p></li><li><p><span>Right click within the Terminal table displayed, and then click on &quot;All History&quot;</span></p></li><li><p><span>All your trading history has now been pulled into the Terminal window. Next, right click on the table displayed and click on &quot;Save as Detailed Report&quot;</span></p></li><li><p><span>Choose the destination where you would like to save the report</span></p></li><li><p><span>Click on &ldquo;Save&rdquo;</span></p></li></ul><p><span>The report will be downloaded in HTML format.</span></p><p><span>For MT5:</span></p><ul ><li><p><span>Log in to your MT5 platform</span></p></li><li><p><span>Click on the &quot;History&quot; tab at the bottom of the terminal</span></p></li><li><p><span>Right click within the Terminal table displayed, and then click on &quot;All History&quot;</span></p></li><li><p><span>All your trading history has now been pulled into the Terminal window. Next, right click on the table displayed &gt; Report &gt; and choose to download the report as XML or HTML.</span></p></li><li><p><span>Choose the destination where you would like to save the report</span></p></li><li><p><span>Click on &ldquo;Save&rdquo;</span></p></li></ul><p><span>The report will be downloaded in the XML/HTML format.</span></p><p><span>For Act Trader:&nbsp;</span></p><ul ><li><p><span>Log in to your ActTrader platform</span></p></li><li><p><span>Click on Reports</span></p></li><li><p><span>Click on Account Statement</span></p></li><li><p><span>Choose time format (for which you want to generate the report)</span></p></li><li><p><span>Click on &ldquo; run report&rdquo;</span></p></li><li><p><span>Click on export to excel to export the report</span></p></li></ul><p><span>Your report will be downloaded</span></p>",
		Changetradingaccountpassword: "<p><span>You can change the password of your trading account from your platform, In case you face any issues while changing the password from your platform, please follow these steps to change the password from your client area.</span></p><ul ><li><p><span>Scroll all the way to the left with your mouse, to expand the left-hand menu bar</span></p></li><li><p><span>Click on &lsquo;Manage Account&rsquo;</span></p></li><li><p><span>Click on &lsquo;Change Password&rsquo;</span></p></li><li><p><span>Select your trading account</span></p></li><li><p><span>Enter the new password and confirm it</span></p></li><li><p><span>Click on &lsquo;Change Password&rsquo;</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request</span></p></li></ul><p><span>Your trading account password is now changed.</span></p>",
		Unabletologintoplatform : "<p><span>Please review the following errors along with their solutions:</span></p><p><span>Invalid Account Error-</span></p><p><span>Please review your trading account ID and password. This error comes when either the trading account id or the password that you are entering is wrong</span></p><p><span>No Connection Error-</span></p><ul ><li><p><span>Review the server name you are entering while logging in to the trading account. Please make sure you have entered fxview-live for live account and fxview-Demo for the demo account</span></p></li><li><p><span>In case the error persists, please follow these steps:</span></p></li><li><p><span>Go to &nbsp;&ldquo;File&rdquo; option on the menu bar and select &ldquo;Open an account&rdquo;</span></p></li><li><p><span>Type &ldquo;fxview&rdquo; in the &ldquo;add new broker box&rdquo; and click on &ldquo;Find your broker&rdquo;</span></p></li><li><p><span>Select &ldquo;fxview&rdquo; and click on &ldquo;Next&rdquo;</span></p></li><li><p><span>Click on &ldquo;Connect with an existing trading account&rdquo; and enter your login credentials</span></p></li><li><p><span>To log in to a Live account select server name &ldquo;fxview-Live&rdquo; or &ldquo;fxview-Demo for Demo account from the drop-down menu and click on &ldquo;Finish&rdquo;.</span></p></li></ul><p><span>Authorisation Failed Error-&nbsp;</span></p><p><span>This error comes up when you are trying to login to the trading account on the phone. In this case, Please review your trading account ID and password. This error comes when either the trading account id or the password that you are entering is wrong</span></p>",
		InternalTransfer: "<p><span>Please follow these steps to transfer funds between your trading accounts:</span></p><ul ><li><p><span>Scroll all the way to the left with your mouse, to expand the left-hand menu bar</span></p></li><li><p><span>Click on &lsquo;Manage Account&rsquo;</span></p></li><li><p><span>Click on &lsquo;Internal Transfer&rsquo;</span></p></li><li><p><span>Select the accounts you would like to send funds from and to&nbsp;</span></p></li><li><p><span>Enter the amount you want to transfer</span></p></li><li><p><span>Click on &lsquo;Internal Transfer&rsquo;</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request</span></p></li></ul><p><span>Your internal transfer is done.</span></p>",
		SwapCharges: "<p><strong><span>What are swaps?</span></strong></p><p><span>When positions are held overnight, a swap is charged. It is either debited from or credited to your trading account depending on the instrument you are trading and the position size you have.&nbsp;</span></p><p><span>You can check the swap charges in the instrument specification list&nbsp;</span><a href='http://dev.fxview.com/global/forex' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or calculate swaps using our Swap calculator available on our website&nbsp;</span><a href='http://dev.fxview.com/global/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or within your trade terminals by following the steps below:</span></p><p><span>MT5/MT5:</span></p><p><span>Right click on any instrument in the &#39;Market Watch&#39; section &gt; left click on the &#39;Specification&#39; button. A new window will open that will show the swap rates for the instrument selected.</span></p><p><span>ActTrader:</span></p><p><span>On the &lsquo;Instruments&rsquo; tab, swaps are listed under &lsquo;Roll. Sell&rsquo; and &lsquo;Roll. Buy&rsquo;</span></p><p><strong><span>Where can I check swap charges?</span></strong></p><p><span>You can check the swap charges in the instrument specification list&nbsp;</span><a href='http://dev.fxview.com/global/forex' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or calculate swaps using our Swap calculator available on our website&nbsp;</span><a href='http://dev.fxview.com/global/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or within your trade terminals by following the steps below:</span></p><p><span>MT5/MT5:</span></p><p><span>Right click on any instrument in the &#39;Market Watch&#39; section &gt; left click on the &#39;Specification&#39; button. A new window will open that will show the swap rates for the instrument selected.</span></p><p><span>ActTrader:</span></p><p><span>On the &lsquo;Instruments&rsquo; tab, swaps are listed under &lsquo;Roll. Sell&rsquo; and &lsquo;Roll. Buy&rsquo;</span></p><p><strong><span>When are swaps charged?</span></strong></p><p><span>Swaps are charged daily between Monday-Friday at 23:59:59 GMT+3 during DST and GMT+2 during non-DST.&nbsp;</span></p><p><span>They are credited into or debited from the account balance once the position is closed. While the position remains open, swaps are reflected in the equity.</span></p><p><span>To account for the weekend, 3 day swaps are charged at some point during the week. The day on which 3 day swaps are charged depends on the instrument traded, and can be summarised as follows:</span></p><p><span>Currencies and commodities: Wednesday</span></p><p><span>USDCAD, USDTRY, EURRUB and USDRUB: Thursday</span></p><p><span>Indices: Friday</span></p><p><strong><span>How are swap charges calculated?</span></strong></p><p><span>Swap charges are set according to the interest rate differential between the two currencies in the pair, and are different for long and short positions. They are charged by the liquidity provider itself. You can look up swap charges through our swap calculator&nbsp;</span><a href='http://dev.fxview.com/global/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;.&nbsp;</span></p><p><span>Formula for swap charges calculation is as follows:&nbsp;</span><span><br></span><span>Swap = No. of Lots* Swap Points* Contract Size* Minimum Price Fluctuations* Days * Conversion price to account base currency</span></p>",
		Slippage: "<p><span>What is slippage?</span></p><p><span>Slippage is when the price at which the trade is executed is different from the expected price.&nbsp;</span></p><p><span>It is very common in forex trading, especially when trading in higher lot sizes.&nbsp;</span></p><p><span>As we are an ECN broker, we pass all your trades directly to our LPs. Depending on the size of the trade, sometimes they might not have enough liquidity to fill the entire trade at the shown price, so a part will be filled at the next best available price(s), which is essentially &lsquo;slippage&rsquo;. You can look up our DOB (Depth of Book) in a live account, by right clicking on an instrument within the &lsquo;Market Watch&rsquo; window and clicking on &nbsp;&lsquo;Depth of Market&rsquo;. This will show you the volumes available at each price. Market orders are executed at VWAP (Volume Weighted Average Price).</span></p><p><span>How much is your slippage?</span></p><p><span>Slippage is something which cannot be controlled by a broker - it&#39;s an inherent part of trading, and common in the forex market. While placing an order in the market, you are requesting your order to be filled at the market price you are seeing on the terminal at that exact moment. However, the market moves between the time your order is placed and the time it is filled. Therefore, it&#39;s possible that it will be filled at a different price from the one you saw when you clicked to trade, and this difference is called &lsquo;slippage&rsquo;.&nbsp;</span></p><p><span>Whether you will experience slippage while trading depends on market volatility and liquidity at the time you are trading. Generally, it increases during volatile times such as news releases (as many orders are going into the market within a short space of time and being matched against one another, causing the market price to fluctuate rapidly) or illiquid market conditions such as market opening or closing time (as there are &nbsp;few orders available in the market, and a large trade might need to be filled at several different prices, causing the market to move).&nbsp;</span></p><p><span>Please note that the higher your position size, the higher the chances that you will experience slippage. Market orders are executed at VWAP (Volume Weighted Average Price)</span></p>",
		Howtodeposit: "<p><span>Adding funds to your Fxview trading account is very simple and easy. We offer a wide range of deposit options so you can make instant deposits to your trading account. All deposits and withdrawals are processed with no fees from Fxview</span></p><p><span>Please follow these steps to fund your trading account:</span></p><ul><li><span>-&nbsp;</span><span>Sign in to your Fxview secure client area&nbsp;</span><a href='https://app.fxview.com/' target='_blank'><strong><u><span >HERE</span></u></strong></a></li><li><span >-&nbsp;</span><span>Scroll to the left of the screen to expand the menu, then click on &ldquo;Deposit&rdquo; &gt; &ldquo;Add Deposit&rdquo;</span></li><li><span >-&nbsp;</span><span>Click on the Trading Account you want to add funds into and click on &ldquo;Deposit Funds&rdquo;</span></li><li><span >-&nbsp;</span><span>Specify the amount you want to deposit</span></li><li><span >-&nbsp;</span><span>Choose a deposit method</span></li><li><span >-&nbsp;</span><span>Read the instructions carefully and please make sure all the details are correct before proceeding with the transaction. As indicated on screen, processing times vary according to the funding method selected.</span></li><li><span >-&nbsp;</span><span>Click on &ldquo;Proceed to Payment&rdquo;</span></li><li><span >-&nbsp;</span><span>Follow the prompts and confirm the payment</span></li><li><span >-&nbsp;</span><span>Once the transaction is approved, the deposited amount will appear in your trading account. Please note that this process is not instant for Bank Transfers.</span></li></ul><p><span>You can see all your transaction history&nbsp;</span><a href='https://app.fxview.com/deposit-list' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		DepositMethods : "<p><span>Following are the supported for account funding:</span></p><ul><li><span>-&nbsp;</span><strong><span>Bank Wire</span></strong><span>&nbsp;:</span></li></ul><ul><li><span>●&nbsp;</span><span>Bank of Lithuania via epayBlock: 100 Euros minimum deposit</span></li><li><span>●&nbsp;</span><span>Handelsbank via MoneyNetint: 1000 Euros minimum deposit</span></li><li><span>●&nbsp;</span><span>Funds are credited within 12 working hours of receiving funds in our bank accounts</span></li><li><span >●&nbsp;</span><span>No cost is charged from Fxview side however the correspondent bank may charge you for the wire transfer. Also please note that deposit amount below the prescribed limit is subject to a charge of 20 EUR</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>Credit/Debit Cards:</span></strong></li></ul><ul><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>VISA and MasterCard&nbsp;</span></li><li><span >●&nbsp;</span><span>100 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from Fxview side however your card provider may charge you for the transaction</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>E-wallets&nbsp;</span></strong><span>:&nbsp;</span></li></ul><ul><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>Neteller and Skrill</span></li><li><span >●&nbsp;</span><span>10 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from Fxview side however neteller or skrill may charge you for the transaction</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>APMs:</span></strong></li></ul><ul><li><span >●&nbsp;</span><span>Rapid, Klarna, Giropay, Przelewy24 and Nordea&nbsp;</span></li><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>5 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from Fxview side however neteller or skrill may charge you for the transaction</span></li><li><span >●&nbsp;</span><span>Only available for deposits</span></li></ul><p><span>Please note that there may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		Fundsnotcredited: "<p><span>Following is the processing time for deposits:</span></p><ul ><li><span>-&nbsp;</span><span>Bank Wire ( Funds are credited within 12 working hours of receiving funds in our bank accounts)</span></li><li><span >-&nbsp;</span><span>Credit/Debit Cards (Instant)</span></li><li><span >-&nbsp;</span><span>E-wallets - Skrill , Neteller</span></li><li><span >-&nbsp;</span><span>APMs - Rapid, Klarna, Giropay, Przelewy24 and Nordea (Instant)</span></li></ul><p><span>Please be aware that there may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		DepositTransactionHistory : "<p><span>Please check your transaction history under Deposit &gt; Deposit List</span></p>",
		Howtowithdraw : "<p><span>You can withdraw from your trading account by submitting a withdrawal request from your secure client area&nbsp;</span><a href='https://app.fxview.com/withdrawal' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.&nbsp;</span></strong><span>Please follow these steps in order to withdraw from your trading account:</span></p><ul ><li><span >-&nbsp;</span><span>Go to &ldquo;Withdraw&rdquo; &gt; &ldquo;Withdrawal&rdquo;</span></li><li><span >-&nbsp;</span><span>Select your Trading Account you want to withdraw funds from and you will see the available withdrawable amount</span></li><li><span >-&nbsp;</span><span>Select your withdrawal method</span></li><li><span >-&nbsp;</span><span>Enter the amount you want to withdraw</span></li><li><span >-&nbsp;</span><span>Click on submit</span></li><li><span >-&nbsp;</span><span>You will receive a confirmation link on your registered email address</span></li><li><span >-&nbsp;</span><span>Click on the link to confirm your request</span></li></ul><p><span>Once the withdrawal is approved, it will be processed within the stipulated time.</span></p><p><span>Please note that withdrawal of principal amount will be processed via the same payment gateway to the same account you used while funding the account. To know more about our withdrawal policy, please click&nbsp;</span><a href='https://fxview.com/account-funding' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		Withdrawalerror : "<p><span>Please make sure you have entered the correct information while placing the withdrawal request. &nbsp;In case the issue persists, please proceed with creating the ticket. Please make sure to provide the detailed information on what exact issue you are facing and upload the relevant screenshot of the error you are getting so we can investigate the issue.</span></p><p><span>Note: your deposited amount will be transferred back to the original source and to the same account that you used to fund the account. While, the rest of the amount (profits) can be withdrawn via any other supported payment method except credit cards. Please review the withdrawal policy for details.</span></p>",
		WithdrawalMethods: "<p><span>As per our &nbsp;Deposits and Withdrawals Policy, withdrawals are processed via the same method by which funds were initially &nbsp;deposited in the trading account.</span></p><p><span>Following, are the supported methods for withdrawals:</span></p><ul ><li><span >-&nbsp;</span><span>Bank Wire:</span></li></ul><ul><li><span >●&nbsp;</span><span>minimum amount - Euros 100</span></li><li><span >●&nbsp;</span><span>processed within the business hours of the same working day after we receive the request however it may take 1-7 working days for funds to appear in bank your account as its an international wire transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from Fxview side, however, the correspondent bank may charge you for the wire transfer</span></li></ul><ul ><li><span >-&nbsp;</span><span>Credit/Debit Cards:</span></li></ul><ul><li><span >●&nbsp;</span><span>Minimum amount - Euros 100</span></li><li><span >●&nbsp;</span><span>processed within the business hours of same working day after we receive the request</span></li><li><span >●&nbsp;</span><span>The total withdrawal amount cannot exceed the total deposit amount processed via the same card</span></li><li><span >●&nbsp;</span><span>Fxview does not charge any fees, &nbsp;however, your card provider may charge you for the transaction.</span></li></ul><ul ><li><span >-&nbsp;</span><span>E-wallets -&nbsp;</span></li></ul><ul><li><span >●&nbsp;</span><span>Skrill and Neteller : Minimum amount - 10 Euros&nbsp;</span></li><li><span >●&nbsp;</span><span>Processed within the business hours of the same working day after we receive the request</span></li><li><span >●&nbsp;</span><span>No transaction cost is charged by Fxview, however, Neteller,Skrill or your bank may charge you for the transaction</span></li><li><span >●&nbsp;</span><span>Amounts withdrawn should be equal with the amounts deposited via these methods plus profits if applicable.&nbsp;</span></li></ul><ul ><li><span >-&nbsp;</span><span>APMs ( Rapid, Klarna, Giropay, Przelewy24 and Nordea) -&nbsp;</span></li></ul><p style='margin-left:72.0000pt;'><span>Only available for deposits. Withdrawals will be processed via bank wire.&nbsp;</span></p><p><span>There may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		Withdrawalpolicy : "<p><span>We understand that fast and easy withdrawals are important to the traders hence we have formulated efficient fund withdrawal policies. The withdrawal request procedure can be completed online and is designed keeping security policies in mind.&nbsp;</span></p><p><span>We support multiple payment gateways for withdrawal. However the method available to you depends on the deposit method you used while initially funding your account.&nbsp;</span></p><p><span>According to the withdrawal policies:</span></p><ul ><li><span >-&nbsp;</span><span>Your deposited amount will be transferred back to the original source and to the same account that you used to fund the account.&nbsp;</span></li><li><span >-&nbsp;</span><span>The amount of profits can be withdrawn via any other supported payment method available except for credit cards.&nbsp;</span></li><li><span >-&nbsp;</span><span>Please note that your bank account, card or the wallet ID should be in the same name as on the account maintained on record with Fxview and should be verified prior making any deposit and withdrawal.</span></li><li><span >-&nbsp;</span><span>For amounts meeting the required limits, Fxview does not charge withdrawal fees for bank wire transactions. However, the sending and correspondent bank may charge a transaction fee.</span></li><li><span >-&nbsp;</span><span>Please note that a fee of 5 EUR will be charged if the withdrawal amount is less than the prescribed minimum withdrawal amount.</span></li><li><span >-&nbsp;</span><span>Withdrawal requests will be processed only if placed via the secure client area. .</span><spanstyle='color:rgb(255,255,0);color:rgb(255,255,0);'>&nbsp;</span><span>Requests sent over email or live chat will be directed to the secured client area and therefore may result in delays.</span></li><li><span >-&nbsp;</span><span>Withdrawals are processed within the business hours of the same working day after we receive the request.</span></li><li><span >-&nbsp;</span><span>APMs are only available for deposits. Withdrawals for funds deposited via these methods will be processed via bank wires only.</span></li></ul><p><span>To know more about our withdrawal policy, please click&nbsp;</span><a href='https://fxview.com/account-funding' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		Withdrawalnotreceived : "<p><span>Typically, withdrawals are processed within the business hours of the same working day after we receive the request. Once we have processed your withdrawal request, please allow 1 -7 business days for the funds to reach you. This will vary depending on the withdrawal method you have used. Usually, withdrawals processed using e-wallets or credit cards are much faster than wire transfers, and are reflected within the same day. Please note the processing times for withdrawals via different methods:</span></p><ul ><li><span >-&nbsp;</span><span>Bank Wire:</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed &nbsp;within the business hours of the same working day after we receive the request, however, it may take 1-7 working days for funds to appear in your account due to wire transfer.</span></p><ul ><li><span >-&nbsp;</span><span>Credit/Debit Cards:</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed within the business hours of the same working day after we receive the request, however, it may take 1 to 7 working days for funds to be reflected into your account.</span></p><p style='margin-left:72.0000pt;'><span>Since we rely on third parties to facilitate the transfer of funds in and out of your account, delays may occur.</span></p><ul ><li><span >-&nbsp;</span><span>E-wallets - Skrill , Neteller&nbsp;</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed within the business hours of same working day after we receive the request, most of the time it reflects instantly however It can take 1 working day for funds to be reflected into your account</span></p><ul ><li><span >-&nbsp;</span><span>APMs- &nbsp;Rapid, Klarna, Giropay, Przelewy24, Nordea:</span></li></ul><p style='margin-left:72.0000pt;'><span>Withdrawals can only be processed via bank wire transfers to the same bank account from which deposits were made via these e-wallets. Therefore, transfers are processed &nbsp;within the business hours of the same working day after we receive the request, however, it may take 1-7 working days for funds to appear in your account due to wire transfer.</span></p>",
		Minimumwithdrawal : "<p><span>Bank Wire: Euros 100</span></p><p><span>Credit/Debit Cards: Euros 100</span></p><p><span>E-wallets - Skrill, Neteller: Euros 10&nbsp;</span></p><p><span>Please note that APMs are only available for deposits. Also, Withdrawal requests below the minimum limits are subject to the processing fees of EUR 5.</span></p>",
		ApplyforVPS : "<p><span>Please follow these steps to apply for VPS:</span></p><ul ><li><span >-&nbsp;</span><span>Click on Tools &gt; VPS &gt; Create New</span></li></ul><p><span>Please note: &nbsp;If you maintain a monthly balance of $5000 in total in your trading accounts, you can avail it for free, however, if you fail to meet the condition, the basic VPS is chargeable at $25 per month which will be deducted from your trading account.&nbsp;</span></p>",
		VPSplansandspecifications : "<p><span>We have three VPS plans-</span></p><p><span>Basic:&nbsp;</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $25</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $5,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>2 GB Memory / 2 VCPU</span></li><li><span >-&nbsp;</span><span>50 GB SSD Disk Space</span></li></ul><p><span>Standard:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $40</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $20,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>4 GB Memory / 3 VCPU</span></li><li><span >-&nbsp;</span><span>100 GB SSD Disk Space</span></li></ul><p><span>Premium:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $60</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $50,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>6 GB Memory / 4 VCPU</span></li><li><span >-&nbsp;</span><span>150 GB SSD Disk Space</span></li></ul>",
		UnabletoConnect : "Please be advised that VPS is activated within 30 minutes after you receive the login credentials. In case the issue persists, Please provide the screenshot of error",
		VPSpasswordchange : "<p><span>To change the password of VPS, please follow the given steps:</span></p><p><span>Click the start tab in the VPS window--&gt;Administrative tools--&gt;Computer Management--&gt;Local users and groups--&gt;Users--&gt;Administrator. Please right click on the &quot;Administrator&quot; option and select the option &quot;set password&quot;</span></p>",
		VPSCancellation : '<p><span >Please note that if monthly fees for the paid VPS is already deducted from the account, it will not be reimbursed back after the cancellation of VPS</span></p>',


		//=======================tradingtools================================
		//==============autochartist scanner
		autoscan_AutochartistScanner :'AutoChartist Scanner',
		autoscan_IBintegrateAdvancedTool :'AutoChartist is a premier chart pattern recognition software that scans trading instruments and automatically recognizes trade set-ups based on breakouts, retracements, support and resistance levels so that you never miss an opportunity again.',
		autoscan_closeMt4 :'Log In to your fxview MT4 account.',
		autoscan_DownloadRunAuto :'Download and run AutoChartist Scanner application.',
		autoscan_SelectPortfoliosTrading :'Select fxview MT4 Platform and proceed with the installation.',
		autoscan_RestartMt4Platform :'Restart fxview MT4 platform.',
		autoscan_autochartistdesc :'Autochartist Scanner can be used on the live MT4 account with a minimum deposit amount of $200.',
		autoscan_DisclaimerAutoChartist :'Disclaimer : The posts on this page are considered marketing communication and do not contain, and should not be construed as containing, investment advice or an investment recommendation or, an offer of or solicitation for any transactions in financial instruments. Past performance is not indicative of future results. Seek independent advice if necessary.',
		
		//===================subscription verify=====================
		subVerf_reqVerify :'Request Verification',
		subVerf_dear :'Dear',
		subVerf_your :'your',
		subVerf_accountVerMsz1 :'request has been processed successfully',
		subVerf_backSubList :'Back to susbcription tools',

		//==========subsTransaction detail=================
		subtrans_heading :'Subscription Transaction Detail',
		subtrans_date :'Date (created)',
		subtrans_payType :'Pay Type',
		subtrans_planprice :'Plan Price',
		subtrans_coupon :'Coupon',
		subtrans_amount :'Amount',
		subtrans_noData :'no data',
		subtrans_backVPSlist :'back to VPS list',

		//================vps detail
		vpsdetail_heading :'VPS Detail',
		vpsdetail_IPAddress :'IP Address',
		vpsdetail_ServerId :'Server Id',
		vpsdetail_HostName :'Host Name',
		vpsdetail_Disk :'Disk',
		vpsdetail_Cpu :'Cpu',
		vpsdetail_Memory :'Memory',
		vpsdetail_State :'State',
		vpsdetail_Created :'Date',
		vpsdetail_action :'Action',

		//============trading tool box
		toolbox_tradeToolbox :'Trader’s Tool Box',
		toolbox_moreAboutTradeToolbox :'Find more about Trader’s Tool Box',
		toolbox_tradeToolMsz1 :'Enrich your trading with fxview Trader’s Tool Box - a suite of robust indicators and applications that adds convenience to your trading journey.',
		toolbox_WhatYouGet :'What you get',
		toolbox_TraderToolboxApp :'Trader’s Tool Box Application',
		toolbox_TradeTerminal :'Trade Terminal',
		toolbox_MiniTerminal :'Mini Terminal',
		toolbox_AlarmsManager :'Alarms Manager',
		toolbox_ExcelRTD :'Excel RTD',
		toolbox_Connect :'Connect',
		toolbox_SentimentTrader :'Sentiment Trader',
		toolbox_SessionMap :'Session Map',
		toolbox_MarketManager :'Market Manager',
		toolbox_CorrelationMatrix :'Correlation Matrix',
		toolbox_CorrelationTrader :'Correlation Trader',
		toolbox_TickTrader :'Tick Trader',
		toolbox_StealthOrder :'Stealth order',
		toolbox_IndicatorPackage :'Indicator Package',
		toolbox_Minichart :'Mini chart',
		toolbox_PivotPoints :'Pivot Points',
		toolbox_HighsLows :'Highs and Lows',
		toolbox_Renkobars :'Renko bars',
		toolbox_ChartGroup :'Chart Group',
		toolbox_SymbolInfo :'Symbol Info',
		toolbox_Gravity :'Gravity',
		toolbox_Chart_in_Chart :'Chart-in-Chart',
		toolbox_PeriodConverter :'Period Converter',
		toolbox_Magnifier :'Magnifier',
		toolbox_OrderHistory :'Order History',
		toolbox_FreehandDrawing :'Freehand Drawing',
		toolbox_BarChanger :'Bar Changer',
		toolbox_KeltnerChannel :'Keltner Channel',
		toolbox_DonchianChannel :'Donchian Channel',
		toolbox_CandleCountdown :'Candle Countdown',
		toolbox_LinearRegression :'Linear Regression',
		toolbox_howtoinstall :"HOW TO INSTALL TRADER'S TOOL BOX",
		toolbox_loginFxViewmt45 :'Log In to your fxview MT4/5 account',
		toolbox_ToolboxApplication :'Download and run MT4/5 Trader’s Tool Box application',
		toolbox_FxviewMT45installation :'Select fxview MT4/5 Platform and proceed with the installation',
		toolbox_allowDdlImports :'Click on tools> options> expert advisor> and then click ok to allow DDL imports',
		toolbox_RestartFxviewMT45 :'Restart fxview MT4/5 platform',
		toolbox_tradeToolboxliveMinDeposit :"The Trader's Tool Box application can be used on the live MT4/5 account with a minimum deposit amount of $500.",
		toolbox_DisclaimerAutoChartist :'Disclaimer : The posts on this page are considered marketing communication and do not contain, and should not be construed as containing, investment advice or an investment recommendation or, an offer of or solicitation for any transactions in financial instruments. Past performance is not indicative of future results. Seek independent advice if necessary.',

		//=====================subscription service plan
		subscription_Subscriptionheading :'Subscriptions',
		subscription_SubMsz :'Take your desired plan to get access to our content easily, we like to offer special license offer to our users.',
		subscription_mnth :'/Month',
		subscription_freeMin :'FREE - MIN',
		subscription_deposit :'Deposits',
		subscription_Features :'Features',
		subscription_window :'window',
		subscription_Memory :'Memory',
		subscription_ssdDisk :'SSD DISK',
		subscription_create :'Create',
		//===================createSub ticket

		subticket_getSubPlan :'Get Subscription For this Plan',
		subticket_applyCouponCode :'Applied coupon code :',
		subticket_TotalAmount :'Total Amount',
		subticket_havePromoCode :'Have a Promocode?',
		subticket_deducedMonthlySubscription :'Please select the trading ID from where you want the cost to be deduced for monthly subscription in case minimum conditions aren’t met for free VPS.',
		subticket_demo :'Demo',
		subticket_live :'Live',
		subticket_noteUnsubTool :'Note: Payment will be only deducted once you click on the subscribe',
		subticket_clickToAgree :'Click Here to agree',
		subticket_vpsTC :'VPS T&C.',
		subticket_linkToSub :'Kindly click on that link to subscribe.',
		subticket_subsucce :'has been Subscribed Successfully. To know more detail, click on the below button',
		subticket_AutoChartPage :'Go to Auto Chartist Page',
		subticket_controlsignalPage :'Go to Control Signal Page',
		subticket_researchReportpage :'Go to Research Reports Page',
		subticket_currentNewsPage :'Go to Current News Page',
		subticket_economicCalPage :'Go to Economic Calender Page',
		subticket_vpsPage :'Go to VPS Page',
		subticket_selectPromoCode :'Select a Promo Code ',
		subticket_EnterCouponCode :'Enter Coupon Code',
		subticket_Apply:'Apply',
		subticket_For :'For',
		subticket_noPromoCode :"You don't Have any Promocode Yet!",
		subticket_vpsSubPlan :'VPS PLAN SUBSCRIPTION',
		subticket_createVPS :'Please add funds to create VPS',
		subticket_goDepositPage :'Go to deposit Page',
		



		////////////////////////////////////////////////////////////////////////////////////////////////////////////




		// ============/account-funding================'acc_fund'==============
		// acc_fund_tab_Deposit:'Deposit',
		// acc_fund_tab_Withdrawal:'Withdrawal',
		// 		//deposit-fund
		// acc_fund_depFundAcc:'Deposit Funds to Account',
		// acc_fund_depFund:'Deposit Funds',
		// acc_fund_tradAccId:'Trading Account ID',
		// acc_fund_demo:'Demo',
		// acc_fund_live:'Live',
		// acc_fund_SpeDepAm:'Specify the deposit amount',
		// acc_fund_amount: 'Amount',
		// acc_fund_selDepMet: 'Select Deposit Method',
		// acc_fund_depFieldReq:'DepositMethod field is required',
		// acc_fund_depMsz1:'Processing Time:',
		// acc_fund_depMsz2:'1 to 5 working days',
		// acc_fund_depMsz3:'Fee:',
		// acc_fund_depMsz4: '0',
		// acc_fund_depMsz5: 'Our Bank details are:',
		// acc_fund_warnMsz: "Only Euros can be received otherwise funds will be returned which can take up to 10 business days",
		// acc_fund_lessDet: "Less Detail",
		// acc_fund_viewDet: "View Detail",
		// acc_fund_MinDepAmt: "Minimum Deposit Amount",
		// acc_fund_MaxDepAmt: "Maximum Deposit Amount",
		// acc_fund_IBAN: "IBAN",
		// acc_fund_accNum:"Account Number",
		// acc_fund_holderName: 'Holder Name:',
		// acc_fund_bankName: 'Bank Name:',
		// acc_fund_Swift: "Swift/BIC",
		// acc_fund_address: "Address",
		// acc_fund_accCurr: "Account Currency",
		// acc_fund_ref: "Reference",
		// acc_fund_TradAcc: "Trading Account",
		// acc_fund_depMsz6: 'In case you wish to transfer from a bank account other than mentioned in your profile, please',
		// acc_fund_depMsz7: ' to add the new bank account details',
		// acc_fund_depMsz8: "You don't have a bank verified yet. Kindly",
		// acc_fund_depMsz9: "to add the new bank. In case you have already added your bank details, please wait for them to get verified.",
		// acc_fund_depMsz10: 'Instant 24/7',
		// acc_fund_DontbankAcc: "you don't have any bank account , please",
		// acc_fund_Createbank: "to create new bank",
		// acc_fund_skrillId: 'Skrill ID:',
		// acc_fund_depMsz11: 'Not the right Skrill account? Please',
		// acc_fund_depMsz12: 'to change your Skrill ID',
		// acc_fund_netId: 'Neteller ID:',
		// acc_fund_depMsz13: 'Not the right Neteller account? Please',
		// acc_fund_depMsz14: 'To change your Neteller ID',
		// acc_fund_DntSkill: "you don't have any skrill id , please",
		// acc_fund_Tocreate: "to create.",
		// acc_fund_DntNett: "you don't have any netteller id , please",
		// acc_fund_bakStp : 'Previous step',
		// acc_fund_procToPay : 'Proceed To Payment',
		// acc_fund_PlsEnsCort : "Please ensure that details are correct",
		// acc_fund_accountId :'Account ID',
		// acc_fund_feeUsd :'Fee (USD)',
		// acc_fund_depAmt :'Deposit Amount',
		// acc_fund_depMeth : 'Deposit Method',
		// acc_fund_confPay : 'Confirm Deposit',
		// acc_fund_depMsz15 : 'Please ensure that the deposit details are correct. If you are happy with everything, click the ‘Fund Now’ button to proceed. Please note that if you make a withdrawal after depositing into your account, your funds will most likely be returned to the same method used to deposit.',
		// acc_fund_noTrdAccFnd :"No Live Trading Account Found!",
		// acc_fund_plzWaitWhileProc : "Please wait while we are processing your data...",
		// acc_fund_viewDetail : "view detail",
		// acc_fund_clkHere : 'Click Here',
		// 		//deposit-list










		// MT4WebTrader : "MT4 Web Trader",
		// pleseEnterAmount : "please enter amount",
		// busActQues : " Business Activity",
		// pro30 : '30X',
		// MT5WebTrader : "MT5 Web Trader",
		// ActWebTrader : "Act Web Trader",
		// INVALID_CAPTCHA : "Invalid Captcha",
		// ALREADY_EXIST : "Already Exist",
		// Save : "Save",
		// forWeb : "Web",
		// acceptCountryFlagText : "<h3>Thank you for the information provided.</h3> <p>We currently accept only EU residents as clients, however, our Compliance team will review your application and confirm if we can accept your registration.</p>",
		// tradeNow : 'Trade Now',
		// mostActive : 'Most Active',
		// topGainers : 'Top Gainers',
		// topLosers : 'Top Losers',
		// ask : 'Ask',
		// bid : 'Bid',
		// spread : 'Spread',
		// change : 'Change',
		// Forex:'Forex',
		// Commodities:'Commodities',
		// Indices:'Indices',
		// amountHigherThanMargin : 'The amount that you have entered is higher than the Free Margin',
		// allowDeposit1lac : 'we are not allowing deposit more then 1,00,000 for demo account',
		// notAcceptCountry : 'Sorry, we are currently not accepting clients from this country.',
		// reviewStatusUpdated : 'Application review status has been updated.',
		// Clicktoseedetail : 'Click to see detail',
		// AddBankDetails : 'Add Bank Details',
		// fileallow : 'Only jpg, jpeg, png, pdf, PDF, JPG, JPEG, PNG, docx, doc, xls, xlsx files are allowed! ',
		// AddSkrillDetails : 'Add Skrill Id Details',
		// AddNetellerDetails : 'Add Neteller Id Details',
		// AddCreditCardDetails : 'Add Credit Card Details',
		// TheAuthorityName : 'The authority name is required',
		// TheDisputeTime : 'The dispute time is required',
		// paymentRequiredNumeric : 'The payment id field is required and may only contain numeric characters.',
		// bankAddressRequired : 'The bank address is required',
		// swiftCodeRequired : 'The swift code is required',
		// ibanRequired : 'The iban is required',
		// countryFieldRequired : 'The country field is required',
		// accountNumberRequired : 'The account number is required',
		// accountHolderRequired : 'The account holder name is required',
		// bankNameRequired : 'The bank name is required',
		// residenceCountryRequired : 'The residence country is required',
		// postCodeRequired : 'The post code is required',
		// DeleteLiveAccount : "<p><span>You cannot delete a live trading account with transactions in it however, you can delete a live account without transactions. Please note that in case you delete the account once, you would not be able to retrieve or access it or its any related trading history in future. Please proceed to raise a ticket in order to delete the account</span></p>",
		// DeleteDemoAccount : "<p><span>Please note that in case you delete the account once, you would not be able to retrieve or access it or its any related trading history in future. Please proceed to raise a ticket in order to delete the account</span></p>",
		// Howtodeposit: "<p><span>Adding funds to your FxView trading account is very simple and easy. We offer a wide range of deposit options so you can make instant deposits to your trading account. All deposits and withdrawals are processed with no fees from FxView</span></p><p><span>Please follow these steps to fund your trading account:</span></p><ul><li><span>-&nbsp;</span><span>Sign in to your FxView secure client area&nbsp;</span><a href='https://app.fxview.com/' target='_blank'><strong><u><span >HERE</span></u></strong></a></li><li><span >-&nbsp;</span><span>Scroll to the left of the screen to expand the menu, then click on &ldquo;Deposit&rdquo; &gt; &ldquo;Add Deposit&rdquo;</span></li><li><span >-&nbsp;</span><span>Click on the Trading Account you want to add funds into and click on &ldquo;Deposit Funds&rdquo;</span></li><li><span >-&nbsp;</span><span>Specify the amount you want to deposit</span></li><li><span >-&nbsp;</span><span>Choose a deposit method</span></li><li><span >-&nbsp;</span><span>Read the instructions carefully and please make sure all the details are correct before proceeding with the transaction. As indicated on screen, processing times vary according to the funding method selected.</span></li><li><span >-&nbsp;</span><span>Click on &ldquo;Proceed to Payment&rdquo;</span></li><li><span >-&nbsp;</span><span>Follow the prompts and confirm the payment</span></li><li><span >-&nbsp;</span><span>Once the transaction is approved, the deposited amount will appear in your trading account. Please note that this process is not instant for Bank Transfers.</span></li></ul><p><span>You can see all your transaction history&nbsp;</span><a href='https://app.fxview.com/deposit-list' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		// Depositerror : "<p><span>Please make sure you have entered the correct information while trying to deposit, In case the issue persists, please proceed with creating the ticket. Please make sure to provide the detailed information on what exact issue you are facing and upload the relevant screenshot of the error you are getting so we can investigate the issue.</span></p><p><span>Note: Please note, you need to get your bank account or e-wallet or card verified prior making the deposit, please get it verified by creating a ticket under Support &gt; Add Payment Method</span></p>",
		// DepositMethods : "<p><span>Following are the supported for account funding:</span></p><ul><li><span>-&nbsp;</span><strong><span>Bank Wire</span></strong><span>&nbsp;:</span></li></ul><ul><li><span>●&nbsp;</span><span>Bank of Lithuania via epayBlock: 100 Euros minimum deposit</span></li><li><span>●&nbsp;</span><span>Handelsbank via MoneyNetint: 1000 Euros minimum deposit</span></li><li><span>●&nbsp;</span><span>Funds are credited within 12 working hours of receiving funds in our bank accounts</span></li><li><span >●&nbsp;</span><span>No cost is charged from FxView side however the correspondent bank may charge you for the wire transfer. Also please note that deposit amount below the prescribed limit is subject to a charge of 20 EUR</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>Credit/Debit Cards:</span></strong></li></ul><ul><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>VISA and MasterCard&nbsp;</span></li><li><span >●&nbsp;</span><span>100 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from FxView side however your card provider may charge you for the transaction</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>E-wallets&nbsp;</span></strong><span>:&nbsp;</span></li></ul><ul><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>Neteller and Skrill</span></li><li><span >●&nbsp;</span><span>10 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from FxView side however neteller or skrill may charge you for the transaction</span></li></ul><ul ><li><span >-&nbsp;</span><strong><span>APMs:</span></strong></li></ul><ul><li><span >●&nbsp;</span><span>Rapid, Klarna, Giropay, Przelewy24 and Nordea&nbsp;</span></li><li><span >●&nbsp;</span><span>Instant deposit</span></li><li><span >●&nbsp;</span><span>5 Euros minimum deposit</span></li><li><span >●&nbsp;</span><span>deposit limit of EUR 25,000 per month, EUR 15,000 per day and EUR 5,000 per transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from FxView side however neteller or skrill may charge you for the transaction</span></li><li><span >●&nbsp;</span><span>Only available for deposits</span></li></ul><p><span>Please note that there may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		// Fundsnotcredited: "<p><span>Following is the processing time for deposits:</span></p><ul ><li><span>-&nbsp;</span><span>Bank Wire ( Funds are credited within 12 working hours of receiving funds in our bank accounts)</span></li><li><span >-&nbsp;</span><span>Credit/Debit Cards (Instant)</span></li><li><span >-&nbsp;</span><span>E-wallets - Skrill , Neteller</span></li><li><span >-&nbsp;</span><span>APMs - Rapid, Klarna, Giropay, Przelewy24 and Nordea (Instant)</span></li></ul><p><span>Please be aware that there may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		// DepositTransactionHistory : "<p><span>Please check your transaction history under Deposit &gt; Deposit List</span></p>",
		// Howtowithdraw : "<p><span>You can withdraw from your trading account by submitting a withdrawal request from your secure client area&nbsp;</span><a href='https://app.fxview.com/withdrawal' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.&nbsp;</span></strong><span>Please follow these steps in order to withdraw from your trading account:</span></p><ul ><li><span >-&nbsp;</span><span>Go to &ldquo;Withdraw&rdquo; &gt; &ldquo;Withdrawal&rdquo;</span></li><li><span >-&nbsp;</span><span>Select your Trading Account you want to withdraw funds from and you will see the available withdrawable amount</span></li><li><span >-&nbsp;</span><span>Select your withdrawal method</span></li><li><span >-&nbsp;</span><span>Enter the amount you want to withdraw</span></li><li><span >-&nbsp;</span><span>Click on submit</span></li><li><span >-&nbsp;</span><span>You will receive a confirmation link on your registered email address</span></li><li><span >-&nbsp;</span><span>Click on the link to confirm your request</span></li></ul><p><span>Once the withdrawal is approved, it will be processed within the stipulated time.</span></p><p><span>Please note that withdrawal of principal amount will be processed via the same payment gateway to the same account you used while funding the account. To know more about our withdrawal policy, please click&nbsp;</span><a href='https://fxview.com/account-funding' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		// Withdrawalerror : "<p><span>Please make sure you have entered the correct information while placing the withdrawal request. &nbsp;In case the issue persists, please proceed with creating the ticket. Please make sure to provide the detailed information on what exact issue you are facing and upload the relevant screenshot of the error you are getting so we can investigate the issue.</span></p><p><span>Note: your deposited amount will be transferred back to the original source and to the same account that you used to fund the account. While, the rest of the amount (profits) can be withdrawn via any other supported payment method except credit cards. Please review the withdrawal policy for details.</span></p>",
		// WithdrawalMethods: "<p><span>As per our &nbsp;Deposits and Withdrawals Policy, withdrawals are processed via the same method by which funds were initially &nbsp;deposited in the trading account.</span></p><p><span>Following, are the supported methods for withdrawals:</span></p><ul ><li><span >-&nbsp;</span><span>Bank Wire:</span></li></ul><ul><li><span >●&nbsp;</span><span>minimum amount - Euros 100</span></li><li><span >●&nbsp;</span><span>processed within the business hours of the same working day after we receive the request however it may take 1-7 working days for funds to appear in bank your account as its an international wire transaction</span></li><li><span >●&nbsp;</span><span>No cost is charged from FxView side, however, the correspondent bank may charge you for the wire transfer</span></li></ul><ul ><li><span >-&nbsp;</span><span>Credit/Debit Cards:</span></li></ul><ul><li><span >●&nbsp;</span><span>Minimum amount - Euros 100</span></li><li><span >●&nbsp;</span><span>processed within the business hours of same working day after we receive the request</span></li><li><span >●&nbsp;</span><span>The total withdrawal amount cannot exceed the total deposit amount processed via the same card</span></li><li><span >●&nbsp;</span><span>FxView does not charge any fees, &nbsp;however, your card provider may charge you for the transaction.</span></li></ul><ul ><li><span >-&nbsp;</span><span>E-wallets -&nbsp;</span></li></ul><ul><li><span >●&nbsp;</span><span>Skrill and Neteller : Minimum amount - 10 Euros&nbsp;</span></li><li><span >●&nbsp;</span><span>Processed within the business hours of the same working day after we receive the request</span></li><li><span >●&nbsp;</span><span>No transaction cost is charged by FxView, however, Neteller,Skrill or your bank may charge you for the transaction</span></li><li><span >●&nbsp;</span><span>Amounts withdrawn should be equal with the amounts deposited via these methods plus profits if applicable.&nbsp;</span></li></ul><ul ><li><span >-&nbsp;</span><span>APMs ( Rapid, Klarna, Giropay, Przelewy24 and Nordea) -&nbsp;</span></li></ul><p style='margin-left:72.0000pt;'><span>Only available for deposits. Withdrawals will be processed via bank wire.&nbsp;</span></p><p><span>There may be unforeseen circumstances whereby deposits &amp; withdrawal times may be longer than stipulated.</span></p>",
		// Withdrawalpolicy : "<p><span>We understand that fast and easy withdrawals are important to the traders hence we have formulated efficient fund withdrawal policies. The withdrawal request procedure can be completed online and is designed keeping security policies in mind.&nbsp;</span></p><p><span>We support multiple payment gateways for withdrawal. However the method available to you depends on the deposit method you used while initially funding your account.&nbsp;</span></p><p><span>According to the withdrawal policies:</span></p><ul ><li><span >-&nbsp;</span><span>Your deposited amount will be transferred back to the original source and to the same account that you used to fund the account.&nbsp;</span></li><li><span >-&nbsp;</span><span>The amount of profits can be withdrawn via any other supported payment method available except for credit cards.&nbsp;</span></li><li><span >-&nbsp;</span><span>Please note that your bank account, card or the wallet ID should be in the same name as on the account maintained on record with FxView and should be verified prior making any deposit and withdrawal.</span></li><li><span >-&nbsp;</span><span>For amounts meeting the required limits, FxView does not charge withdrawal fees for bank wire transactions. However, the sending and correspondent bank may charge a transaction fee.</span></li><li><span >-&nbsp;</span><span>Please note that a fee of 5 EUR will be charged if the withdrawal amount is less than the prescribed minimum withdrawal amount.</span></li><li><span >-&nbsp;</span><span>Withdrawal requests will be processed only if placed via the secure client area. .</span><spanstyle='color:rgb(255,255,0);color:rgb(255,255,0);'>&nbsp;</span><span>Requests sent over email or live chat will be directed to the secured client area and therefore may result in delays.</span></li><li><span >-&nbsp;</span><span>Withdrawals are processed within the business hours of the same working day after we receive the request.</span></li><li><span >-&nbsp;</span><span>APMs are only available for deposits. Withdrawals for funds deposited via these methods will be processed via bank wires only.</span></li></ul><p><span>To know more about our withdrawal policy, please click&nbsp;</span><a href='https://fxview.com/account-funding' target='_blank'><strong><u><span >HERE</span></u></strong></a><strong><span>.</span></strong></p>",
		// Withdrawalnotreceived : "<p><span>Typically, withdrawals are processed within the business hours of the same working day after we receive the request. Once we have processed your withdrawal request, please allow 1 -7 business days for the funds to reach you. This will vary depending on the withdrawal method you have used. Usually, withdrawals processed using e-wallets or credit cards are much faster than wire transfers, and are reflected within the same day. Please note the processing times for withdrawals via different methods:</span></p><ul ><li><span >-&nbsp;</span><span>Bank Wire:</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed &nbsp;within the business hours of the same working day after we receive the request, however, it may take 1-7 working days for funds to appear in your account due to wire transfer.</span></p><ul ><li><span >-&nbsp;</span><span>Credit/Debit Cards:</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed within the business hours of the same working day after we receive the request, however, it may take 1 to 7 working days for funds to be reflected into your account.</span></p><p style='margin-left:72.0000pt;'><span>Since we rely on third parties to facilitate the transfer of funds in and out of your account, delays may occur.</span></p><ul ><li><span >-&nbsp;</span><span>E-wallets - Skrill , Neteller&nbsp;</span></li></ul><p style='margin-left:72.0000pt;'><span>Processed within the business hours of same working day after we receive the request, most of the time it reflects instantly however It can take 1 working day for funds to be reflected into your account</span></p><ul ><li><span >-&nbsp;</span><span>APMs- &nbsp;Rapid, Klarna, Giropay, Przelewy24, Nordea:</span></li></ul><p style='margin-left:72.0000pt;'><span>Withdrawals can only be processed via bank wire transfers to the same bank account from which deposits were made via these e-wallets. Therefore, transfers are processed &nbsp;within the business hours of the same working day after we receive the request, however, it may take 1-7 working days for funds to appear in your account due to wire transfer.</span></p>",
		// Minimumwithdrawal : "<p><span>Bank Wire: Euros 100</span></p><p><span>Credit/Debit Cards: Euros 100</span></p><p><span>E-wallets - Skrill, Neteller: Euros 10&nbsp;</span></p><p><span>Please note that APMs are only available for deposits. Also, Withdrawal requests below the minimum limits are subject to the processing fees of EUR 5.</span></p>",



		// ApplyforVPS : "<p><span>Please follow these steps to apply for VPS:</span></p><ul ><li><span >-&nbsp;</span><span>Click on Tools &gt; VPS &gt; Create New</span></li></ul><p><span>Please note: &nbsp;If you maintain a monthly balance of $5000 in total in your trading accounts, you can avail it for free, however, if you fail to meet the condition, the basic VPS is chargeable at $25 per month which will be deducted from your trading account.&nbsp;</span></p>",
		// VPSPlans : "<p><span>We have three VPS plans-</span></p><p><span>Basic:&nbsp;</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $25</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $5,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>2 GB Memory / 2 VCPU</span></li><li><span >-&nbsp;</span><span>50 GB SSD Disk Space</span></li></ul><p><span>Standard:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $40</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $20,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>4 GB Memory / 3 VCPU</span></li><li><span >-&nbsp;</span><span>100 GB SSD Disk Space</span></li></ul><p><span>Premium:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $60</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $50,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>6 GB Memory / 4 VCPU</span></li><li><span >-&nbsp;</span><span>150 GB SSD Disk Space</span></li></ul>",
		// UnabletoConnect : "Please be advised that VPS is activated within 30 minutes after you receive the login credentials. In case the issue persists, Please provide the screenshot of error",
		// VPSpasswordchange : "<p><span>To change the password of VPS, please follow the given steps:</span></p><p><span>Click the start tab in the VPS window--&gt;Administrative tools--&gt;Computer Management--&gt;Local users and groups--&gt;Users--&gt;Administrator. Please right click on the &quot;Administrator&quot; option and select the option &quot;set password&quot;</span></p>",
		// VPSplansandspecifications : "<p><span>We have three VPS plans-</span></p><p><span>Basic:&nbsp;</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $25</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $5,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>2 GB Memory / 2 VCPU</span></li><li><span >-&nbsp;</span><span>50 GB SSD Disk Space</span></li></ul><p><span>Standard:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $40</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $20,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>4 GB Memory / 3 VCPU</span></li><li><span >-&nbsp;</span><span>100 GB SSD Disk Space</span></li></ul><p><span>Premium:</span></p><ul ><li><span >-&nbsp;</span><span>Chargeable at monthly cost of $60</span></li><li><span >-&nbsp;</span><span>Free of Cost if you maintain a monthly balance of $50,000 in total in your trading account</span></li><li><span >-&nbsp;</span><span>Month-to-month subscription</span></li><li><span >-&nbsp;</span><span>6 GB Memory / 4 VCPU</span></li><li><span >-&nbsp;</span><span>150 GB SSD Disk Space</span></li></ul>",
		// VPSCancellation : '<p><span >Please note that if monthly fees for the paid VPS is already deducted from the account, it will not be reimbursed back after the cancellation of VPS</span></p>',

		// createSupportRequest : "Create a Support Request",
		// Method: "Method",
		// clickToResolve : "click to resolve",

		// inversterPass : "In case if you face any issues setting investor password from your MT4/MT5 platform, Please proceed with creating the support request",
		// EmailfieldValid : 'Please enter a valid email address',
		// EmailfieldReq : 'Email field is required',
		// uploadRecentAddressProof : "Upload recent address proof ",
		// apiEndpoints : "api endpoints",
		// RestApi : "Rest api",
		// Deposits : "Deposits",
		// Feedback : "Feedback",
		// Others : "Others",
		// AddPaymentMethod : "Add Payment Method",
		// Withdrawals : "Withdraw",
		// EasternTime : "all dates are in Eastern Time (EST/EDT)",
		// WebSocketMsg : "Web socket messages streaming",
		// ReadPolicy : "Read Our Bonus Policy",
		// ifscSwiftBic : "ifsc/Swift/Bic (Short code of uk)",
		// IBANNumber : "IBAN Account Number",
		// MiniDepositAmount : "Minimum Deposit Amount",
		// MaxDepositAmount : "Maximum Deposit Amount",
		// chargedIfdeposit : "For payments via Modular Bank a fee of &euro;20 will be charged if deposit amount is less than the minimum deposit amount.",
		// PleaseEnsureCorrect : "Please ensure that details are correct",
		// SwapCharges: "<p><strong><span>What are swaps?</span></strong></p><p><span>When positions are held overnight, a swap is charged. It is either debited from or credited to your trading account depending on the instrument you are trading and the position size you have.&nbsp;</span></p><p><span>You can check the swap charges in the instrument specification list&nbsp;</span><a href='https://fxview.com/forex' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or calculate swaps using our Swap calculator available on our website&nbsp;</span><a href='https://fxview.com/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or within your trade terminals by following the steps below:</span></p><p><span>MT5/MT5:</span></p><p><span>Right click on any instrument in the &#39;Market Watch&#39; section &gt; left click on the &#39;Specification&#39; button. A new window will open that will show the swap rates for the instrument selected.</span></p><p><span>ActTrader:</span></p><p><span>On the &lsquo;Instruments&rsquo; tab, swaps are listed under &lsquo;Roll. Sell&rsquo; and &lsquo;Roll. Buy&rsquo;</span></p><p><strong><span>Where can I check swap charges?</span></strong></p><p><span>You can check the swap charges in the instrument specification list&nbsp;</span><a href='https://fxview.com/forex' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or calculate swaps using our Swap calculator available on our website&nbsp;</span><a href='https://fxview.com/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;or within your trade terminals by following the steps below:</span></p><p><span>MT5/MT5:</span></p><p><span>Right click on any instrument in the &#39;Market Watch&#39; section &gt; left click on the &#39;Specification&#39; button. A new window will open that will show the swap rates for the instrument selected.</span></p><p><span>ActTrader:</span></p><p><span>On the &lsquo;Instruments&rsquo; tab, swaps are listed under &lsquo;Roll. Sell&rsquo; and &lsquo;Roll. Buy&rsquo;</span></p><p><strong><span>When are swaps charged?</span></strong></p><p><span>Swaps are charged daily between Monday-Friday at 23:59:59 GMT+3 during DST and GMT+2 during non-DST.&nbsp;</span></p><p><span>They are credited into or debited from the account balance once the position is closed. While the position remains open, swaps are reflected in the equity.</span></p><p><span>To account for the weekend, 3 day swaps are charged at some point during the week. The day on which 3 day swaps are charged depends on the instrument traded, and can be summarised as follows:</span></p><p><span>Currencies and commodities: Wednesday</span></p><p><span>USDCAD, USDTRY, EURRUB and USDRUB: Thursday</span></p><p><span>Indices: Friday</span></p><p><strong><span>How are swap charges calculated?</span></strong></p><p><span>Swap charges are set according to the interest rate differential between the two currencies in the pair, and are different for long and short positions. They are charged by the liquidity provider itself. You can look up swap charges through our swap calculator&nbsp;</span><a href='https://fxview.com/trading-calculators' target='_blank'><strong><u><span >HERE</span></u></strong></a><span>&nbsp;.&nbsp;</span></p><p><span>Formula for swap charges calculation is as follows:&nbsp;</span><span><br></span><span>Swap = No. of Lots* Swap Points* Contract Size* Minimum Price Fluctuations* Days * Conversion price to account base currency</span></p>",
		// AccountClosure : "<p><span>We are sorry to hear that you want to close your fxview account. If you are facing any kind of issue with your account, please feel free to contact us Via Live Chat , Email or Call so we can look into the issue and provide you the required assistance.&nbsp;</span></p><p><span>Should you still choose to close your account, please proceed with the support request.</span></p><p><span>Please note that in case you have any open positions in your account, all the positions will be closed at the prevailing market price and withdrawal of remaining funds will be processed to you</span></p><p><span>In case you wish to cancel your account closure request in the meantime, please feel free to contact us via Live Chat, phone or email, and we will be glad to assist.</span></p>",


		// French : 'French',
		// //=============================messages================================================
		// noTradingCreateNewOne : 'No Trading Account Yet, Create a New Account',
		// faMszOtp1 : 'or use can also use 2fa OTP but you should enable first by click on the link given below',
		// RESEND_EMAIL : 'Resend Email',
		// TECH_ERROR : "We are facing some issues , Kindly try after some time",
		// VALIDATION_ERROR : 'validation error',
		// INVALID_TRADING_ACC : 'invalid trading account error',
		// INVALID_WITHDRAWAL_TRANSACTION : 'invalid withdrawal transaction',
		// INVALID_OTP : 'invalid OTP',
		// FILE_UPLOAD : 'Only jpg, jpeg, png, pdf files are allowed!',
		// OTP_EXPIRED : 'OTP expired',
		// OTP_IP_MISMATCH : 'OTP is not match',
		// LOW_BALANCE_THEN_AMOUNT : 'The amount that you have entered is higher than the Free Margin available.',				
		// TICKET_EXIST : 'ticket already exists',
		// EMAIL_EXIST : 'email is already exists',
		// MOBILE_EXIST : 'mobile number is already exists',
		// LOW_BONUS_THEN_AMOUNT : 'amount that you have filled is low then your bonus',
		// INVALID_ACCOUNT_TRANSACTION : 'invalid account transaction',
		// INVALID_TICKET_TRANSACTION : 'invalid ticket transaction',
		// DEPOSIT_LIMIT : 'deposit limit',
		// AMOUNT_GREATER_THEN_ALLOWED : 'The amount that you have entered is higher then the allowed.',
		// fund_msz : 'deposit successfully',
		// suceessMsz1 : '2FA Enabled successfully',
		// suceessMsz2 :'2FA Disabled successfully',
		// suceessMsz3 : 'A link for change password has been sent on your registered email id',
		// suceessMsz4 :'password changed successfully',
		// suceessMsz5 :'OTP resend successfully',
		// suceessMsz6 :'OTP is sent on your register email and mobile number',
		// suceessMsz7 :'Now you are eligible to open live account',
		// suceessMsz8 :'please upload your document within 15 days',
		// suceessMsz9 :"add name successfully",
		// suceessMsz10 :'link has been sent your registered email id', 
		// suceessMsz11 :'plan unsubscribe successfully',
		// suceessMsz12 :'service restart successfully',
		// suceessMsz13 : 'service reboot successfully',
		// suceessMsz14 : 'service shutdown successfully',
		// suceessMsz15 : 'service password changed successfully',
		// suceessMsz16 : 'A link has been sent to your registered email address',
		// suceessMsz17 : 'deposit successfully',
		// suceessMsz18 : 'OTP resend successfully',
		// suceessMsz19 : 'add bank successfully',
		// suceessMsz20 : 'ticket has been created successfully and please wait for 2-3 working days',
		// suceessMsz21 : 'At this moment we are allowing 1,00,000,00 only. In case you want to deposit more than this kindly contact support',
		// suceessMsz22 : 'you are not allowed to enter amount greater then or equal to deposit limit - , because you are not verified yet and ur document is still under verification so you cannot deposit more then2000 EUR',
		// suceessMsz23 : 'Invalid Amount',
		// suceessMsz24 : 'Your account is not verified',	
		// suceessMsz25 : 'account id should be different from another account id you selected	',	
		// suceessMsz26 : 'atleast select 2 options',
		// suceessMsz27 : 'new password is not same as confirm new password',
		// suceessMsz28 : 'Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',
		// suceessMsz29 : '',
		// errorMsz1 : "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!",
		// //=====================================================================================
		// germany : 'Germany',
		// itly : 'Italian',
		// tradingIdeas : 'Trading Ideas',
		// autocharist : 'Auto Charist',
		// signalCentre : 'Signal Centre',
		// forMore : 'For more',
		// Subscribe : 'Subscribe',
		// SeeMore : 'See More',
		// Poweredby : 'Powered by',
		// PortfoliosCom : 'Portfolios.com',
		// getSubPlan : 'Get Subscription For this Plan',
		// mnth : '/Month',
		// appliedmnth : 'Applied. For 1 Month',
		// havePromoCode : 'Have a Promocode?',
		// selectTradingAmountDeduct : 'Please select the trading ID from you want you want payment will be deducted.',
		// selectAccountId : 'select account id',
		// noteUnsubTool : "Note: Payment will be only deducted once you click on the subscribe",
		// linkToSub : "Kindly click on that link to subscribe.",
		// subsucce : "has been Subscribed Successfully. To know more detail, click on the below button",
		// AutoChartPage : 'Go to Auto Chartist Page',
		// controlsignalPage : "Go to Control Signal Page",
		// researchReportpage : 'Go to Research Reports Page',
		// currentNewsPage : 'Go to Current News Page',
		// economicCalPage : 'Go to Economic Calender Page',
		// vpsPage : 'Go to VPS Page',
		// selectPromoCode : 'Select a Promo Code ',
		// Apply : 'Apply',
		// backSub :'Back to Subscription',
		// For : 'For',
		// EconomicCalendar : 'Economic Calendar',
		// ecoCalMsz : 'Take your desired plan to get access to our content easily, we like to offer special license offer to our users.',
		// createServiceSeeDetail : 'Please create this service to see details',
		// Country : 'Country',
		// Event : 'Event',
		// Time : 'Time',
		// Forecast : 'Forecast',
		// Revised : 'Revised',
		// TEForecast : 'TEForecast',
		// Time : 'Time',
		// backSubList : 'Back to susbcription tools',
		// Subscription : 'Subscriptions',
		// SubMsz : 'Take your desired plan to get access to our content easily, we like to offer special license offer to our users.',
		// PlanCurrency : 'Plan Currency',
		// Periodicity : 'Periodicity',
		// TaxPer : 'Tax Per',
		// create : 'create',
		// Unsubscribe : 'Unsubscribe',
		// TraderToolSubscription : 'Trader Tool Subscription',
		// CurrentNews : 'News',
		// VPSDetail : 'VPS Detail',
		// Restart : 'Restart',
		// ShutDown : 'Shut-Down',
		// Reboot : 'Reboot',
		// VPSList : 'VPS List',
		// CreateNew : 'Create VPS',
		// Cpu : 'Cpu',
		// Hostname : "Hostname",
		// State : "State",
		// Disk : "Disk",
		// Label : "Label",
		// MainIpAddress : "Main Ip Address",
		// Memory : "Memory",
		// DetailedState : "Detailed State",
		// vpsMsz : "You don’t have a VPS server.",

		// // ==================depesit====================
		// depTransHist : "Deposit Transaction history",
		// transId : "Transaction Id",
		// payMeth : "Payment Method",

		// // =========== Manage Account ===================
		// reqProcessing : "request processing...",
		// interTransMsz : "Making an internal transfer isn't possible at the moment as you have only one trading account",
		// interTransDeducted : "will be deducted from your ",
		// interTransSorryMsz : "Sorry you don't have balance to transfer amount to another trading account.",
		// confToTransfer : "Please Confirm to Continue",
		// PleaseSelectTradingId : 'Please Select Trading Id',
		// plzWaitWhileProc : "Please wait while we are processing your data...",
		// transToAcc : "transfer to account id",
		// currentBalance : "Current Balance",
		// depostotradAcc : "will be deposited to your ",
		// back : "Back",

		// // =========== Register Step ===================
		// dataFieldReq : "date field is required",
		// addFieldNote : "Note: Please ensure that the address entered is correct, as you will be required to provide proof that you reside at this address at a later stage.",
		// selectGender : "Select Gender",
		// male : "Male",
		// female : "Female",
		// dontPassport : "Don't have a passport",
		// genderField : "gender field is required",
		// selIdntProof : "Select Indentity Proof (You need to provide document to verify this number later on)",
		// drivLicNum : "Driving License Number",
		// enterPassNum : "Enter Passport Number",
		// enterIdenNum : "Enter Identification Number",
		// enterDrivLicNum : "Enter Driving License Number",
		// regkindlyEnsureId : "Please note that you will be asked to verify your passport/id number at a later stage by uploading the corresponding document.",
		// empStatusFieldReq : "The Employee Status field is required",
		// occFieldReq : "The occupation field is required",
		// yearEncFieldReq : "The Yearly Income field is required",
		// netWorthFieldReq : "The Estimated Net Worth field is required",
		// accTurnFieldReq : "The Account Turnover field is required",
		// allInfoCorrect : "you won't be able to change any previous step information. Make sure all information is correct!",
		// reviewing : "Reviewing..",
		// dataMisMatchDoc : "Data Mismatch From Document",
		// WhileReviewYourApp : "While we are reviewing your application. You can check our following services:",
		// readTradeNews : "1. Market moving news",
		// readTradeIdeaAuto : "2. Trade ideas",
		// readTradeIdeaSignal : "3. Economic calendar",
		// appSubTakeTime : "Application submitted. This will take upto 5-8 minutes.",
		// deniNotificAcc : "We have noticied that you have denied notification access.",
		// whyWeAllow : "Why do we want you to allow that:",
		// infoAboutAppStatus : "Real time information about your application status. While we are verifying your document you can see our feature. So notification will help us to do that.",
		// toSkip : "to skip",
		// idNumEnt : "ID number entered",
		// nationalityEntered : "Nationality entered",

		// //============ Shared ===================
		// tools : "tools",
		// AutoChartist : "Autochartist",
		// SignalCenter : "Signal Center",
		// VPS : "VPS",
		// EconomicCalender : "Economic Calendar",
		// TradeNews : "Trading News",
		// revStatUpdated : "Review Status Updated",
		// Low : "Low",
		// high : "High",
		// Selecttimezone: "Select Timezone",

		// // ========== shared trade Id ==========
		// TransFromAccId : "Transfer from account id",
		// selectAccount : "select account id",
		// Swap : "Swap",
		// buy : "BUY",
		// sell : "SELL",

		// // ========== support ==========
		// SearchSomething : "Search Here",
		// OpenRequests : "Open Requests",
		// ClosedRequests : "Closed Requests",
		// TypeMsz : "Type a message",
		// docReq : "document is required",
		// AccountName : "Account Name",
		// IBAN : "IBAN",
		// last4Digit : "last 4 digits is required and contains only numeric character",
		// first4Digit : "first 4 digits is required and contains only numeric character",
		// UpBankStatement : "Upload Bank Statement",
		// SwiftCode : "Swift/BIC/Sort Code",
		// netSkrill1 : 'please upload the screenshot of the',
		// netSkrill2 : 'profile contacting the full name,',
		// netSkrill3 : ' id and address. We are going to match the name and address',
		// MyBankNotIBAN : "My Bank Doesn’t issue IBAN",
		// frontBack : "We require the following for the card verification -",
		// frontPhotoCredit : "Color copy of the front side of the card, showing: full name, expiration date, Bank name/logo, first 4 and last 4 digits of the credit card number hiding the middle 8 digits.",
		// backPhotoCredit : "Color copy of the back side of the card hiding the CVV security code. The back copy should shown the sign of the holder",
		// legalEntityName : "Legal Entity Name (in case of a legal person):",
		// employeeWhoOffered : "Employee who offered the services to the Client:",
		// timeDisputed : "Date and Time of the disputed situation (in MetaTrader server time):",
		// ticNoContested : "Ticket Number(s) of all contested positions and/or pending orders:",
		// DisputedAmount : "Disputed amount:",
		// reportComplaint : "Have you reported your complaint to any Supervisory Authority?",
		// stateNameAuth : "Please state the name of the Supervisory Authority",
		// attachTogetherForm : "Please attach together with this form any supporting evidence to your claim that will facilitate fxview's investigation of your complaint. Supporting evidence may consist of any documentation (screenshots, chats, phone records etc) relevant to the complaint.",
		// DetailedDescript : "Detailed description of the Complaint:",
		// ComplaintDetails : "Complaint Details",

		// // ========== Trading Account ==========
		// ClosedTrades : "Closed Trades History",
		// MainBalance : "Main Balance",
		// passWordMustContain : "Your password must contain at least 5 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^*/)",
		// apiAccounts : "API ACCOUNTS",
		// apiDocumentation : "API Documentation",
		// TradingAccount : "Trading Account",
		// backlist : "back to list",
		// SeeApiDoc : "See Api Documentation",

		// // ========== Trading Tools ==========
		// haveReachedFreeLimit : "<span class='green'>Oops! </span>You have reached a free limit of 6 articles. To access more articles, please create a live account.",
		// LoadMore : "Load More",
		// DisclaimerAutoChartist : "Disclaimer : The posts on this page are considered marketing communication and do not contain, and should not be construed as containing, investment advice or an investment recommendation or, an offer of or solicitation for any transactions in financial instruments. Past performance is not indicative of future results. Seek independent advice if necessary.",
		// CreateLiveAccount : "Create Live Account",
		// Cancel : "Cancel",
		// AutochartistfinestSupplement : "AutoChartist- The finest supplement to technical analysis for continuously identifying trade opportunities across multiple assets class including forex, stock indices, commodities, and crypto currencies.",
		// IBintegrateAdvancedTool : "AutoChartist is a premier chart pattern recognition software that scans trading instruments and automatically recognizes trade set-ups based on breakouts, retracements, support and resistance levels so that you never miss an opportunity again.",
		// SubsMarketReports : "Subscribe for live account",
		// launchWebApp : "launch web app",
		// userguide : "User & installation guide",
		// TradOppCharts : "Trading opportunity charts",
		// usingTraderToolbox : "For using Trader’s toolbox, first you need to have a MT4/MT5/Ctrader Portfolios account.",
		// closeMt4 : "Log In to your fxview MT4 account.",
		// DownloadRunAuto : "Download and run AutoChartist Scanner application.",
		// SelectPortfoliosTrading : "Select fxview MT4 Platform and proceed with the installation.",
		// completeInstallationProcess : "Click OK to allow DDL Imports.",
		// RestartMt4Platform : "Restart fxview MT4 platform.",
		// AutochartistScanner : "AutoChartist Scanner",
		// reachFreeLimit : "<span class='green'>Oops!</span> You have reached a free limit. To access more, please create a live account",
		// EnterCouponCode : "Enter Coupon Code",
		// noPromoCode : "You don't Have any Promocode Yet!",
		// TotalAmount : "Total Amount",
		// applyCouponCode : "Applied coupon code :",
		// goDepositPage : "Go to deposit Page",
		// vpsSubPlan : "VPS PLAN SUBSCRIPTION",
		// createVPS:"Please add funds to create VPS",
		// clickToAgree : "Click Here to agree",
		// vpsTC : "VPS T&C.",
		// deducedMonthlySubscription : "Please select the trading ID from where you want the cost to be deduced for monthly subscription in case minimum conditions aren’t met for free VPS.",
		// showMore : "Show More",
		// showLess : "Show Less",
		// ChannelDownIdentified : "Channel Down identified at",
		// ThisPatternProcess : "This pattern is still in the process of forming. Possible bullish price movement towards the resistance 2,662.6500 within the next 1 hour.",
		// Short : "Short",
		// May : "May",
		// unmatchedTradingExperience : "Get an unmatched trading experience via suitable VPS hosting program that allows you to trade uninterruptedly with reduced latency.",
		// freeMin : "FREE - MIN",
		// Features : "Features",
		// ssdDisk : "SSD DISK",
		// notVerified : "you are not verified",
		// moreAboutTradeToolbox : "Find more about Trader’s Tool Box",
		// moreaboutautochartist : "Find more about AutoChartist Scanner",
		// tradeToolbox : "Trader’s Tool Box",
		// tradeToolboxliveMinDeposit : "The Trader's Tool Box application can be used on the live MT4/5 account with a minimum deposit amount of $500.",
		// autochartistdesc : "Autochartist Scanner can be used on the live MT4 account with a minimum deposit amount of $200.",
		// RestartFxviewMT45 : "Restart fxview MT4/5 platform",
		// allowDdlImports : "Click on tools> options> expert advisor> and then click ok to allow DDL imports",
		// FxviewMT45installation : "Select fxview MT4/5 Platform and proceed with the installation",
		// ToolboxApplication : "Download and run MT4/5 Trader’s Tool Box application",
		// loginFxViewmt45 : "Log In to your fxview MT4/5 account",
		// HowInstallTraderToolbox : "How to Install Trader’s Tool Box application",
		// useTraderToolbox : "For using Trader toolbox, first you need to have a MT4/MT5/Ctrader Portfolios account.",
		// IndicatorPackage : "Indicator Package",
		// Minichart : "Mini chart",
		// PivotPoints : "Pivot Points",
		// HighsLows : "Highs and Lows",
		// Renkobars : "Renko bars",
		// ChartGroup : "Chart Group",
		// SymbolInfo : "Symbol Info",
		// Gravity : "Gravity",
		// Chart_in_Chart : "Chart-in-Chart",
		// PeriodConverter : "Period Converter",
		// Magnifier : "Magnifier",
		// OrderHistory : "Order History",
		// FreehandDrawing : "Freehand Drawing",
		// BarChanger : "Bar Changer",
		// KeltnerChannel : "Keltner Channel",
		// DonchianChannel : "Donchian Channel",
		// CandleCountdown : "Candle Countdown",
		// LinearRegression : "Linear Regression",
		// StealthOrder : "Stealth order",
		// TickTrader : "Tick Trader",
		// CorrelationTrader : "Correlation Trader",
		// CorrelationMatrix : "Correlation Matrix",
		// MarketManager : "Market Manager",
		// SessionMap : "Session Map",
		// SentimentTrader : "Sentiment Trader",
		// Connect : "Connect",
		// ExcelRTD : "Excel RTD",
		// AlarmsManager : "Alarms Manager",
		// MiniTerminal : "Mini Terminal",
		// TradeTerminal : "Trade Terminal",
		// TraderToolboxApp : "Trader’s Tool Box Application",
		// WhatYouGet : "What you get",
		// DownloadMT5 : "Download For MT5",
		// DownloadMT4 : "Download For MT4",
		// tradeToolMsz2 : "Accentuate your trading platform with our extensive tools to capitalize on the dynamic market action in a convenient manner.",
		// tradeToolMsz1 : "Enrich your trading with fxview Trader’s Tool Box - a suite of robust indicators and applications that adds convenience to your trading journey.",
		// backVPSlist : "back to VPS list",
		// passWordMustContain12 : "Your password must contain at least 12 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)",
		// IPAddress : "IP Address",
		// ServerId : "Server Id ",
		// HostName : "Host Name",
		// noData : "no data",
		// Manage : "Manage",
		// Plan : "Plan",
		// Status : "Status",

		// // ========API Doc================
		// FxViewTradAPI : "FxView TRADING API",
		// Introduction : "Introduction",
		// getToken : "<span>GET</span> Token",
		// account : "Account",
		// accounts : "accounts",
		// getAcc : "<span>GET</span> accounts",
		// getChangepassword : "<span>GET</span> changepassword",
		// market : "Market",
		// getSymbols : "<span>GET</span> symbols",
		// getOpentrades : "<span>GET</span> opentrades",
		// gtOpenOrders : "<span>GET</span> openorders",
		// getTadehistory : "<span>GET</span> tradehistory",
		// getPlacemarket : "<span>GET</span> placemarket",
		// getPlacepending : "<span>GET</span> placepending",
		// getPlacestop : "<span>GET</span> placestop",
		// getPlacelimit : "<span>GET</span> placelimit",
		// getClosetrade : "<span>GET</span> closetrade",
		// getModifyorder : "<span>GET</span> modifyOrder",
		// getCancelorder : "<span>GET</span> cancelorder",
		// streaming : "Streaming",
		// getWs : "<span>GET</span> ws",
		// ExampleRequest : "Example Request",
		// GET : "GET",
		// changepass : "change password",
		// PARAMS : "PARAMS",
		// oldPass : "oldpassword",
		// old : "old",
		// new : "new",
		// newpass : "newpassword",
		// token : "token",
		// sessionToken : "session token",
		// AUTHORIZATION : "AUTHORIZATION",
		// DigestAuth : "Digest Auth",
		// ReadLess : "Read Less",
		// ReadMore : "Read More",
		// GetAllAccounts : "Get all accounts that you currently have.",
		// curlGET : "curl --location --request GET",
		// symbols : "symbols",
		// market:"Market",
		// symbolsMsz : "Used to get the available trading symbols at ActTrader along with other meta data",
		// responce : "responce",
		// ws : "ws",
		// subscribeMarketsCommand : "subscribe for markets command",
		// unsubscribeMarketsCommand : "unsubscribe from markets command",
		// tickerMessage : "ticker message",
		// orderbook : "orderbook message",
		// OrderMsgExp : "Order message example",
		// accountMsgformat : "account message format",
		// tradeMsgformat : "trade message format",
		// lifetime : "lifetime",
		// tokenLifeMint : "token life time in minutes",
		// authMsz : "Performing a simple GET request to this endpoint returns status code 401 unauthorized with www-authenticate header containing information to successfully authenticate subsequent requests. The www-authenticate header must be processed to extract realm and nonce values to hash subsequent requests.",
		// closetrade : "closetrade",
		// closetradeMsz : "Close open trade responce",
		// cancelorder : "cancelorder",
		// cancelorderMsz : "Delete order",
		// openorders : "openorders",
		// openordersMsz : "Get all open orders.",
		// modifyorder : "modifyorder",
		// modifyorderMsz : "Modify order.",
		// placelimit : "placelimit",
		// placelimitMsz : "Place limit order responce",
		// opentrades : "opentrades",
		// opentradesMsz : "Get all open trades.",
		// placepending : "placepending",
		// placependingMsz : "Place pending order responce",
		// placemarket : "placemarket",
		// placemarketMsz : "place market order responce",
		// tradehistory : "tradehistory",
		// tradehistoryMsz : "Trading history",
		// placestop : "placestop",
		// placestopMsz : "Place stop order responce",
		// trade : "trade",
		// openPositionNumber : "open position number",
		// orderAmount : "order amount",
		// closingAmount : "closing amount",
		// orderPrice : "order price",
		// orderNumber : "order number",
		// limitOrderPrice : "pre-defined limit order price",
		// stoptOrderPrice : "pre-defined stop order price",
		// accountIdentifier : "account identifier",
		// orderSide : "order side (0-sell, 1- buy)",
		// limit : "limit",
		// stop : "stop",
		// symbolName : "symbol name",
		// Auth : "Auth",

		// //============ WithDrawl ===================
		// PrincipalWithAmount : "Principal Withdrawal Amount",
		// creditCardNumber : "credit card number",
		// expiryDate : "expiry date",
		// allowOption : "Please select from the above allowed options",
		// WithdrawalMethodReq : "Withdrawal Method is required",
		// EnterWithdrawal : "Enter withdrawal",
		// requestWithdrawal : "You can request the withdrawal from newly approved payment options after 24 hours of approval",
		// News : "News",

		// //============ user ===================
		// EnterAuthCode : "Enter Authentication Code",
		// googleOtp : "Please enter the one time passcode shown in the <strong>Google Authenticator</strong> app.",
		// varify2step : "Two-step Verification",
		// AddBank : "Add Bank",
		// InvalidNumber : "Invalid Number",
		// viewDetail : "view detail",
		// wlcmMsz1 : "Identify automatically generated trade ideas based on chart patterns, breakouts, trend reversals, Fibonacci patterns and technical indicators.",
		// wlcmMsz2 : "Explore a wide range of actionable trade ideas recognised on the basis of multiple chart patterns and technical indicators across various assets class.",
		// wlcmMsz3 : "Stay a step ahead with real time financial news and updates on geo-political events to make informed trading decisions.",
		// wlcmMsz4 : "Stay up to date with real time Economic calendar that encompasses key global economic events and indicators on the horizon.",
		// wlcmMsz5 : "Get an unmatched trading experience via suitable VPS hosting program that allows you to trade uninterruptedly with reduced latency.",


		// //============common=========================
		// faMszOtp : 'or use can also write 2fa OTP over there' ,
		// freeMargin : 'Free Margin',
		// ClientAgreement : 'Client Agreement',
		// IdentificationProcedure : 'Identification Procedure',
		// OrderExecutionPolicy : 'Order Execution Policy',
		// ConflictofInterest : 'Conflict of Interest',
		// ClientCategorisation : 'Client Categorisation',
		// InvestorCompensation : 'Investor Compensation Fund (ICF)',
		// stepDisclamar_msz : 'Key Information Documents',
		// English : 'English',
		// balanceFromTradingId : 'Balance from Trading Account',
		// balanceToTradingId : 'Balance to Trading Account',
		// conversionAmount : 'conversion Amount',
		// removeBonusCongoMsz : 'Bonus has been removed successfully forTrading Id',
		// Prev : 'Prev',
		// Next : 'Next',
		// Espanish : 'Español',
		// created : 'Date',
		// tradingAcc :'Trading Account',
		// amount : 'Amount',
		// submit : 'Submit',  
		// footerMsz1 : 'This website is owned and operated by Charlgate Ltd, with a registered address at 319, 28th October Street, Kanika Business Center, Office 201B, 3105, Limassol, Cyprus',
		// footerMsz2 : 'Your capital is at risk. You may lose all the capital invested.',
		// yourMsz : 'Your Message',
		// googleAuth1 : 'Please enter the 6 digit One-Time Pin shown in the',
		// googleAuth2 : 'Google Authenticator',
		// googleAuth3 : 'app',
		// googleAuth4 : 'Having Trouble with your Two-Factor Authentication Code?',
		// googleAuth5 : 'Click Here to verify with Email',
		// googleAuth6 : "We've sent a link to your email",
		// googleAuth7 :"Haven't received an email in your inbox or spam folder? Resend",
		// googleAuth8 : "Two-factor authentication is not enabled on your account.",
		// googleAuth9 : "Two-factor authentication adds an extra layer of security, ensuring that it's really you who is trying to make changes in your fxview account. ",
		// googleAuth10 : "Click Here to enable Google authentication",
		// withdrawalAuthMessage : 'Kindly verify the withdrawal request by clicking on the link that we sent to your registered email ID',
		// validate :'Validate',
		// dear : 'Dear',
		// congo :"Congratulations",
		// goBackMangeAcc : "Go to Manage Account",
		// noTradingAccFound :"No Live Trading Account Found!",
		// reqVerify :'Request Verification',
		// backBonusList :'Back To Bonus List',
		// reqFailed :'Request Failed',
		// your :'your',
		// bonusList :'Bonus List',
		// bonus :'Bonus',
		// clickHere : 'Click Here',
		// accountId :'Account ID',
		// depositList :"Deposit List",
		// currency :'Currency',
		// tradingId :"Trading ID",
		// changeLeverage :'Change Leverage',
		// changePassword :'Change Password',
		// internalTransfer :'Internal Transfer',
		// selectTradingAccId :'Select Trading Account ID',
		// backManageAccount : 'Back To Manage Account',
		// createLiveAccount :"Live Account",
		// iDoLater :"I'll do it later",
		// saveContinue : 'Save & Continue',
		// thereIsNoRecord : "No records found",
		// pro100 :"100X <sup>For PRO</sup>",
		// pro200 : "200X <sup>For PRO</sup>",
		// pro300 :"300X <sup>For PRO</sup>",
		// pro400 :"400X <sup>For PRO</sup>",
		// pro500 :"500X <sup>For PRO</sup>",

		// //======================================bonus-folder-files================================================================
		// //bonus
		// allowMaxBonus :'Maximum bonus allowed',
		// bonusMsz1 :"Sorry you are not eligible. Fund your account to avail bonus.",
		// removebonusMsz1 :"Sorry you are not eligible to remove bonus.",
		// bonusGoogleAuth :"Kindly click on the link in order to proceed with your withdrawal",
		// bonusMsz2 :"Bonus has successfully been added for Trading ID:",
		// availBonus :"Use Bonus",
		// allowBonus :"Allowed Bonus",
		// removeBonus : "Remove Bonus",

		// //bonusVerify
		// bonusVerMsz1 :'Your bonus request has been processed successfully.',

		// //bonus-list
		// bonusType : 'Bonus Type',

		// //======================================deposit-folder-files===========================================================		
		// //add deposit
		// depFundAcc :'Deposit Funds to Account',
		// depFund :'Deposit Funds',
		// tradAccId :'Account ID',
		// demo :'Demo',
		// live : 'Live',
		// depAmount :'Specify the deposit amount',
		// selPayMethd : 'Select Deposit Method',
		// payFieldReq :'DepositMethod field is required',
		// depMsz1 :'Processing Time:',
		// depMsz2 :'1 to 5 working days',
		// depMsz3 :'Fee:',
		// depMsz4 : '0',
		// depMsz5 : 'Our Bank details are:',
		// bankName :'Bank Name:',
		// AccNumber :'Account Number:',
		// IFSCCode : 'IFSC Code:',
		// MicrCode : 'Micr Code:',
		// holderName : 'Holder Name:',
		// bankCode :'Bank Code:',
		// sortCode :'Sort Code:',
		// bankAdd :'Bank Address:',
		// depMsz6 :'In case you wish to transfer from a bank account other than mentioned in your profile, please ',

		// depMsz7 :' to add the new bank account details',
		// depMsz8 : "You don't have a bank verified yet. Kindly",
		// depMsz9 : "to add the new bank. In case you have already added your bank details, please wait for them to get verified.",
		// depMsz10 : 'Instant 24/7',
		// skrillId :'Skrill ID:',
		// depMsz11 :'Not the right Skrill account? Please',
		// depMsz12 : 'to change your Skrill ID',
		// netId :'Neteller ID:',
		// depMsz13 :'Not the right Neteller account? Please',
		// depMsz14 :'To change your Neteller ID',

		// feeUsd :'Fee (USD)',
		// depositAmount :'Deposit Amount',
		// paymentMethod : 'Deposit Method',

		// backToStep : 'Previous step',
		// procToPay : 'Proceed To Payment',
		// conPay : 'Confirm Deposit',
		// depMsz15 : 'Please ensure that the deposit details are correct. If you are happy with everything, click the ‘Fund Now’ button to proceed. Please note that if you make a withdrawal after depositing into your account, your funds will most likely be returned to the same method used to deposit.',

		// //-----------deposit-------------------------
		// warnMsz : "Only Euros can be received otherwise funds will be returned which can take up to 10 business days",
		// lessDetail:"Less Detail",
		// viewDetail:"View Detail",
		// IBAN:"IBAN",
		// accountNumber:"Account Number",
		// Swift:"Swift/BIC",
		// address:"Address",
		// accountCurr:"Account Currency",
		// reference:"Reference",
		// DontbankAcc:"you don't have any bank account , please",
		// Createbank:"to create new bank",
		// DntSkill:"you don't have any skrill id , please",
		// Tocreate:"to create.",
		// DntNetteler:"you don't have any netteller id , please",
		// //deposit list
		// paymentStatus :'DepositStatus',

		// //======================================manage-account-folder-files====================================================
		// //acount-verify
		// accountVerMsz1 :'request has been processed successfully',
		// backAccountList : 'Back to Account List',

		// //account-list
		// myAccounts : 'My Accounts',
		// demoAccount : 'Demo Accounts',
		// liveAccount : 'Live Accounts',
		// platform : 'Platform',
		// demoLive :'Demo/Live',
		// accountType : 'Account Type',
		// leverage : 'Leverage',
		// fundNow : 'Fund Now',
		// addFundTo : 'Add Funds to',
		// addingFundTo : 'Adding Funds to',
		// addFund : 'Add Funds',
		// enterAmount : 'Enter Amount',

		// //change-leverage
		// exsistLev :'Existing Leverage',
		// newLev : "New Leverage",
		// levMsz1 :"Please click on the link to change your leverage.",
		// levMsz2 : "Your trading account leverage has been changed successfully",
		// oldLev : "Old Leverage",
		// highleverage:"To apply for higher leverage you need to apply for a Professional account. To proceed, please",
		// Clickhere:"Click Here.",


		// //change-password
		// newPassword :'New Password',
		// conPassword : "Confirm Password",
		// passMsz1 :"Please click on the link to change your password",
		// passMsz2 : "Your trading account password has been changed successfully",
		// oldPassword : "Old Password",

		// newPassFieldReq :"The ‘New Password’ field is required",
		// conPassFieldReq : "The ‘Confirm Password’ field is required",
		// passCharVal :"Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)",
		// newConfFieldSame :"The entered passwords do not match. Please try again",

		// //change-internal-Transfer
		// intTransMsz1 : 'You currently have only one trading account. Please create at least one more trading account before attempting an internal transfer',
		// selFromTradId :"Send From Trading Account ID",
		// selToTradId : 'Send To Trading Account ID',
		// intTransMsz2 :"Please click on the link to confirm your internal transfer",
		// intTransMsz3 :"The transfer has been completed successfully",
		// fromTradId :"From Trading ID",
		// toTradId :"To Trading ID",
		// transferAmount :"Transferred Amount",

		// //========================register-steps-folder-files=========================================================
		// //do-later
		// doLaterMsz :"You can always come back and continue your registration by clicking on the verification button in the header. Meanwhile, you can go to the dashboard",
		// goToDash :"Go to dashboard",

		// //step1
		// personalInfo :'Personal Information',
		// fname :'First Name',
		// lname : 'Last Name',
		// stepMsz1 : "Sorry, we only accept customers aged between 18 and 68",
		// addressLine1 :'Residential Address line 1 ',
		// addressLine2 : 'Residential Address line 2',
		// resCountry :'Country of Residence',
		// selectCurrency : 'Select Currency',
		// city : 'City or Town',
		// postCode : 'Post Code',
		// nationality : "Country of Nationality",
		// taxResCountry : 'Country of Tax Residency',
		// tinNumber : 'TIN Number',
		// passportNumber : 'Passport Number',
		// pep : "Are you a Politically Exposed Person (PEP)?",
		// stepMsz2 :"A PEP is a natural person who has been entrusted with the following prominent public functions in any country, as well as his/ her immediate family members and persons known to be close associates of such a person: <ul> <li>Heads of State, heads of government, ministers and deputy or assistant ministers,</li>  <li> Members of parliaments or of similar legislative bodies,</li>  <li>Members of governing bodies of political parties,</li>  <li>Members of supreme courts, of constitutional courts or of other high-level judicial bodies whose decisions are not subject to further appeal, except in exceptional circumstances,</li>  <li>Members of courts of auditors or of the boards of central banks,</li> <li>Ambassadors, chargés d'affaires and high-ranking officers in the armed forces,</li>  <li>Members of administrative, management or supervisory bodies of governmental businesses or stated owned enterprises,</li> <li>Directors, deputy directors and members of the board of directors or persons holding an equivalent position in an international organization,</li> <li>Mayors</li> </ul>",
		// usPerson :'Are you a US person?',
		// stepMsz3 : "The definition of a U.S. person (“United States person”) includes: <ul>  <li> A U.S. citizen or resident (including dual citizenship),</li> <li> A U.S. alien (resident for tax purposes)</li>  <li> A person born in the U.S? </li>   <li> A person with a current U.S. mailing or residence address (including a U.S. post office box or U.S. in care of address) </li>    <li> A person with a current U.S. telephone number </li> <li> A person with standing instructions to transfer funds to an account maintained in the United Sates?</li>  <li> A person with current and effective power of attorney or signatory authority granted to a person with U.S. address?</li> </ul>",
		// dateOfBirth : 'Enter Date of Birth',

		// //step2
		// financialDetail : 'Financial Details',
		// empStatus :'Employment Status',
		// occupation: 'Occupation',
		// estYearlyIncome :"Estimated Yearly Income (EUR)",
		// estNetWorth : 'Estimated Net Worth (EUR)',
		// accountTurnover :'Anticipated Account Turnover (Annual Net Deposits - EUR)',


		// //step3
		// stepMsz4 :"Let's test your trading experience",
		// stepMsz5 : 'As a regulated entity, we are required to assess whether you have appropriate understanding to trade leveraged products. Please complete your Appropriateness test carefully, as your responses will be used to determine whether you can open a Live trading account with us.',
		// startTest : 'Start Test ',
		// expInMarket :"1. Trading Experience (Appropriateness Assessment)",
		// knowledgeInMarket : '2. Knowledge Scoring (Appropriateness Assessment)',
		// Of :'of',
		// percentComplete :"% Complete",
		// preQues :'Previous Question',
		// nextQues :"Next Question",
		// stepMsz6Title: "Appropriate test failed",
		// stepMsz6 :"<p>Based on the answers you provided and our assessment in relation to your experience with trading leveraged products, we believe that it may not be appropriate for you to trade on a Live account at this time. Therefore, we strongly recommend that you learn more about trading CFDs and the risks involved and try to set up a Live account again after 7 days. In the meantime, you can refer to free educational resources available online, and practice trading on an FxView Demo account.</p>",
		// stepMsz7 :"Based on the answers you provided and our assessment in relation to your experience with trading leveraged products, we believe that it is risky for you to open an account. However, although you marginally failed the appropriateness test, you may still proceed to open a Live account.",
		// proceed :"Proceed",


		// //step4
		// declaration : "Declaration",
		// stepMsz8 :'I confirm I understand the full nature and risks of trading Forex, CFDs and other derivatives using leverage.',
		// fieldReq : 'Field is required',
		// stepMsz9 :"I have carefully read, fully understood and accept the information in the following documents: ",
		// privacyPolicy : 'Privacy Policy',
		// and : 'and',
		// Typebelow:'Please type in the below field the sentence: "Product that is difficult to understand. CNMV considers that, in general, it is not appropriate for retail investors"',
		// riskDisclaimer :"Risk Disclaimer",
		// riskWarning:'Risk Warning: You are about to purchase a product that is not simple and may be difficult to understand: (the product must be identified). The National Securities Market Commission (CNMV) considers that, in general,',
		// stepMsz10 : 'I agree for my personal data to be processed and stored as per the Privacy Policy which I have carefully read, fully understood and accepted. ',
		// stepMsz11 :"I agree for Charlgate Ltd to contact me regarding my account, company services and products, and any other announcements, when needed and from time to time.",
		// SeeMor:"see more",
		// Acquisition:"its acquisition by retail clients is not appropriate due to their complexity. However, FxView has assessed your knowledge and experience and considers that it is appropriate for you. This is a leveraged product. You should be aware that the losses may be greater than the amount initially paid for its purchase.",
		// Seeles:"see less",
		// AfterCalling:"Note: After clicking on",
		// //step5
		// letVerifyYou :"Let's verify you!", 
		// verifyIdentity :"In order to get verified, you'll be required to upload a copy of your identify document, and a proof of address. Valid documents include, but are not limited to: ",
		// havingTrouble :"Having trouble?",
		// one :"1",
		// stepMsz12 : "Proof of Identity",
		// idenProofText : "<p>Passport</p> <p>Drivers License</p> <p>Other Government Issued Photo ID</p>",
		// two :"2",
		// holdDocFrontSide :"Proof of Residence (in your name & not more than 6 months old)",
		// resProofText: '<p>Bank Statement/Credit Card Statement</p><p>Utility Bill</p> <p>Payroll Statement</p> <p>Tax Document</p> ',
		// three :"3",
		// holdDocBackSide :"Upload instructions",
		// insText : '<p>You must use a device that has a camera to capture images of the documents. If your device has a webcam, then proceed to the  next steps, else choose “I don’t have a webcam” to continue the application from your mobile phone.</p><p>You will need to take an image of the front and the back of your ID, and a selfie.</p> <p>To ensure that your ID and selfie are clearly visible, choose an area or room that is bright and well-lit.</p>',
		// four :"4",
		// captureSelfie :"Capture your selfie following the instructions on screen",
		// five : "5",
		// personVerDone : "Your verification is complete",
		// dontHaveWebCame :"I Don't Have a Webcam",
		// letBegin : "Let's Begin",
		// acceptRisk :"Do you accept this risk?",
		// stepMsz13 :"A problem has occurred while validating your document automatically. We have raised a ticket to resolve this. Our support team will be in touch with you as soon as possible, and within 2 Business days.",
		// toViewTicket : "to view ticket",
		// stepMsz14 :"Thank you for verifying your identity, and welcome to FxView! You can now open a Live trading account and start trading.",
		// stepMsz15 :"While validating your proof of address document, we noticed that the address and ID number entered during registration does not match the document uploaded during verification.",
		// stepMsz16 : "While validating your proof of address document, we noticed that the address entered during registration does not match the document uploaded during verification.",
		// stepMsz17 :" While validating your proof of address document, we noticed that the ID number entered during registration does not match the document uploaded during verification.",
		// address : "Address",
		// address1 : "Address 1",
		// stepMsz18 : "I don't want to change anything",
		// stepMsz19 :"I don't want to change anything in the address",
		// idNumber :"ID Number",
		// idNumberDoc :"ID number from the document",
		// stepMsz20 :"I don't want to change anything",
		// stepMsz21 :"Resolve conflict",
		// makewithdrawal : "Make a Withdrawal",

		// //==============================shared-folder-files=====================================================
		// //filter-component
		// search :'Search',

		// //left-navbar
		// dashboard :"Dashboard",
		// manageAccount :"Manage Account",
		// accountList :"Account List",
		// deposit : "Deposits",
		// addDeposit : "Make a Deposit",
		// withdrawal : "Withdrawals",
		// withdrawalList : "Withdrawal List",
		// support :"Support",

		// //loader-component


		// //pagination
		// totalRecords : "Total Records",

		// //no-trading-account
		// noTradAccMsz1 : "You do not currently have a trading account. Please create a trading account first. ",

		// noTradAccMsz2 :"Thank you for submitting the requested information. However, based on the information & answers you have provided, trading in leveraged products is not appropriate for you at this time.",
		// noTradAccMsz3 :"We recommend you refer to free educational resources available online so that you can get more familiar with CFD trading, and try again in 15 days. Before deciding to go with a live account, we also advise you to test your understanding of our products and services by creating a demo account, and learning about trading with virtual money.",
		// createDemoAccount :"Demo Account",
		// noTradAccMsz4 :"Currently, you do not have a Live trading account. Please complete your account application to be able to access this function.",
		// noTradAccMsz41 :"Currently, you do not any trading account. Please create live or demo account to access this operation",
		// completeRegSteps :"Complete Registration Steps",
		// resumeApplication : 'Resume Application',
		// noDemoLiveTradingAccFound : "No Trading Account Found!",
		// //header
		// hello : "Hello",
		// headerMsz1 :"What would you like to do today?",
		// addNewTradAccount :"Add New Trading Account",
		// startTrading : "Start Trading",
		// verification :"Verification",
		// becomeAPro : "Become a Pro",
		// Notification :"Notification",
		// seeAll :"See All",
		// noNewNotification :"No New Notifications",
		// verified :"Verified",
		// notVerified :"Not Verified",
		// profile :"Profile",
		// downloadPlatform : "Download Platform",
		// security :"Security",
		// logout : "Logout",
		// reviewStatus:"Review Status",


		// //open-order
		// orderId :"Order ID",
		// symbol :"Symbol",
		// accountId :"Account ID",
		// quantity :"Quantity",
		// price : "Price",
		// type : "Type",
		// triggered : "Triggered",
		// side :"Side",
		// tradeId :"Trade ID",
		// login :"Login",
		// order :"Order",
		// openPrice :"Open Price",
		// closePrice :"Close Price",
		// profit : "Profit",
		// volume :"Volume",
		// openTime :"Open Time",
		// closeTime :"Close Time",
		// comment :"Comment",
		// commision : "Commission",
		// agentComm :"Agent Commission",
		// cmd :"Cmd",
		// sl :"SL",
		// tp :"TP",
		// swaps : "Swaps",
		// //=============================trading-accounts-folder-files=================================
		// //balance-margin-section
		// balance : 'Balance',
		// equity : 'Equity',
		// margin : 'Margin',
		// pnl : 'PNL',

		// //open-order-listing
		// openOrder : 'Open Orders',

		// //open-trades-listing
		// openTrades : 'Open Trades',

		// //platform-type
		// openTradingAccount : 'Open a Trading Account',

		// //trading-accounts
		// selectTradingAccount : 'Select Trading Account',

		// //create-account -demo and live file
		// createAccountMsz1 : 'Your account has been successfully created. Your credentials are:',
		// password : 'Password',
		// enterpassword : 'enter your password',
		// accountBaseCurrency : 'Account Base Currency',
		// goToAccountList : 'Go to Account List',
		// download : 'Download',
		// forWindows : 'Windows',
		// forIos : 'iOS',
		// forAndroid : 'Android',
		// MT4 : 'Meta Trader 4',
		// MT5 : 'Meta Trader 5',
		// live:'Live',
		// demo:'Demo',
		// actTrader : 'ActTrader<sup>TM</sup>',
		// USD : 'USD',
		// EUR : 'EUR',
		// GBP : 'GBP',
		// AUD : 'AUD',
		// X30 : '30X',
		// open : 'Open',
		// leverageField : 'Leverage is a required field',
		// accountPassword : 'Trading Account Password',
		// passwordFieldReq : 'password field is required',
		// createAccount : 'Create Account',
		// proMember : 'Want to Become a Pro Trader? Click Here',
		// passwordMust:'Your password must contain minimum 6 characters and maximum 24 characters and includes atleast 1 special character (!@#$%^*/) ',

		// //======================unauthorized-folder-files================================
		// //failed-test-file
		// tryAgain : 'Try Again In',
		// failedTestMsz1 : "<p>Thank you for submitting the requested information. However, based on the information & answers you have provided, trading in leveraged products is not appropriate for you at this time. </p><p>We will recommend you to refer to the free educational resources available online so you can get more familiar with CFD trading and try again in 7 days. Before deciding to go with a live account, we also advise you to test your understanding of our products and services by creating a demo account and learning by trading with virtual money.</p>",

		// //pending-verification-file
		// under : 'Under',
		// pendingVerificationMsz1 : 'Your application is under review by our compliance department. It may take 3-4 working days for your documents to be verified. You will receive an email once your documents are verified',

		// //unauthorized-folder-file

		// //=====================users-folder-files=======================================
		// //register-file
		// OTPPAGEHEAD:'Verify your contact details',
		// registerMsz3 : 'By continuing you agree to our ',
		// OTPPAGEAFTERREGS: 'Enter the OTP sent to your email & phone to verify your contact information.',
		// CompleteApplicationHead: 'Complete your application',
		// CompleteApplicationText: 'Complete the application form and verify your identity online by uploading your ID documents',
		// MakeyourFirstDepositHead: 'Deposit and trade',
		// MakeyourFirstDepositText: 'Once approved, fund your account and start trading Forex, Indices, Precious metals and commodity CFDs.',
		// UnlockallToolsHead: 'Unlock Trading Tools',
		// UnlockallToolsText: 'Access a wide range of trading tools such as Autochartist, Trader’s Tool Box, calculators and more',
		// SignuptoFxView: 'REGISTER NOW, IT’s FREE',
		// YourName: 'Your Name',
		// emailaddress:'Email Address',
		// register: 'Register',
		// registerMsz1 : 'Enter your email, phone and choose a password to get started',
		// registerMsz2 : 'One-Time Pin has been sent to your email. Please enter it below.',
		// enterOtp : 'Enter OTP',
		// resendOtp : 'Resend One Time Pin',
		// resendOtpTicket : "Haven't received an email in your inbox or spam folder? Resend",
		// captchaErr: 'Invalid Captcha',

		// //login-file
		// welcomeMsgHeadone:'Competitive Trading Conditions',
		// welcomeMsg1: 'Benefit from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.',
		// welcomeMsgHeadtwo:'Our Platforms',
		// welcomeMsg2: "Access the world's most popular markets on our fast and reliable platforms - MT4, MT5 & ActTrader",
		// welcomeMsgHeadthree:'Trading Tools',
		// welcomeMsg3: 'Access a wide range of trading tools such as Autochartist, Trader’s Tool Box, API trading and more',
		// signin: 'Log in to FxView',
		// forgotPassword : 'Forgot Password',
		// donthaveaccount:'Don’t have an account?',
		// haveAnAccount : '',
		// charlgateMsg : 'Charlgate Ltd owns fxview.com.  Charlgate Ltd is a company authorised and regulated by the Cyprus Securities and Exchange Commission – CySEC (CySEC Licence number 367/18 & company registration number : 372060 ) and a Member of the Investor Compensation Fund (ICF).',
		// riskWarningMsg : 'CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading in CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		// signuphere:'Sign up here',
		// logIn : 'Sign In',

		// //dashboard-file
		// performance : 'Performance',
		// trading : 'Trading',
		// drawdown : 'Drawdown',
		// saveChanges:'Save Changes',
		// Platform:'Platform',
		// Leverage:'Leverage',
		// Overview:'Overview',
		// AddFunds:'Add Funds',
		// DontAny:"Your account is not yet verified.Please complete your application and verification before opening a",
		// TradACC:"trading account , please create first",
		// DemoAcc:"Demo Account",
		// LiveACC:"Live Account",
		// WaitVerif:" or practice trading on a demo.",
		// DontAny2:"Your account application is incomplete. Please complete your application and verify your account in order to open a ",
		// WaitVerif2:" practice trading on a ",
		
		// //welcome-file
		// fewStepAway : 'You are just few steps away',
		// activateFxviewAccountNow : 'Activate Your Fxview Account Now!',
		// setupFxViewAcc : 'Setup your fxview account',
		// modify : 'Modify', 
		// welcomeFxView : 'Welcome to fxview!',
		// welFxviewCon : 'You are almost ready to begin trading. Please complete your trading account application and upload the necessary identification documents.',
		// completeReg : 'Complete Registration',
		// tryDemoAcc : 'Try a Demo Account',
		// tryDemoAccCon : 'Try our trading platforms - MT4, MT5 and ActTrader - and develop your CFD trading skills. Practice trading with virtual funds',
		// winIosAndroid : 'Windows/IOS/Android',
		// rangeTradTools : 'Range of Trading Tools',
		// traderToolBox : 'Trader’s Tool Box',
		// traderToolBoxCont : 'Get access to a mix of advanced trading tools & an indicator package to help you with your analysis and make better trading decisions.',
		// calculators :'Calculators',
		// calculatorsCon : 'Monitor the trades that you plan to make. Our calculators help you calculate values based on market conditions and provide instant results.',
		// signalCenter : 'Signal Centre',
		// signalCenterCon :'Automate your trades through signal trading or copy trading. Review & Select any signal provider from the list & follow them to copy trades.',
		// autoChart : 'Autochartist',
		// autoChartCont : 'Autochartist is a premier chart pattern recognition software that scans the markets and automatically recognises trade set-ups.',
		// promotion : 'Promotions',
		// promotionCont : 'Apply for a free VPS or a bonus directly from your client area, and enhance your trading potential.',
		// investInPamm : 'Invest in a PAMM account',
		// investInPammCont : 'Review the list of various PAMM account holders with us. Choose & connect with any of them in order to connect your trading account.',
		// requestAccess : 'Request Access',

		// //2Fa-file
		// faText : 'Two-Factor Authentication',
		// alreadyEnabled :'Enabled',
		// setUp2FA : 'Set up 2FA',
		// clickToDisable : 'Click To Disable',
		// clickToEnable : 'Click To Enable',
		// enable2FaText : 'Enable Two-Factor Authentication',
		// accounntSafe3Steps : 'Make Your Account safer in 3 easy steps:',
		// downloaduthApp : 'Download an Authenticator App',
		// downloaduthAppText : 'Download and install Authy or Google Authenticator to your phone or tablet.',
		// scanQrCode : 'Scan The QR Code',
		// scanQrCodeText : "Open the authentication app and scan the image to the left, using your phone's camera.",
		// loginYourCode : "Log in with your Code",
		// enter6DigitCode : "Enter the 6-digit verification code generated.",
		// activate : "Activate",
		// enterOtpDisableQrCode : "Please Enter OTP to Disable QR Code",
		// disableCodeText : "Disable With your Code",
		// disable : "Disable",

		// //download-platform-file
		// window : 'Window',
		// launch : 'Launch',

		// //forgot-password
		// forgotPasswordText : 'Please enter your registered email address with fxview so we can help you create a new password.',
		// resetPassword : 'Reset Password',
		// backLogin : 'Back to log in page',

		// //pro
		// proTrader : 'Become a Professional Trader',
		// proTraderText : 'In order to be categorized as a professional trader, you must meet two of the three conditions mentioned below. Please select at least two out of the three criteria for which you can provide documents in the next step.',
		// finTransa : 'Financial Transactions',
		// finTransaText : 'Did you carry out transactions in significant size on a relevant financial market at an average of at least ten (10) transactions per quarter over the previous four (4) quarters?',
		// finPort : 'Financial Portfolio',
		// finPortText : 'Does the size of your financial portfolio (deposits and financial instruments) exceed EUR 500,000?',
		// proExp : 'Professional Experience',
		// proExpText : 'Do you, or have you worked in a professional position in the financial sector requiring knowledge of trading leveraged products for at least 1 year?',
		// Continue : 'Continue',
		// warning : 'Agreement',
		// clickPro : 'Click Here to Become a pro',
		// orderApply: ' In order to apply for professional account we have given just limited knowledge about the documents required, we can give detailed information here',
		// tradingActivity:'1. The documents which prove your trading activity*',
		// providetrades:'Please provide us with any of the following showing that you placed on average more than 10 trades per quarter over the last year:',
		// Screenshot:"Screenshot from the broker's web/application where your name or email address is shown.",
		// AccountStat:'Account statement',
		// thirtParty:'Any other third-party document to verify your trading activity over the past 12 months.',
		// professionalExper:'2. The documents which prove your Professional experience in the financial sector for a period of at least one (1) year in a professional position, which requires knowledge of the transactions or service(s) envisaged.',
		// evidenceProf:'Please provide us with the evidence of the professional experience you have. Such evidence can be any of the following:',
		// linkedIn:' Link to a website which clearly shows your position & the company name (e.g LinkedIn)',
		// businessCard:'A copy of your Business Card',
		// CV:'A CV',
		// payslip:'A recent Pay Slip',
		// officialDoc:'Official document from the employer',
		// eurnetWorth:'3. The documents which prove your Net Worth exceeds EUR 500,000',
		// evidenceliquid:'Please provide us with the evidence that your liquid Net Worth exceeds EUR 500,000.',
		// touchevidence:'We will be in touch if we require any additional supporting evidence from you.',
		// proMsz1 : 'To: Charlgate Ltd',
		// proMsz2 : 'Date',
		// proMsz3 : 'Client Name',
		// proMsz4 : "<p>I/We the undersigned Client, categorized by Charlgate Ltd as a:  <span class='editor'>Professional Client</span> </p>  <p>According to the “Client Categorisation Policy” of Charlgate Ltd available on <a href='#' class='underline'>www.fxview.com</a> and the Provision of Investment Services, the Exercise of Investment Activities, the Operation of Regulated Markets and Other Related Matters Law of 2017 (L. 87(I)/2017), “the Law”, hereby request to be treated by Charlgate Ltd as a:</p> <p><span class='editor'>Professional Client</span></p> <p>In relation to the investment services of reception and transmission and execution of orders in Contracts for Differences). </p> <p>In case I/we am/are a Retail Client who wishes to be treated as a Professional Client (i.e. Elective Professional Client), I/we will undertake the Fitness Test below for the Company’s internal assessment and provide the Company with supporting documentation/evidence to support my/our application.</p> <p>I/We fully understand the level of protection afforded by the Provision of Investment Services, the Exercise of Investment Activities, the Operation of Regulated Markets and Other Related Matters Law of 2017 L. 87(I)/2017, (“the Law”) for the new category I/we am/are requesting. </p>  <p>I/We have read and understood and agree with the “Client Categorisation Policy” made available by the Company on its website and fully acknowledge that Professional Clients enjoy a lower level of protection than Retail Clients.</p>   <p>You agree and accept that in order to process your application, the Company may, at its absolute discretion, contact you and request additional documentation/evidence to support your application. </p> <p>Please note that you are responsible for keeping the Company informed about any changes that could affect your current categorization. It will be at the Company’s absolute discretion to accept or reject this application, even if the criteria above are fully fulfilled.</p> ",
		// uploadDoc : "Upload Documents",
		// uploadDocText : "Please upload documents to support your selections from the previous step",
		// proMsz5 : "A Copy of your Trading account statement for the past 4 quarters",
		// chooseFile : "Choose a file…",
		// proMsz6 : "A copy of your Investment Portfolio Statement",
		// proMsz7 : "A letter from your employer confirming your position in the company and the duration of your employment, along with a CV showing you have worked in the financial sector",
		// yes : "yes",
		// no : "no",
		// proMsz8 : "TThe size of the Client’s financial portfolio, defined as including cash deposits and financial instruments, exceeds EUR 500,000",
		// proMsz9 : "Works or has worked in a professional position in the financial sector requiring knowledge of trading leveraged products for at least 1 year.",
		// proMsz10 : "Dear Valued Client,",
		// proMsz11 : "Subject: Request for",
		// proMszHereClient : 'an opt-up from Retail Client to Elective Professional Client (hereinafter the ‟Client”)',
		// proMsz13 : "<p>Charlgate Ltd (hereinafter the ‟Company”) hereby acknowledges the receipt of your request for opting-up from being categorized as a Retail to a Professional Client.</p><p> Please note that in accordance with the Investment Services and Activities and Regulated Markets Law of 2017 (Law 87(I)-2017) and MiFID II Directive (2014-65-EC), the Company may treat its clients as Professional Clients if following the Company’s assessment of the clients’ expertise, experience, and knowledge, the Company is reasonably assured that the client is capable of making his/her own investment decisions and understanding the risks involved relating to the nature of the transactions or services offered.</p> <p>When making the assessment, the Company may rely on the information it already possesses about the Client, and/or request additional information from the Client, and/or call the Client to discuss his/her investment experience. In order to meet the requirements, the Client must satisfy at least two of the following three criteria:  </p> <p>-Have carried out transactions in significant size on the relevant market at an average frequency of 10 per quarter over at least the previous 4 quarters.</p>",
		// firstQuesMsz: "Have carried out transactions in significant size on the relevant market at an average frequency of 10 per quarter over at least the previous 4 quarters.",
		// proMsz14 : "<p>Further to the above, please note that in case you receive the Company’s express approval, you will be categorized as an elective Professional Client, and as such will waive your right to a greater degree of protection. </p> <p>Any such waiver of the protection afforded by the standard conduct of business regime shall be considered valid only if an adequate assessment of your expertise, experience and knowledge undertaken by the Company gives reasonable assurance, in light of the nature of the transactions or services envisaged, that you are capable of making your own investment decisions and understanding the risks involved. </p><p>The Company may only accept your re-categorization request if it is reasonably convinced that you are able to make your own specific investment decisions and comprehend the risks involved, taking into account the nature of the said planned transactions or services.</p> <p>If the Company ascertains that you no longer fulfil the conditions under which you have been categorized as a Professional Client, it has the right to take all necessary measures, including to re-classify you as a Retail Client and notify you accordingly.</p> <p>Further to the above, we hereby wish to provide you with a clear warning, in Appendix A below, of the protections and investor compensation rights you may lose. </p><p>Upon execution of Appendix B of this letter, you expressly consent that you are fully aware of the consequences of losing such protections and investor compensation rights.</p> <p>We remain at your disposal for any clarifications and/or further information you may require in relation to the above.</p><p>Yours Sincerely,</p> ", 

		// proMsz15 : "Name",
		// proMsz16 : "Identification Number",
		// proMsz17 : "I Agree to FxView Terms of Service",
		// proMszIAgree : "I Agree to FxView’s",
		// proMsz18 : "Your ticket to become a Pro has been created",
		// proMsz19 : "Go to Tickets",

		// //profile
		// basicDetail : 'Basic Info',
		// addressDetail : 'Address Info',
		// bankDetails : 'Bank Details',
		// documents : 'Documents',
		// notEligible : 'Not Eligible',
		// completeRegSteps : 'Complete Your RegistrationSteps',
		// phone : 'Phone',
		// gender : 'Gender',
		// onlinePayId : 'Online Payment ID',
		// noBankDetail : 'No Bank Details',

		// noDocuments : 'No Documents',
		// paymentDetail: 'Payment Details',
		// Pending:'Pending',
		// Disable:'Disable',
		// AddCard:'Add Credit card',
		// CreditCard:'Credit Card Number:',
		// ExpiryDate:'Expiry Date:',

		// //request-verify-file
		// requestVerifyWith : 'Your withdrawal request has been processed successfully',
		// backWithList : 'Back To Withdrawals List',

		// //reset-password-from-hash-file
		// passwordHashMsz1 : 'After you update your password, you will be logged out and asked to log in again.',
		// otherWayHelp : 'Other ways to get help',
		// chatWithUs : 'Chat with us',
		// callUs : 'Call us',
		// passwordHashMsz2 : 'Password has been changed successfully. Click',
		// here : 'Here',
		// or : 'or',
		// toLogin : 'to log in',

		// //===========================withdrawal-folder===============================================
		// //withdrawal
		// avalBalance : 'Available Balance',
		// withdrawalMsz1 : "Sorry, you're not eligible for a withdrawal yet. Depositing and trading can help you become eligible!",
		// withdrawalMsz2 :'We have received your withdrawal request, and will update you accordingly',

		// withCont1 : 'FxView does not charge withdrawal fees. However, please note that payment processors/financial intermediaries may charge a transaction fee.',
		// withCont2 : 'Due to third party transaction restrictions, funds can only be returned to a bank account in the same name as your FxView trading account. Furthermore, funds will only be returned to the same bank account from which they were received.',
		// withCont3 : 'The total amount you can withdraw into your card cannot exceed the total amount deposited with the card. Amounts exceeding this level can be withdrawn into your bank account, Neteller or Skrill',

		// //withdrawal list
		// all : 'All',
		// pending : 'Pending',
		// processed : 'Processed',
		// rejected : "Rejected",
		// withdrawalType : 'Withdrawal Type',
		// withdrawalStatus : 'Status',
		// detail : 'Detail',
		// viewTicket : 'View Ticket',


		// //=========================support-folder===================================================
		// //request-services
		// helpSupport : 'How can we help?',
		// lodgeComplaint : 'Submit a complaint',
		// updateAddress : 'Update your address',
		// addNewBankAcc : 'Add a new bank account',
		// updateMobileNumber : 'Update your mobile number',
		// lodgeEmailRequest : 'Request to change email address',
		// askOtherQuestions : 'Ask us any other question',

		// helpUsWithYour : 'Help us with your',

		// //index
		// requestServices :'Support Request',
		// openRequest : 'Open Request',
		// closeRequest : 'Close Request',

		// //support
		// ticketNumber : 'Ticket Number',
		// reason : 'Reason',
		// action : 'Action',
		// Queries : 'Related Queries',

		// //view
		// backToTicket : 'Support Home',
		// send : 'Send',

		// //OTP Verification-file
		// otpVerification : 'OTP Verification',
		// otpVerificationText : 'Please enter the One Time Pin to complete verification',
		// otpVerificationText1 : 'A One Time Pin has been sent to your email.',
		// verifyCode : 'Verfication Code',

		// //profile-request-file
		// getHelpWith : 'Get Help With',
		// relatedTopics : 'Related Topics',
		// notSatisfied : "I'm not satisfied",
		// inn : 'in',
		// close : 'close',
		// emailHeading : 'Please Enter your new email ID below',
		// exsistsEmailAddress : 'Existing Email Address',
		// newEmail : 'Enter Your New Email Address',
		// changeEmailAddress : 'Change Email Address',
		// mobileHeading : 'Please Enter Your New Mobile Number Below',
		// existingMobileNumber : 'Existing Mobile Number',
		// newMobile : 'Enter Your New Mobile Number',
		// changeMobileNumber : 'Change Mobile Number',
		// uploadSupportingDocument :'Upload a Supporting Document',
		// addNewBank : 'Add a New Bank Account',
		// changeAddress : 'Change Address',
		// Subject : 'Subject',
		// ticketHasbeenCreated : 'Your ticket has been created',
		// ticketHasbeenComplaint : 'Your complaint has been Registered successfully',
		// ChangeClientPortalPassword: "<p><span>Please follow these steps to change your client area password:</span></p><ul><li><p><span>Click on the square with your initials on the top right corner of the client portal area</span></p></li><li><p ><span>Click on &lsquo;Change Password&rsquo; or directly click&nbsp;</span><a href='https://app.fxview.com/change-password' target='_blank'><span>HERE</span></a></p</li><li><p ><span>Enter your old password</span></p></li><li><p ><span>Enter the new password you would like to use</span></p></li><li><p ><span>Click on &lsquo;Change Password&rsquo;</span></p></li></ul><p><span>Your password is now changed</span></p>",
		// Enable2FA: "<p><span>Please follow these steps to enable 2FA on your client area:</span></p><ul ><li><p><span>To enable 2FA click&nbsp;</span><a href='https://app.fxview.com/two-fa' target='_self'><span>HERE</span></a></p></li><li><p><span>Click on enable and you will see a QR Code on your screen</span></p></li><li><p><span>Download the google authenticator app on your mobile and scan the code through the app</span></p></li><li><p><span>Once the code is scanned, you will see a numeric code on your google authenticator app</span></p></li><li><p><span>Enter that google authentication code where it says &ldquo;Google Authenticator Code&rdquo; and click on &ldquo;Enable&rdquo;</span></p></li></ul><p><span>2FA is now enabled</span></p>",
		// Disable2FA: "<p><span>Please follow these steps to disable 2FA on your client area:</span></p><ul ><li><p><span>To disable 2FA click&nbsp;</span><a href='https://app.fxview.com/two-fa' target='_self'><span>HERE</span></a></p></li><li><p><span>Enter that google authentication code for fxview</span></p></li><li><p><span>Click on disable</span></p></li></ul><p><span>2FA is now disabled.</span></p>",

		// ProfessionalAccountRequest:"<p><span>To know about the Professional Client categorisation policy, please click&nbsp;</span><a href='https://fxview.com/static/fxview/pdf/legal-document/Client-Categorisation-Procedure.pdf' target='_self'><span>HERE</span></a><span>. To apply for a professional client, please click&nbsp;</span><a href='https://app.fxview.com/pro' target='_self'><span>HERE</span></a></p>",
		// ClientAreaPasswordReset : "<p><span>In order to reset the password of your client area, please click on &ldquo;Forgot Password&rdquo; at the time of login. Once you click on it, enter your registered email address and you will receive a link to reset the password. You&rsquo;ll then be asked to enter your new password twice, and click &lsquo;Reset Password&rsquo; to complete the process.</span></p>",
		// AccountVerificationIndividual:"<p><span>we do need to do KYC and require the following documents for complete account verification:</span></p><p><span>* A proof of your residence which can be a utility bill or a bank statement in your own name and address dated within the last 6 months</span></p><p><span>* A proof of your identity, which can be your government issued photo id, passport, or a driving licence. You will need this document at hand during the In-Person-Verification (IPV) process.&nbsp;</span></p><p><span>*IPV is in person verification where a client needs to show and take an image of the front and back of his valid ID card and take his selfie. Once the pictures are taken, they will be automatically uploaded in your profile and are necessary for the account verification. IPV can be done in the secured client area&nbsp;</span><a href='https://app.fxview.com/'><span>HERE</span></a></p>",
		// IBAccountVerification: "We require the following documents for complete account verification:<br>* A copy of your government issued photo id proof which can be a valid passport, national ID card or driving licence <br>* A proof of your residency which can be a utility bill or bank statement in your own name and address dated within the last 6 months <br> You can upload your documents HERE",

		// MarginCallInquiry:"<p><span>Our margin call/stop out levels are 70%/50% which means if your account equity falls below 70%, you will receive a margin call notification on your trading platform and if your equity falls below 50% of the used margin, system will start closing out your positions automatically one by one and the position incurring maximum loss will be closed out first.&nbsp;</span></p><p><span>Getting a margin call depends on the margin utilized by the open positions in your account and it is client&rsquo;s responsibility to monitor the open positions at all times and ensure there are sufficient funds in the account to support open positions in the account.</span></p>",
		// InvestorPasswordRequest : "<p><span>Please follow these steps in order to set an investor password for your trading account</span><span>.</span></p><ul ><li><p><span>Login to your MT4/MT5 account</span></p></li><li><p><span>Click on Tools &gt; Options &gt; Server &gt; Change</span></p></li><li><p><span>Enter your master password</span></p></li><li><p><span>Select - change investor (read only) password</span></p></li><li><p><span>Enter your new password and enter the same in confirm&nbsp;</span></p></li><li><p><span>Click on ok</span></p></li></ul>",
		// UnabletoDownloadPlatform:"<p><span>Please follow these steps to download platform:</span></p><p><span>Click on the profile icon &gt; Download Platform</span></p>",
		// Changeleverage: "<p><span>Increasing your leverage is subject to your client classification. Retail Clients can trade on a maximum of 30x leverage. Professional Clients can trade on leverage of up to 500x. You can read more about client classification&nbsp;</span><a href='https://fxview.com/static/fxview/pdf/legal-document/Client-Categorisation-Procedure.pdf' target='_self'><span>HERE</span></a><span>.&nbsp;</span></p><p><span>Please follow these steps to change the leverage:</span></p><ul ><li><p><span>Click on manage account</span></p></li><li><p><span>Click on change leverage</span></p></li><li><p><span>Select your trading account</span></p></li><li><p><span>Choose the leverage you want</span></p></li><li><p><span>Click on submit</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request&nbsp;</span></p></li></ul><p><span>Your leverage will then be updated.</span></p>",
		// TradeOrderInquiry : "<p><span>If you want any trade to be investigated, please provide the following information:</span></p><ul ><li><p><span>Trading Account ID</span></p></li><li><p><span>Trade order ID</span></p></li><li><p><span>Time when you faced the issue</span></p></li><li><p><span>Exact issue you faced&nbsp;</span></p></li><li><p><span>Relevant screenshots</span></p></li></ul>",
		// TradingAccountStatement: "<p><span>Yes, you can generate your own account statements. Please follow the below steps in order to generate your trading account statement.</span></p><p><span>For MT4:&nbsp;</span></p><ul ><li><p><span>Log in to your MT4 platform</span></p></li><li><p><span>Click on the &quot;Account History&quot; tab at the bottom of the terminal</span></p></li><li><p><span>Right click within the Terminal table displayed, and then click on &quot;All History&quot;</span></p></li><li><p><span>All your trading history has now been pulled into the Terminal window. Next, right click on the table displayed and click on &quot;Save as Detailed Report&quot;</span></p></li><li><p><span>Choose the destination where you would like to save the report</span></p></li><li><p><span>Click on &ldquo;Save&rdquo;</span></p></li></ul><p><span>The report will be downloaded in HTML format.</span></p><p><span>For MT5:</span></p><ul ><li><p><span>Log in to your MT5 platform</span></p></li><li><p><span>Click on the &quot;History&quot; tab at the bottom of the terminal</span></p></li><li><p><span>Right click within the Terminal table displayed, and then click on &quot;All History&quot;</span></p></li><li><p><span>All your trading history has now been pulled into the Terminal window. Next, right click on the table displayed &gt; Report &gt; and choose to download the report as XML or HTML.</span></p></li><li><p><span>Choose the destination where you would like to save the report</span></p></li><li><p><span>Click on &ldquo;Save&rdquo;</span></p></li></ul><p><span>The report will be downloaded in the XML/HTML format.</span></p><p><span>For Act Trader:&nbsp;</span></p><ul ><li><p><span>Log in to your ActTrader platform</span></p></li><li><p><span>Click on Reports</span></p></li><li><p><span>Click on Account Statement</span></p></li><li><p><span>Choose time format (for which you want to generate the report)</span></p></li><li><p><span>Click on &ldquo; run report&rdquo;</span></p></li><li><p><span>Click on export to excel to export the report</span></p></li></ul><p><span>Your report will be downloaded</span></p>",
		// Unabletologintoplatform : "<p><span>Please review the following errors along with their solutions:</span></p><p><span>Invalid Account Error-</span></p><p><span>Please review your trading account ID and password. This error comes when either the trading account id or the password that you are entering is wrong</span></p><p><span>No Connection Error-</span></p><ul ><li><p><span>Review the server name you are entering while logging in to the trading account. Please make sure you have entered fxview-live for live account and fxview-Demo for the demo account</span></p></li><li><p><span>In case the error persists, please follow these steps:</span></p></li><li><p><span>Go to &nbsp;&ldquo;File&rdquo; option on the menu bar and select &ldquo;Open an account&rdquo;</span></p></li><li><p><span>Type &ldquo;fxview&rdquo; in the &ldquo;add new broker box&rdquo; and click on &ldquo;Find your broker&rdquo;</span></p></li><li><p><span>Select &ldquo;fxview&rdquo; and click on &ldquo;Next&rdquo;</span></p></li><li><p><span>Click on &ldquo;Connect with an existing trading account&rdquo; and enter your login credentials</span></p></li><li><p><span>To log in to a Live account select server name &ldquo;fxview-Live&rdquo; or &ldquo;fxview-Demo for Demo account from the drop-down menu and click on &ldquo;Finish&rdquo;.</span></p></li></ul><p><span>Authorisation Failed Error-&nbsp;</span></p><p><span>This error comes up when you are trying to login to the trading account on the phone. In this case, Please review your trading account ID and password. This error comes when either the trading account id or the password that you are entering is wrong</span></p>",
		// InternalTransfer: "<p><span>Please follow these steps to transfer funds between your trading accounts:</span></p><ul ><li><p><span>Scroll all the way to the left with your mouse, to expand the left-hand menu bar</span></p></li><li><p><span>Click on &lsquo;Manage Account&rsquo;</span></p></li><li><p><span>Click on &lsquo;Internal Transfer&rsquo;</span></p></li><li><p><span>Select the accounts you would like to send funds from and to&nbsp;</span></p></li><li><p><span>Enter the amount you want to transfer</span></p></li><li><p><span>Click on &lsquo;Internal Transfer&rsquo;</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request</span></p></li></ul><p><span>Your internal transfer is done.</span></p>",


		// Changetradingaccountpassword: "<p><span>You can change the password of your trading account from your platform, In case you face any issues while changing the password from your platform, please follow these steps to change the password from your client area.</span></p><ul ><li><p><span>Scroll all the way to the left with your mouse, to expand the left-hand menu bar</span></p></li><li><p><span>Click on &lsquo;Manage Account&rsquo;</span></p></li><li><p><span>Click on &lsquo;Change Password&rsquo;</span></p></li><li><p><span>Select your trading account</span></p></li><li><p><span>Enter the new password and confirm it</span></p></li><li><p><span>Click on &lsquo;Change Password&rsquo;</span></p></li><li><p><span>You will receive a confirmation link on your registered email address</span></p></li><li><p><span>Click on the link to confirm your request</span></p></li></ul><p><span>Your trading account password is now changed.</span></p>",
		// Slippage: "<p><span>What is slippage?</span></p><p><span>Slippage is when the price at which the trade is executed is different from the expected price.&nbsp;</span></p><p><span>It is very common in forex trading, especially when trading in higher lot sizes.&nbsp;</span></p><p><span>As we are an ECN broker, we pass all your trades directly to our LPs. Depending on the size of the trade, sometimes they might not have enough liquidity to fill the entire trade at the shown price, so a part will be filled at the next best available price(s), which is essentially &lsquo;slippage&rsquo;. You can look up our DOB (Depth of Book) in a live account, by right clicking on an instrument within the &lsquo;Market Watch&rsquo; window and clicking on &nbsp;&lsquo;Depth of Market&rsquo;. This will show you the volumes available at each price. Market orders are executed at VWAP (Volume Weighted Average Price).</span></p><p><span>How much is your slippage?</span></p><p><span>Slippage is something which cannot be controlled by a broker - it&#39;s an inherent part of trading, and common in the forex market. While placing an order in the market, you are requesting your order to be filled at the market price you are seeing on the terminal at that exact moment. However, the market moves between the time your order is placed and the time it is filled. Therefore, it&#39;s possible that it will be filled at a different price from the one you saw when you clicked to trade, and this difference is called &lsquo;slippage&rsquo;.&nbsp;</span></p><p><span>Whether you will experience slippage while trading depends on market volatility and liquidity at the time you are trading. Generally, it increases during volatile times such as news releases (as many orders are going into the market within a short space of time and being matched against one another, causing the market price to fluctuate rapidly) or illiquid market conditions such as market opening or closing time (as there are &nbsp;few orders available in the market, and a large trade might need to be filled at several different prices, causing the market to move).&nbsp;</span></p><p><span>Please note that the higher your position size, the higher the chances that you will experience slippage. Market orders are executed at VWAP (Volume Weighted Average Price)</span></p>",	
},
	
	'it': {},
	'ge':{},
	'es': {},
	'fr':{},
	'gr':{}
};

const i18n = new VueI18n({
locale: 'en', // set locale
fallbackLocale: 'es', // set fallback locale
messages, // set locale messages
});

export default i18n;


// WEBPACK FOOTER //
// ./src/plugins/lang/i18n.js